<template>
  <div>
    <div class="vx-row">
      <!-- MULTIPLE COLUMNS-->
      <div class="vx-col w-full mb-base">
        <vx-card title="">
          <div class="demo-alignment">
            <div class="vx-row" style="width: 100%; height: 50px; align-items: center">
              <div class="vx-col lg:w-2/12" style="">
                <vs-input
                  class="inputx"
                  placeholder="Arama..."
                  @keyup.enter="stokListesi()"
                  :ref="barkod"
                  v-model="barkod"
                />
              </div>
              <div class="vx-col lg:w-3/12" style="">
                <div
                  class="vx-row"
                  style="width: 100%; height: 50px; align-items: center"
                >
                  <div class="vx-col lg:w-6/12" style="text-align: end">
                    <label>Açılan Stoklar</label>
                  </div>
                  <div class="vx-col lg:w-6/12" style="">
                    <vs-switch style="border-radius: 20px" v-model="Durum" />
                  </div>
                </div>
              </div>
              <div class="vx-col lg:w-2/12" style="">
                <vs-button
                  @click="stokListesi()"
                  style="height: 40px; border-radius: 3px"
                  color="purple"
                  type="filled"
                  >Listele</vs-button
                >
              </div>
              <div class="vx-col lg:w-2/12" style="">
                <TopluIslemComponent :secilenStok="secilenStok" />
              </div>
              <div class="vx-col lg:w-2/12" style="">
                <ExcelYazdirButon :excelData="liste" />
              </div>
            </div>
          </div>
        </vx-card>
        <br />
      </div>
      <div class="vx-col w-full mb-base">
        <vue-good-table
          @on-selected-rows-change="selectionChanged"
          :row-style-class="rowStyleClassFn"
          v-model="checkSelected"
          :columns="columns"
          :rows="liste"
          :rtl="dir"
          :select-options="{
            enabled: true,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
            selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }"
          :pagination-options="{
            enabled: true,
            perPage: pageLength,
          }"
        >
          <template slot="table-row" slot-scope="props">
            <!-- Column: Name -->

            <div v-if="props.column.field === 'stokKodu'" class="text-nowrap">
              <b-avatar
                :src="props.row.resimLink"
                class="mx-1"
                button
                @click="onClick(props.row.resimLink)"
              />
              <span class="text-nowrap">{{ props.row.stokKodu }}</span>
            </div>

            <!-- Column: Status -->
            <span v-else-if="props.column.field === 'status'">
              <b-badge :variant="statusVariant(props.row.status)">
                {{ props.row.status }}
              </b-badge>
            </span>
            <div style="width: 140px" v-else-if="props.column.field === 'Pazaryeri'">
              <b-badge
                style="float: right; width: 20%"
                :key="index"
                v-for="(val, index) in pazaryeriLogo(props.row.Pazaryeri)"
              >
                <img
                  :src="findPazaryeri(val)"
                  style="width: 100%; float: right"
                  class="img-fluid"
                />
              </b-badge>
            </div>

            <!-- Column: Action -->
            <span v-else-if="props.column.field === 'action'">
              <span>
                <b-row>
                  <b-col lg="3" sm="12">
                    <vs-button
                      @click="kartDetay(props.row.Barkod)"
                      radius
                      size="small"
                      icon="search"
                      type="gradient"
                    ></vs-button>
                  </b-col>

                  <b-col lg="3" sm="12">
                    <vs-button
                      @click="recete(props.row.stokKodu)"
                      color="success"
                      radius
                      size="small"
                      icon="event_note"
                      type="gradient"
                    ></vs-button>
                  </b-col>
                  <b-col lg="3" sm="12">
                    <vs-button
                      @click="logListesiGetir(props.row.stokKodu)"
                      color="danger"
                      radius
                      size="small"
                      icon="assignment"
                      type="gradient"
                    ></vs-button>
                  </b-col>
                </b-row>
              </span>
            </span>

            <!-- Column: Common -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>

          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <b-form-select
                  v-model="pageLength"
                  :options="['50', '100', '250', '500', '1000']"
                  class="mx-1"
                  @input="(value) => props.perPageChanged({ currentPerPage: value })"
                />
                <span class="text-nowrap">Toplam {{ props.total }} kayıt </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="left"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </div>
    </div>

    <vs-popup fullscreen title="Özellik Eşleme" :active.sync="popupActiveSiparis2">
      <div>
        <h5 style="color: red">Stok Kart Bilgisi</h5>
        <span style="color: dark" v-if="ozellikEsleListeFlag != true">
          {{ StokKartDetayOzellikleri }}</span
        ><span style="color: dark" v-if="ozellikEsleListeFlag == true">
          {{ StokKartDetayOzellikleriListe }}</span
        ><br />
      </div>
      <br />

      <b-row style="margin-bottom: 50px">
        <!--   <b-col lg="3" sm="8" v-if="aktifPazaryeri == 'N11'">
          <vue-autosuggest
            v-model="query"
            style="width: 100%"
            :suggestions="filteredOptions"
            :get-suggestion-value="getSuggestionValue"
            :input-props="{
              id: 'autosuggest__input',
              class: 'form-control',
              placeholder: 'Özellik',
            }"
            @input="onInputChange"
          >
            <template slot-scope="{ suggestion }">
              <div class="d-flex align-items-center my-suggestion-item">
                <div class="detail ml-50 my-suggestion-item">
                  <b-card-text class="mb-0">
                    {{ suggestion.item.attributeName }} -
                    {{ suggestion.item.attributeid }}
                  </b-card-text>
                </div>
              </div>
            </template>
          </vue-autosuggest>
        </b-col>-->
        <b-col>
          <v-select
            v-model="selectedO1"
            :options="kategoriOzellikListesi"
            label="attributeName"
            style=""
            solo
            @input="ozellikOzellikListesi"
          ></v-select>
        </b-col>

        <b-col lg="3" sm="8">
          <div v-if="aktifPazaryeri != 'N11'">
            <v-select
              v-model="selectedO3"
              :options="ozellikOzellikleriData"
              label="valueName"
              style=""
              solo
            ></v-select>
          </div>
          <div v-else>
            <vue-autosuggest
              v-model="query"
              style="width: 100%"
              :suggestions="filteredOptions"
              :get-suggestion-value="getSuggestionValue"
              :input-props="{
                id: 'autosuggest__input',
                class: 'form-control',
                placeholder: 'Pazaryeri Özellikleri',
              }"
              @input="onInputChange"
            >
              <template slot-scope="{ suggestion }">
                <div class="d-flex align-items-center my-suggestion-item">
                  <div class="detail ml-50 my-suggestion-item">
                    <b-card-text class="mb-0">
                      {{ suggestion.item.valueName }}
                    </b-card-text>
                  </div>
                </div>
              </template>
            </vue-autosuggest>
          </div>
        </b-col>
        <b-col lg="3" sm="4">
          <vs-button @click="ozellikleriEsle" color="red" type="filled">
            Eşleştir</vs-button
          >
        </b-col>
      </b-row>

      <vs-table :data="ozellikEslestirmeListesiData" style="min-height: 500px">
        <template slot="thead">
          <vs-th>Özellik Adı</vs-th>
          <vs-th>Değeri</vs-th>
          <vs-th>Çıkar</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              {{ data[indextr].muhasebeAlan }}
            </vs-td>
            <vs-td>
              {{ data[indextr].alanDegeri }}
            </vs-td>
            <vs-td>
              <vs-button
                v-bind:id="'cikar' + data[indextr].barkod"
                @click="
                  ozellikeslestirmeSil(
                    data[indextr].id,
                    data[indextr].program,
                    data[indextr].barkod
                  )
                "
                color="red"
                type="filled"
                >Listeden Kaldır</vs-button
              >
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>

    <vs-popup
      fullscreen
      class="holamundo"
      title="Kart Detayı"
      :active.sync="popupKartDetay"
    >
      <template>
        <vs-card>
          <b-row align-h="center">
            <b-col cols="12" md="auto">
              <h5 style="color: red">Stok Kart Bilgisi</h5>
            </b-col>
            <b-col cols="12" md="auto">
              {{ StokKartDetayOzellikleri }}
            </b-col>
            <b-col cols="12" md="auto">
              <h5 style="color: red">Stok Kodu</h5>
            </b-col>
            <b-col cols="12" md="auto">
              {{ dStokKodu }}
            </b-col>
            <b-col cols="12" md="auto">
              <h5 style="color: red">Barkod</h5>
            </b-col>
            <b-col cols="12" md="auto">
              {{ dBarkod }}
            </b-col>
          </b-row>
        </vs-card>

        <vs-tabs v-model="active_tab">
          <vs-tab label="Stok Kart Detayı" :key="0">
            <div class="con-tab-ejemplo">
              <table>
                <tr>
                  <td>Stok Adı</td>
                  <td>{{ dStokAdi }}</td>
                </tr>
                <tr>
                  <vs-td>Stok Kodu</vs-td>
                  <vs-td>{{ dStokKodu }}</vs-td>
                </tr>
                <tr>
                  <td>Barkod</td>
                  <td>{{ dBarkod }}</td>
                </tr>
                <tr>
                  <td>Ürün Kategorisi</td>
                  <td>{{ dKategori }}</td>
                </tr>
                <tr>
                  <td>Renk</td>
                  <td>{{ dRenk }}</td>
                </tr>
                <tr>
                  <td>Beden</td>
                  <td>{{ dBeden }}</td>
                </tr>
                <tr>
                  <td>Tanımlı Diğer Özellikler</td>
                  <td>
                    <p v-html="dDigerOzelliklerListe"></p>
                  </td>
                </tr>
                <tr>
                  <td>Ürün Açıklaması</td>
                  <td>
                    <vs-textarea v-model="stokAciklama" />
                  </td>
                </tr>
              </table>
            </div>
          </vs-tab>

          <vs-tab label="Stok Resimleri" @click="resimListesi()">
            <div class="con-tab-ejemplo">
              <b-row>
                <b-col cols="3">
                  <b-row v-if="!image">
                    <vs-card style="margin: 10px">
                      <div slot="header">
                        <h3>Resim Update</h3>
                      </div>
                      <div>
                        <vs-button
                          @click="resimUpdate()"
                          style="border-radius: 5px"
                          color="success"
                          type="gradient"
                          >Resim Güncelle</vs-button
                        >
                      </div>
                    </vs-card>
                  </b-row>
                </b-col>
                <b-col cols="7" style="background: white; padding: 20px; margin: 20px">
                  <b-row v-if="!image">
                    <b-col cols="4">
                      <h2>Resim Seç</h2>
                      <input type="file" @change="onFileChange" />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <!--<vs-progress
                :percent="progress"
                v-model="progress"
                color="primary"
              ></vs-progress>-->

              <vs-table :data="stokResimListesi">
                <template slot="thead">
                  <vs-th></vs-th>
                  <vs-th>Stok Kodu</vs-th>
                  <vs-th>Barkod</vs-th>
                  <vs-th>Resim Adı</vs-th>
                  <vs-th>Sil</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td
                      ><img
                        style="width: 50px"
                        v-bind:src="
                          imageUrl.replace('sistem.asmx?WSDL', 'uploads/') +
                          data[indextr].resimAdi
                        "
                        alt=""
                    /></vs-td>
                    <vs-td>
                      {{ data[indextr].stokKodu }}
                    </vs-td>
                    <vs-td>
                      {{ data[indextr].barkod }}
                    </vs-td>
                    <vs-td>
                      {{ data[indextr].resimAdi }}
                    </vs-td>
                    <vs-td>
                      <vs-button
                        @click="resimSil(data[indextr].id)"
                        style="border-radius: 5px"
                        type="gradient"
                        color="danger"
                        >Resim Sil</vs-button
                      >
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-tab>

          <vs-tab
            v-for="(tabval, tabind) in tabList"
            :key="'A' + tabind"
            :label="tabval.name"
            @click="pazaryeriDetay(tabval.name)"
          >
            <div v-if="tabval.name == 'Trendyol'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">
                      {{ trendyolBilgilendirme }}
                    </b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Kategorisi</b-col>
                          <b-col cols="9">{{ trendyolKategori }}</b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Satış Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="trendyolSatisFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Piyasa Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="trendyolPiyasaFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px"
                            >Gönderilecek Adet</b-col
                          >
                          <b-col cols="9">
                            <vs-input v-model="trendyolGonderilecekAdet" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Desi</b-col>
                          <b-col cols="9">
                            <vs-input v-model="trendyolDesi" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Renk</b-col>
                          <b-col cols="9">
                            <vs-input v-model="dRenk" />
                          </b-col>
                        </b-row>
                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('Trendyol')"
                              style="border-radius: 5px"
                              type="gradient"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              >Listeye Ekle</vs-button
                            >
                            <vs-button
                              @click="trendyolGonder()"
                              style="border-radius: 5px"
                              color="danger"
                              type="gradient"
                              :disabled="validateTrendyolGonder"
                              >Trendyola Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              style="border-radius: 5px"
                              color="success"
                              type="gradient"
                              >Özellik Eşleştir</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>

                    <b-col
                      cols="6"
                      v-if="trendyolBilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>
                </span>
                <span>
                  <table>
                    <tr>
                      <td colspan="2">
                        {{ trendyolDurumMesaji }}
                      </td>
                    </tr>
                  </table>

                  <vs-table :data="trendyolAltUrunListesi">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>Renk</vs-th>
                      <vs-th>Beden</vs-th>
                      <vs-th>Listeden Çıkar</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].renk }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].beden }}
                        </vs-td>
                        <vs-td>
                          <span v-if="data[indextr].eslesmeDurumu == '2'">
                            Ürün Trendyola Gönderilmiş (
                            {{ data[indextr].eklenmeDurumu }} )
                          </span>
                          <span v-if="data[indextr].eslesmeDurumu == '1'">
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="
                                altListedenKaldir('Trendyol', data[indextr].stokKodu)
                              "
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>
                          <span v-if="trendyolurunEklenmeDurumu == 'anaUrun'">
                            <span v-if="data[indextr].eslesmeDurumu == '-1'">
                              <vs-button
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'Trendyol',
                                    data[indextr].stokKodu,
                                    data[indextr].stokAdi,
                                    data[indextr].barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    0,
                                    '',
                                    0,
                                    '',
                                    data[indextr].ortakKod,
                                    ''
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                            </span>
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>

                  <vs-table :data="gonderilenStokListesi">
                    <template slot="thead">
                      <vs-th>Barkod</vs-th>
                      <vs-th>Durum</vs-th>
                      <vs-th>Alınan Hata</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].barcode }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].status }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].failureReasons }}
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
              </div>
            </div>
            <div v-if="tabval.name == 'N11'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">{{ n11Bilgilendirme }}</b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-row>
                          <b-col cols="8">
                            <b-row align-v="center">
                              <b-col cols="4" style="font-size: 15px">Kategorisi</b-col>
                              <b-col cols="8">{{ n11Kategori }}</b-col>
                            </b-row>
                            <b-row align-v="center">
                              <b-col cols="4" style="font-size: 15px">Satış Fiyatı</b-col>
                              <b-col cols="8">
                                <vs-input v-model="n11SatisFiyati" />
                              </b-col>
                            </b-row>
                            <b-row align-v="center">
                              <b-col cols="4" style="font-size: 15px"
                                >Piyasa Fiyatı</b-col
                              >
                              <b-col cols="8">
                                <vs-input v-model="n11PiyasaFiyati" />
                              </b-col>
                            </b-row>
                            <b-row align-v="center">
                              <b-col cols="4" style="font-size: 15px"
                                >Gönderilecek Adet</b-col
                              >
                              <b-col cols="8">
                                <vs-input v-model="n11GonderilecekAdet" />
                              </b-col>
                            </b-row>
                            <b-row align-v="center">
                              <b-col cols="4" style="font-size: 15px"
                                >Hazırlık Süresi</b-col
                              >
                              <b-col cols="8">
                                <v-select
                                  style="width: 200px"
                                  :options="['1', '2', '3', '4', '5', '6', '7+']"
                                  v-model="selectedN11HazirlikSuresi"
                                ></v-select>
                              </b-col>
                            </b-row>
                            <b-row align-v="center">
                              <b-col cols="4" style="font-size: 15px">Para Birimi</b-col>
                              <b-col cols="8">
                                {{ dParaBirim }}
                              </b-col>
                            </b-row>
                            <b-row v-if="N11KatalogId != ''" align-v="center">
                              <b-col cols="4" style="font-size: 15px">Katalog Id</b-col>
                              <b-col cols="8">
                                {{ N11KatalogId }}
                              </b-col>
                            </b-row>
                          </b-col>

                          <!--    <b-col cols="4" style="font-size: 15px">
                            <b-row align-v="center">
                              <b-col cols="7">Kar Oranı</b-col>
                              <b-col cols="5">{{ karOran }}</b-col>
                            </b-row>
                            <b-row align-v="center">
                              <b-col cols="7">Kargo</b-col>
                              <b-col cols="5">{{ kargoTutar }}</b-col>
                            </b-row>
                            <b-row align-v="center">
                              <b-col cols="7">Hesaplanan</b-col>
                              <b-col cols="5">{{
                                FiyatHesapla(
                                  karOran,
                                  kargoTutar,
                                  n11SatisFiyati
                                )
                              }}</b-col>
                            </b-row>
                          </b-col>-->
                        </b-row>

                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('N11')"
                              type="gradient"
                              :disabled="validateN11ListeyeEkle"
                              style="border-radius: 5px"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              >Listeye Ekle</vs-button
                            >
                            <vs-button
                              @click="n11Gonder()"
                              color="danger"
                              type="gradient"
                              style="border-radius: 5px"
                              id="button-with-loading-n11gonder"
                              class="vs-con-loading__container"
                              >N11 Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              color="success"
                              type="gradient"
                              style="border-radius: 5px"
                              >Özellik Eşleştir</vs-button
                            >
                            <vs-button
                              @click="openAlert('warning', 'N11', dStokKodu)"
                              color="#fc9551"
                              gradient-color-secondary="rgb(255, 115, 0)"
                              type="gradient"
                              style="border-radius: 5px"
                              >Listeden Kaldır</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>
                    <b-col
                      cols="6"
                      v-if="n11Bilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>

                  <!--<td>
                      Teslimat Şablonu
                    </td>
                    <td>
                      <v-select
                        :value="selectedN11TeslimatSablonu"
                        v-model="selectedN11TeslimatSablonu"
                        label="name"
                        :options="optionsN11TeslimatSablonu"
                        size:small
                      ></v-select>
                    </td>-->
                  <!--<td class="text-center" style="font-weight: bold">
                      N11 Ürün Durumu
                    </td>-->

                  <!--<td>
                      <v-select
                        :value="selectedN11UrunDurumu"
                        v-model="selectedN11UrunDurumu"
                        :options="formatOptions"
                        style="width:200px"
                        size:small
                      ></v-select>
                    </td>-->

                  <!--<td>
                      <vs-button
                        @click="n11DurumGuncelle()"
                        type="filled"
                        color="red"
                        >N11 Durum Güncelle</vs-button
                      >
                    </td>-->
                  <!--:disabled="validateN11Kaldir"-->

                  <!--<tr>
                    <td colspan="2">{{ n11DurumMesaji }}</td>
                  </tr>-->

                  {{ n11DurumMesaji }}
                  <vs-table :data="N11AltUrunListesi">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>Renk</vs-th>
                      <vs-th>Fiyat</vs-th>
                      <vs-th>Adet</vs-th>
                      <vs-th>Katalog Id</vs-th>
                      <vs-th>Listeden Çıkar</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].renk }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].SATIS_FIAT1 }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdet }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].alan10 }}
                        </vs-td>
                        <vs-td>
                          <span v-if="data[indextr].eslesmeDurumu == '2'">
                            Ürün N11 Gönderilmiş (
                            {{ data[indextr].eklenmeDurumu }} )
                          </span>
                          <span v-if="data[indextr].eslesmeDurumu == '1'">
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="altListedenKaldir('N11', data[indextr].stokKodu)"
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>
                          <span v-if="N11urunEklenmeDurumu == 'anaUrun'">
                            <span v-if="data[indextr].eslesmeDurumu == '-1'">
                              <vs-button
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'N11',
                                    data[indextr].stokKodu,
                                    data[indextr].stokAdi,
                                    data[indextr].barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    0,
                                    '',
                                    data[indextr].kdv,
                                    '',
                                    data[indextr].ortakKod,
                                    '',
                                    data[indextr].N11KatalogId
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                            </span>
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>

                  <vs-table :data="gonderilenStokListesi">
                    <template slot="thead">
                      <vs-th>Barkod</vs-th>
                      <vs-th>Durum</vs-th>
                      <vs-th>Alınan Hata</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].barcode }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].status }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].failureReasons }}
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
              </div>
            </div>
            <div v-if="tabval.name == 'Hepsiburada'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">
                      {{ hepsiburadaBilgilendirme }}
                    </b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-row align-v="center">
                          <b-col cols="4" style="font-size: 15px">Kategorisi</b-col>
                          <b-col cols="8">{{ hepsiburadaKategori }}</b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="4" style="font-size: 15px">Satış Fiyatı</b-col>
                          <b-col cols="8">
                            <vs-input v-model="hepsiburadaSatisFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="4" style="font-size: 15px">Piyasa Fiyatı</b-col>
                          <b-col cols="8">
                            <vs-input v-model="hepsiburadaPiyasaFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="4" style="font-size: 15px"
                            >Gönderilecek Adet</b-col
                          >
                          <b-col cols="8">
                            <vs-input v-model="hepsiburadaGonderilecekAdet" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="4" style="font-size: 15px">Desi</b-col>
                          <b-col cols="8">
                            <vs-input v-model="hepsiburadaDesi" />
                          </b-col>
                        </b-row>

                        <b-row align-v="center">
                          <b-col cols="4" style="font-size: 15px">SKU Kod</b-col>
                          <b-col cols="8">
                            {{ HBKatalogId }}
                          </b-col>
                        </b-row>

                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('Hepsiburada')"
                              type="gradient"
                              style="border-radius: 5px"
                              :disabled="validateHepsiburadaListeyeEkle"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              >Listeye Ekle</vs-button
                            >
                            <vs-button
                              @click="hepsiburadaGonder()"
                              color="danger"
                              type="gradient"
                              style="border-radius: 5px"
                              :disabled="validateHepsiburadaGonder"
                              >Hepsiburada Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              color="success"
                              type="gradient"
                              style="border-radius: 5px"
                              >Özellik Eşleştir</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>
                    <b-col
                      cols="6"
                      v-if="hepsiburadaBilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>
                  <table>
                    <tr>
                      <td>{{ hepsiburadaGonderimHatasi }}</td>
                    </tr>
                  </table>

                  <vs-table :data="HepsiburadaAltUrunListesi">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>Renk</vs-th>
                      <vs-th>Beden</vs-th>
                      <vs-th>Listeden Çıkar</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].renk }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].beden }}
                        </vs-td>
                        <vs-td>
                          <span v-if="data[indextr].eslesmeDurumu == '2'">
                            Ürün Hepsiburadaya Gönderilmiş (
                            {{ data[indextr].eklenmeDurumu }} )
                          </span>
                          <span v-if="data[indextr].eslesmeDurumu == '1'">
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="
                                altListedenKaldir('Hepsiburada', data[indextr].stokKodu)
                              "
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>

                          <span v-if="ticimaxurunEklenmeDurumu == 'anaUrun'">
                            <span v-if="data[indextr].eslesmeDurumu == '-1'">
                              <vs-button
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'Hepsiburada',
                                    data[indextr].stokKodu,
                                    data[indextr].stokAdi,
                                    data[indextr].barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    0,
                                    '',
                                    0,
                                    '',
                                    data[indextr].ortakKod,
                                    ''
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                            </span>
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
                <span>
                  <vs-table :data="gonderilenStokListesi">
                    <template slot="thead">
                      <vs-th>Barkod</vs-th>
                      <vs-th>Durum</vs-th>
                      <vs-th>Alınan Hata</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].barcode }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].status }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].failureReasons }}
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
              </div>
            </div>
            <div v-if="tabval.name == 'Ticimax'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">
                      {{ ticimaxBilgilendirme }}
                    </b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Kategorisi</b-col>
                          <b-col cols="9">{{ ticimaxKategori }}</b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Satış Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="ticimaxSatisFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Piyasa Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="ticimaxPiyasaFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px"
                            >Gönderilecek Adet</b-col
                          >
                          <b-col cols="9">
                            <vs-input v-model="ticimaxGonderilecekAdet" />
                          </b-col>
                        </b-row>

                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('Ticimax')"
                              type="gradient"
                              :disabled="validateTicimaxListeyeEkle"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              style="border-radius: 5px"
                              >Listeye Ekle</vs-button
                            >
                            <vs-button
                              @click="ticimaxGonder()"
                              color="danger"
                              type="gradient"
                              style="border-radius: 5px"
                              >Ticimax Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              color="success"
                              type="gradient"
                              style="border-radius: 5px"
                              >Özellik Eşleştir</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>
                    <b-col
                      cols="6"
                      v-if="ticimaxBilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>

                  <vs-table :data="ticimaxAltUrunListesi">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>Renk</vs-th>
                      <vs-th>Beden</vs-th>
                      <vs-th>Listeden Çıkar</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].renk }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].beden }}
                        </vs-td>
                        <vs-td>
                          <span v-if="data[indextr].eslesmeDurumu == '2'">
                            Ürün Ticimax Gönderilmiş (
                            {{ data[indextr].eklenmeDurumu }} )
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="
                                altListedenKaldir('Ticimax', data[indextr].stokKodu)
                              "
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>
                          <span v-if="data[indextr].eslesmeDurumu == '1'">
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="
                                altListedenKaldir('Ticimax', data[indextr].stokKodu)
                              "
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>

                          <span v-if="ticimaxurunEklenmeDurumu == 'anaUrun'">
                            <span v-if="data[indextr].eslesmeDurumu == '-1'">
                              <vs-button
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'Ticimax',
                                    data[indextr].stokKodu,
                                    data[indextr].stokAdi,
                                    data[indextr].barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    0,
                                    '',
                                    0,
                                    '',
                                    data[indextr].ortakKod,
                                    ''
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                            </span>
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>

                  <span v-if="dEklenmeDurumu == 'anaUrun'">
                    <span style="font-weight: bold">İlişkili Ürünler</span>
                    <span style="font-weight: bold"
                      ><vs-input
                        class="inputx"
                        placeholder="Stok Kodu & Barkod"
                        @keyup.enter="iliskiliUrunAra('Ticimax')"
                        :ref="iliskiliUrunB"
                        v-model="iliskiliUrunB"
                    /></span>
                    <vs-table :data="anaUrunListesiTicimax">
                      <template slot="thead">
                        <vs-th>Ürün Kodu</vs-th>
                        <vs-th>Ürün Adı</vs-th>
                        <vs-th>Barkod</vs-th>
                        <vs-th>İlişkili Ürün Ekle</vs-th>
                      </template>

                      <template slot-scope="{ data }">
                        <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                          <vs-td>
                            {{ data[indextr].stokKodu }}
                          </vs-td>
                          <vs-td>
                            {{ data[indextr].stokAdi }}
                          </vs-td>
                          <vs-td>
                            {{ data[indextr].barkod }}
                          </vs-td>

                          <vs-td>
                            <span v-if="dBarkod != boslukTemizle(data[indextr].barkod)">
                              <vs-button
                                @click="
                                  iliskiliUrunGonder(
                                    'Ticimax',
                                    dBarkod,
                                    data[indextr].barkod
                                  )
                                "
                                color="red"
                                type="filled"
                                >İlişkili Ürün Gönder</vs-button
                              >
                            </span>
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </span>
                </span>
              </div>
            </div>
            <div v-if="tabval.name == 'Tsoft'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">
                      {{ tsoftBilgilendirme }}
                    </b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Kategorisi</b-col>
                          <b-col cols="9">{{ tsoftKategori }}</b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Satış Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="tsoftSatisFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Piyasa Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="tsoftPiyasaFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px"
                            >Gönderilecek Adet</b-col
                          >
                          <b-col cols="9">
                            <vs-input v-model="tsoftGonderilecekAdet" />
                          </b-col>
                        </b-row>

                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('Tsoft')"
                              type="gradient"
                              :disabled="validateTsoftListeyeEkle"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              style="border-radius: 5px"
                              >Listeye Ekle</vs-button
                            >
                            <vs-button
                              @click="tsoftGonder()"
                              type="gradient"
                              color="danger"
                              style="border-radius: 5px"
                              >Tsoft Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              color="success"
                              type="gradient"
                              style="border-radius: 5px"
                              >Özellik Eşleştir</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>
                    <b-col
                      cols="6"
                      v-if="tsoftBilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>

                  <vs-table :data="tsoftAltUrunListesi">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>Özellik</vs-th>
                      <vs-th>Alt Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].Barkod }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].beden }} - {{ data[indextr].renk }} -
                          {{ data[indextr].cinsiyet }}
                        </vs-td>
                        <vs-td>
                          <span v-if="data[indextr].eslesmeDurumu == '2'">
                            Ürün Tsoft Gönderilmiş (
                            {{ data[indextr].eklenmeDurumu }} )
                          </span>
                          <span v-if="data[indextr].eslesmeDurumu == '1'">
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="altListedenKaldir('Tsoft', data[indextr].stokKodu)"
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>
                          <span v-if="urunEklenmeDurumu == 'anaUrun'">
                            <span v-if="data[indextr].eslesmeDurumu == '-1'">
                              <vs-button
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'Tsoft',
                                    data[indextr].stokKodu,
                                    data[indextr].StokAdi,
                                    data[indextr].Barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    0,
                                    '',
                                    0,
                                    '',
                                    data[indextr].ortakKod,
                                    ''
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                            </span>
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>

                <span v-if="dEklenmeDurumu == 'anaUrun'">
                  <span style="font-weight: bold">İlişkili Ürünler</span>
                  <span style="font-weight: bold"
                    ><vs-input
                      class="inputx"
                      placeholder="Stok Kodu & Barkod"
                      @keyup.enter="iliskiliUrunAra('Tsoft')"
                      :ref="iliskiliUrunB"
                      v-model="iliskiliUrunB"
                  /></span>
                  <vs-table :data="anaUrunListesiTsoft">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>İlişkili Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>

                        <vs-td>
                          <span v-if="dBarkod != boslukTemizle(data[indextr].barkod)">
                            <vs-button
                              @click="
                                iliskiliUrunGonder('Tsoft', dBarkod, data[indextr].barkod)
                              "
                              color="red"
                              type="filled"
                              >İlişkili Ürün Gönder</vs-button
                            >
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
              </div>
            </div>
            <div v-if="tabval.name == 'Shopify'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">
                      {{ shopifyBilgilendirme }}
                    </b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Kategorisi</b-col>
                          <b-col cols="9">{{ shopifyKategori }}</b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Satış Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="shopifySatisFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Piyasa Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="shopifyPiyasaFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px"
                            >Gönderilecek Adet</b-col
                          >
                          <b-col cols="9">
                            <vs-input v-model="shopifyGonderilecekAdet" />
                          </b-col>
                        </b-row>

                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('Shopify')"
                              type="gradient"
                              style="border-radius: 5px"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              >Listeye Ekle</vs-button
                            >
                            <vs-button
                              @click="shopifyGonder()"
                              type="gradient"
                              color="danger"
                              style="border-radius: 5px"
                              >Shopify Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              color="success"
                              type="gradient"
                              style="border-radius: 5px"
                              >Özellik Eşleştir</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>
                    <b-col
                      cols="6"
                      v-if="shopifyBilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>

                  <vs-table :data="shopifyAltUrunListesi">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>Özellik</vs-th>
                      <vs-th>Alt Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].Barkod }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].beden }} - {{ data[indextr].renk }} -
                          {{ data[indextr].cinsiyet }}
                        </vs-td>
                        <vs-td>
                          <span v-if="data[indextr].eslesmeDurumu == '2'">
                            Ürün shopify Gönderilmiş (
                            {{ data[indextr].eklenmeDurumu }} )
                          </span>
                          <span v-if="data[indextr].eslesmeDurumu == '1'">
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="
                                altListedenKaldir('Shopify', data[indextr].stokKodu)
                              "
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>
                          <span v-if="urunEklenmeDurumu == 'anaUrun'">
                            <span v-if="data[indextr].eslesmeDurumu == '-1'">
                              <vs-button
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'Shopify',
                                    data[indextr].stokKodu,
                                    data[indextr].StokAdi,
                                    data[indextr].Barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    0,
                                    '',
                                    0,
                                    '',
                                    data[indextr].ortakKod,
                                    ''
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                            </span>
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>

                <span v-if="dEklenmeDurumu == 'anaUrun'">
                  <span style="font-weight: bold">İlişkili Ürünler</span>
                  <span style="font-weight: bold"
                    ><vs-input
                      class="inputx"
                      placeholder="Stok Kodu & Barkod"
                      @keyup.enter="iliskiliUrunAra('Shopify')"
                      :ref="iliskiliUrunB"
                      v-model="iliskiliUrunB"
                  /></span>
                  <vs-table :data="anaUrunListesiShopify">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>İlişkili Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>

                        <vs-td>
                          <span v-if="dBarkod != boslukTemizle(data[indextr].barkod)">
                            <vs-button
                              @click="
                                iliskiliUrunGonder(
                                  'Shopify',
                                  dBarkod,
                                  data[indextr].barkod
                                )
                              "
                              color="red"
                              type="filled"
                              >İlişkili Ürün Gönder</vs-button
                            >
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
              </div>
            </div>
            <div v-if="tabval.name == 'Gittigidiyor'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">{{
                      gittigidiyorBilgilendirme
                    }}</b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Kategorisi</b-col>
                          <b-col cols="9">{{ gittigidiyorKategori }}</b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Satış Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="gittigidiyorSatisFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Piyasa Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="gittigidiyorPiyasaFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px"
                            >Gönderilecek Adet</b-col
                          >
                          <b-col cols="9">
                            <vs-input v-model="gittigidiyorGonderilecekAdet" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Kategori ID</b-col>
                          <b-col cols="9">
                            {{ GGKatalogId }}
                          </b-col>
                        </b-row>

                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('Gittigidiyor')"
                              type="gradient"
                              style="border-radius: 5px"
                              :disabled="validateGittigidiyorListeyeEkle"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              >Listeye Ekle</vs-button
                            >
                            <vs-button
                              @click="gittigidiyorGonder()"
                              type="gradient"
                              color="danger"
                              style="border-radius: 5px"
                              >Gittigidiyor Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              color="success"
                              type="gradient"
                              style="border-radius: 5px"
                              >Özellik Eşleştir</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>
                    <b-col
                      cols="6"
                      v-if="gittigidiyorBilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>

                  <vs-table>
                    <tr>
                      <td>
                        <vs-table :data="gittigidiyorAltUrunListesi">
                          <template slot="thead">
                            <vs-th>Ürün Kodu</vs-th>
                            <vs-th>Barkod</vs-th>
                            <vs-th>Özellik</vs-th>
                            <vs-th>Alt Ürün Ekle</vs-th>
                          </template>

                          <template slot-scope="{ data }">
                            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                              <vs-td>
                                {{ data[indextr].stokKodu }}
                              </vs-td>
                              <vs-td>
                                {{ data[indextr].Barkod }}
                              </vs-td>
                              <vs-td>
                                {{ data[indextr].beden }} - {{ data[indextr].renk }} -
                                {{ data[indextr].cinsiyet }}
                              </vs-td>

                              <vs-td>
                                <span v-if="data[indextr].eslesmeDurumu == '2'">
                                  Ürün gittigidiyor Gönderilmiş (
                                  {{ data[indextr].eklenmeDurumu }} )
                                </span>
                                <span v-if="data[indextr].eslesmeDurumu == '1'">
                                  <vs-button
                                    v-bind:id="'cikar' + data[indextr].stokKodu"
                                    @click="
                                      altListedenKaldir(
                                        'Gittigidiyor',
                                        data[indextr].stokKodu
                                      )
                                    "
                                    color="red"
                                    type="filled"
                                    >Listeden Kaldır</vs-button
                                  >
                                </span>
                                <span v-if="urunEklenmeDurumu == 'anaUrun'">
                                  <span v-if="data[indextr].eslesmeDurumu == '-1'">
                                    <vs-button
                                      v-bind:id="'ekle' + data[indextr].stokKodu"
                                      @click="
                                        altGonderimListesineEkle(
                                          'Gittigidiyor',
                                          data[indextr].stokKodu,
                                          data[indextr].StokAdi,
                                          data[indextr].Barkod,
                                          data[indextr].stokAdet,
                                          data[indextr].alan1,
                                          data[indextr].alan2,
                                          data[indextr].alan3,
                                          data[indextr].alan4,
                                          data[indextr].alan5,
                                          data[indextr].alan6,
                                          data[indextr].alan7,
                                          data[indextr].alan8,
                                          data[indextr].alan9,
                                          data[indextr].alan10,
                                          data[indextr].renk,
                                          data[indextr].beden,
                                          data[indextr].SATIS_FIAT1,
                                          data[indextr].stokAdet,
                                          data[indextr].SATIS_FIAT1,
                                          0,
                                          0,
                                          '',
                                          0,
                                          '',
                                          data[indextr].ortakKod,
                                          ''
                                        )
                                      "
                                      color="success"
                                      type="filled"
                                      >Alt Ürün Ekle</vs-button
                                    >
                                  </span>
                                </span>
                              </vs-td>
                            </vs-tr>
                          </template>
                        </vs-table>
                      </td>
                      <td></td>
                    </tr>
                  </vs-table>
                </span>

                <span v-if="dEklenmeDurumu == 'anaUrun'">
                  <span style="font-weight: bold">İlişkili Ürünler</span>
                  <span style="font-weight: bold"
                    ><vs-input
                      class="inputx"
                      placeholder="Stok Kodu & Barkod"
                      @keyup.enter="iliskiliUrunAra('Gittigidiyor')"
                      :ref="iliskiliUrunB"
                      v-model="iliskiliUrunB"
                  /></span>
                  <vs-table :data="anaUrunListesiGittigidiyor">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>İlişkili Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>

                        <vs-td>
                          <span v-if="dBarkod != boslukTemizle(data[indextr].barkod)">
                            <vs-button
                              @click="
                                iliskiliUrunGonder(
                                  'Gittigidiyor',
                                  dBarkod,
                                  data[indextr].barkod
                                )
                              "
                              color="red"
                              type="filled"
                              >İlişkili Ürün Gönder</vs-button
                            >
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
                <vs-table :data="gonderilenStokListesi">
                  <template slot="thead">
                    <vs-th>Barkod</vs-th>
                    <vs-th>Durum</vs-th>
                    <vs-th>Alınan Hata</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>
                        {{ data[indextr].barcode }}
                      </vs-td>
                      <vs-td>
                        {{ data[indextr].status }}
                      </vs-td>
                      <vs-td>
                        {{ data[indextr].failureReasons }}
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
            <div v-if="tabval.name == 'Ciceksepeti'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">{{
                      ciceksepetiBilgilendirme
                    }}</b-col>

                    <b-col cols="7">
                      <vs-card>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Kategorisi</b-col>
                          <b-col cols="9">{{ ciceksepetiKategori }}</b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Satış Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="ciceksepetiSatisFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Piyasa Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="ciceksepetiPiyasaFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px"
                            >Gönderilecek Adet</b-col
                          >
                          <b-col cols="9">
                            <vs-input v-model="ciceksepetiGonderilecekAdet" />
                          </b-col>
                        </b-row>

                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('Ciceksepeti')"
                              type="gradient"
                              style="border-radius: 5px"
                              :disabled="validateCiceksepetiListeyeEkle"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              >Listeye Ekle</vs-button
                            >
                            <vs-button
                              @click="ciceksepetiGonder()"
                              type="gradient"
                              color="danger"
                              style="border-radius: 5px"
                              >Ciceksepeti Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              color="success"
                              type="gradient"
                              style="border-radius: 5px"
                              >Özellik Eşleştir</vs-button
                            >
                            <vs-button
                              @click="openAlert('warning', 'Ciceksepeti', dStokKodu)"
                              color="#fc9551"
                              gradient-color-secondary="rgb(255, 115, 0)"
                              type="gradient"
                              style="border-radius: 5px"
                              >Listeden Kaldır</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>
                    <b-col
                      cols="5"
                      v-if="ciceksepetiBilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>

                  <table></table>

                  <vs-table :data="ciceksepetiAltUrunListesi">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>Özellik</vs-th>
                      <vs-th>Alt Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].Barkod }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].beden }} - {{ data[indextr].renk }} -
                          {{ data[indextr].cinsiyet }}
                        </vs-td>
                        <vs-td>
                          <span v-if="data[indextr].eslesmeDurumu == '2'">
                            Ürün Çiçeksepeti Gönderilmiş (
                            {{ data[indextr].eklenmeDurumu }} )
                          </span>
                          <span v-if="data[indextr].eslesmeDurumu == '1'">
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="
                                altListedenKaldir('Ciceksepeti', data[indextr].stokKodu)
                              "
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>
                          <span v-if="urunEklenmeDurumu == 'anaUrun'">
                            <span v-if="data[indextr].eslesmeDurumu == '-1'">
                              <vs-button
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'Ciceksepeti',
                                    data[indextr].stokKodu,
                                    data[indextr].StokAdi,
                                    data[indextr].Barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    0,
                                    '',
                                    0,
                                    '',
                                    data[indextr].ortakKod,
                                    ''
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                            </span>
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>

                <span v-if="dEklenmeDurumu == 'anaUrun'">
                  <span style="font-weight: bold">İlişkili Ürünler</span>
                  <span style="font-weight: bold"
                    ><vs-input
                      class="inputx"
                      placeholder="Stok Kodu & Barkod"
                      @keyup.enter="iliskiliUrunAra('Ciceksepeti')"
                      :ref="iliskiliUrunB"
                      v-model="iliskiliUrunB"
                  /></span>
                  <vs-table :data="anaUrunListesiCiceksepeti">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>İlişkili Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>

                        <vs-td>
                          <span v-if="dBarkod != boslukTemizle(data[indextr].barkod)">
                            <vs-button
                              @click="
                                iliskiliUrunGonder(
                                  'Ciceksepeti',
                                  dBarkod,
                                  data[indextr].barkod
                                )
                              "
                              color="red"
                              type="filled"
                              >İlişkili Ürün Gönder</vs-button
                            >
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
              </div>
            </div>
            <div v-if="tabval.name == 'Platin Market'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">{{
                      platinmarketBilgilendirme
                    }}</b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Kategorisi</b-col>
                          <b-col cols="9">{{ platinmarketKategori }}</b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Satış Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="platinmarketSatisFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Piyasa Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="platinmarketPiyasaFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px"
                            >Gönderilecek Adet</b-col
                          >
                          <b-col cols="9">
                            <vs-input v-model="platinmarketGonderilecekAdet" />
                          </b-col>
                        </b-row>

                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('PlatinMarket')"
                              style="border-radius: 5px"
                              type="gradient"
                              :disabled="validatePlatinmarketListeyeEkle"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              >Listeye Ekle</vs-button
                            >
                            <vs-button
                              @click="platinmarketGonder()"
                              type="gradient"
                              color="danger"
                              style="border-radius: 5px"
                              >PlatinMarket Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              color="success"
                              type="gradient"
                              style="border-radius: 5px"
                              >Özellik Eşleştir</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>
                    <b-col
                      cols="6"
                      v-if="platinmarketBilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>

                  <vs-table :data="platinmarketAltUrunListesi">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>Özellik</vs-th>
                      <vs-th>Alt Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].Barkod }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].beden }} - {{ data[indextr].renk }} -
                          {{ data[indextr].cinsiyet }}
                        </vs-td>
                        <vs-td>
                          <span v-if="data[indextr].eslesmeDurumu == '2'">
                            Ürün PlatinMarket Gönderilmiş (
                            {{ data[indextr].eklenmeDurumu }} )
                          </span>
                          <span v-if="data[indextr].eslesmeDurumu == '1'">
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="
                                altListedenKaldir('PlatinMarket', data[indextr].stokKodu)
                              "
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>
                          <span v-if="urunEklenmeDurumu == 'anaUrun'">
                            <span v-if="data[indextr].eslesmeDurumu == '-1'">
                              <vs-button
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'PlatinMarket',
                                    data[indextr].stokKodu,
                                    data[indextr].StokAdi,
                                    data[indextr].Barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    0,
                                    '',
                                    0,
                                    '',
                                    data[indextr].ortakKod,
                                    ''
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                            </span>
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>

                <span v-if="dEklenmeDurumu == 'anaUrun'">
                  <span style="font-weight: bold">İlişkili Ürünler</span>
                  <span style="font-weight: bold"
                    ><vs-input
                      class="inputx"
                      placeholder="Stok Kodu & Barkod"
                      @keyup.enter="iliskiliUrunAra('PlatinMarket')"
                      :ref="iliskiliUrunB"
                      v-model="iliskiliUrunB"
                  /></span>
                  <vs-table :data="anaUrunListesiPlatinMarket">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>İlişkili Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>

                        <vs-td>
                          <span v-if="dBarkod != boslukTemizle(data[indextr].barkod)">
                            <vs-button
                              @click="
                                iliskiliUrunGonder(
                                  'PlatinMarket',
                                  dBarkod,
                                  data[indextr].barkod
                                )
                              "
                              color="red"
                              type="filled"
                              >İlişkili Ürün Gönder</vs-button
                            >
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
              </div>
            </div>
            <div v-if="tabval.name == 'Woocommerce'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">{{
                      WoocommerceBilgilendirme
                    }}</b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Kategorisi</b-col>
                          <b-col cols="9">{{ WoocommerceKategori }}</b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Satış Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="WoocommerceSatisFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Piyasa Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="WoocommercePiyasaFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px"
                            >Gönderilecek Adet</b-col
                          >
                          <b-col cols="9">
                            <vs-input v-model="WoocommerceGonderilecekAdet" />
                          </b-col>
                        </b-row>

                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('Woocommerce')"
                              type="gradient"
                              style="border-radius: 5px"
                              :disabled="validateWoocommerceListeyeEkle"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              >Listeye Ekle</vs-button
                            >
                            <vs-button
                              @click="WoocommerceGonder()"
                              type="gradient"
                              color="danger"
                              style="border-radius: 5px"
                              >Woocommerce Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              color="success"
                              type="gradient"
                              style="border-radius: 5px"
                              >Özellik Eşleştir</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>
                    <b-col
                      cols="6"
                      v-if="WoocommerceBilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>
                  <table>
                    <tr>
                      <td colspan="2">{{ WoocommerceDurumMesaji }}</td>
                    </tr>
                  </table>

                  <vs-table :data="WoocommerceAltUrunListesi">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>Özellik</vs-th>
                      <vs-th>Alt Ürün Ekle</vs-th>
                      <vs-th>Listeden Çıkar</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td
                          v-if="
                            data[indextr].Barkod == '' || data[indextr].Barkod == null
                          "
                        >
                          {{ data[indextr].barkod }}
                        </vs-td>
                        <vs-td v-else>
                          {{ data[indextr].Barkod }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].beden }} - {{ data[indextr].renk }} -
                          {{ data[indextr].cinsiyet }}
                        </vs-td>
                        <vs-td>
                          <span v-if="data[indextr].eslesmeDurumu == '2'">
                            Ürün Woocommerce Gönderilmiş (
                            {{ data[indextr].eklenmeDurumu }} )
                          </span>
                          <span v-if="data[indextr].eslesmeDurumu == '1'">
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="
                                altListedenKaldir('Woocommerce', data[indextr].stokKodu)
                              "
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>
                          <span v-if="urunEklenmeDurumu == 'anaUrun'">
                            <span v-if="data[indextr].eslesmeDurumu == '-1'">
                              <vs-button
                                v-if="
                                  data[indextr].Barkod == '' ||
                                  data[indextr].Barkod == null
                                "
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'Woocommerce',
                                    data[indextr].stokKodu,
                                    data[indextr].stokAdi,
                                    data[indextr].barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    data[indextr].pazaryeriId,
                                    '',
                                    data[indextr].kdv,
                                    '',
                                    data[indextr].ortakKod,
                                    data[indextr].pazaryeriCode
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                              <vs-button
                                v-else
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'Woocommerce',
                                    data[indextr].stokKodu,
                                    data[indextr].StokAdi,
                                    data[indextr].Barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    data[indextr].pazaryeriId,
                                    '',
                                    data[indextr].kdv,
                                    '',
                                    data[indextr].ortakKod,
                                    data[indextr].pazaryeriCode
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                            </span>
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>

                <span v-if="dEklenmeDurumu == 'anaUrun'">
                  <span style="font-weight: bold">İlişkili Ürünler</span>
                  <span style="font-weight: bold"
                    ><vs-input
                      class="inputx"
                      placeholder="Stok Kodu & Barkod"
                      @keyup.enter="iliskiliUrunAra('Woocommerce')"
                      :ref="iliskiliUrunB"
                      v-model="iliskiliUrunB"
                  /></span>
                  <vs-table :data="anaUrunListesiWoocommerce">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>İlişkili Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>

                        <vs-td>
                          <span v-if="dBarkod != boslukTemizle(data[indextr].barkod)">
                            <vs-button
                              @click="
                                iliskiliUrunGonder(
                                  'Woocommerce',
                                  dBarkod,
                                  data[indextr].barkod
                                )
                              "
                              color="red"
                              type="filled"
                              >İlişkili Ürün Gönder</vs-button
                            >
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
              </div>
            </div>
            <div v-if="tabval.name == 'PttAvm'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">{{ PttAvmBilgilendirme }}</b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Kategorisi</b-col>
                          <b-col cols="9">{{ PttAvmKategori }}</b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Satış Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="PttAvmSatisFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Piyasa Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="PttAvmPiyasaFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px"
                            >Gönderilecek Adet</b-col
                          >
                          <b-col cols="9">
                            <vs-input v-model="PttAvmGonderilecekAdet" />
                          </b-col>
                        </b-row>
                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('PttAvm')"
                              style="border-radius: 5px"
                              type="gradient"
                              :disabled="validatePttAvmListeyeEkle"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              >Listeye Ekle</vs-button
                            >
                            <vs-button
                              @click="PttAvmGonder()"
                              type="gradient"
                              color="danger"
                              style="border-radius: 5px"
                              >Ptt Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              color="success"
                              type="gradient"
                              style="border-radius: 5px"
                              >Özellik Eşleştir</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>
                    <b-col
                      cols="6"
                      v-if="PttAvmBilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>
                  <table>
                    <tr>
                      <td colspan="2">{{ PttAvmDurumMesaji }}</td>
                    </tr>
                  </table>

                  <vs-table :data="PttAvmAltUrunListesi">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>Özellik</vs-th>
                      <vs-th>Alt Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].Barkod }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].beden }} - {{ data[indextr].renk }} -
                          {{ data[indextr].cinsiyet }}
                        </vs-td>
                        <vs-td>
                          <span v-if="data[indextr].eslesmeDurumu == '2'">
                            Ürün PttAvm Gönderilmiş (
                            {{ data[indextr].eklenmeDurumu }} )
                          </span>
                          <span v-if="data[indextr].eslesmeDurumu == '1'">
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="altListedenKaldir('PttAvm', data[indextr].stokKodu)"
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>
                          <span v-if="urunEklenmeDurumu == 'anaUrun'">
                            <span v-if="data[indextr].eslesmeDurumu == '-1'">
                              <vs-button
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'PttAvm',
                                    data[indextr].stokKodu,
                                    data[indextr].StokAdi,
                                    data[indextr].Barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    data[indextr].pazaryeriId,
                                    '',
                                    0,
                                    '',
                                    data[indextr].ortakKod,
                                    data[indextr].pazaryeriCode
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                            </span>
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>

                <span v-if="dEklenmeDurumu == 'anaUrun'">
                  <span style="font-weight: bold">İlişkili Ürünler</span>
                  <span style="font-weight: bold"
                    ><vs-input
                      class="inputx"
                      placeholder="Stok Kodu & Barkod"
                      @keyup.enter="iliskiliUrunAra('PttAvm')"
                      :ref="iliskiliUrunB"
                      v-model="iliskiliUrunB"
                  /></span>
                  <vs-table :data="anaUrunListesiPttAvm">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>İlişkili Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>

                        <vs-td>
                          <span v-if="dBarkod != boslukTemizle(data[indextr].barkod)">
                            <vs-button
                              @click="
                                iliskiliUrunGonder(
                                  'PttAvm',
                                  dBarkod,
                                  data[indextr].barkod
                                )
                              "
                              color="red"
                              type="filled"
                              >İlişkili Ürün Gönder</vs-button
                            >
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
              </div>
            </div>
            <div v-if="tabval.name == 'Ikas'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">{{ ikasBilgilendirme }}</b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Kategorisi</b-col>
                          <b-col cols="9">{{ ikasKategori }}</b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Satış Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="ikasSatisFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Piyasa Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="ikasPiyasaFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px"
                            >Gönderilecek Adet</b-col
                          >
                          <b-col cols="9">
                            <vs-input v-model="ikasGonderilecekAdet" />
                          </b-col>
                        </b-row>

                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('Ikas')"
                              style="border-radius: 5px"
                              type="gradient"
                              :disabled="validateIkasListeyeEkle"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              >Listeye Ekle</vs-button
                            >
                            <vs-button
                              @click="ikasGonder()"
                              type="gradient"
                              color="danger"
                              style="border-radius: 5px"
                              >Ikas Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              color="success"
                              type="gradient"
                              style="border-radius: 5px"
                              >Özellik Eşleştir</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>
                    <b-col
                      cols="6"
                      v-if="ikasBilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>

                  <vs-table :data="ikasAltUrunListesi">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>Özellik</vs-th>
                      <vs-th>Alt Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].Barkod }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].beden }} - {{ data[indextr].renk }} -
                          {{ data[indextr].cinsiyet }}
                        </vs-td>
                        <vs-td>
                          <span v-if="data[indextr].eslesmeDurumu == '2'">
                            Ürün Ikas Gönderilmiş (
                            {{ data[indextr].eklenmeDurumu }} )
                          </span>
                          <span v-if="data[indextr].eslesmeDurumu == '1'">
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="altListedenKaldir('Ikas', data[indextr].stokKodu)"
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>
                          <span v-if="urunEklenmeDurumu == 'anaUrun'">
                            <span v-if="data[indextr].eslesmeDurumu == '-1'">
                              <vs-button
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'Ikas',
                                    data[indextr].stokKodu,
                                    data[indextr].StokAdi,
                                    data[indextr].Barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    0,
                                    '',
                                    0,
                                    '',
                                    data[indextr].ortakKod,
                                    ''
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                            </span>
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>

                <span v-if="dEklenmeDurumu == 'anaUrun'">
                  <span style="font-weight: bold">İlişkili Ürünler</span>
                  <span style="font-weight: bold"
                    ><vs-input
                      class="inputx"
                      placeholder="Stok Kodu & Barkod"
                      @keyup.enter="iliskiliUrunAra('Ikas')"
                      :ref="iliskiliUrunB"
                      v-model="iliskiliUrunB"
                  /></span>
                  <vs-table :data="anaUrunListesiIkas">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>İlişkili Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>

                        <vs-td>
                          <span v-if="dBarkod != boslukTemizle(data[indextr].barkod)">
                            <vs-button
                              @click="
                                iliskiliUrunGonder('Ikas', dBarkod, data[indextr].barkod)
                              "
                              color="red"
                              type="filled"
                              >İlişkili Ürün Gönder</vs-button
                            >
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
              </div>
            </div>
            <div v-if="tabval.name == 'Azall'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">{{ AzallBilgilendirme }}</b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Kategorisi</b-col>
                          <b-col cols="9">{{ AzallKategori }}</b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Satış Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="AzallSatisFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Piyasa Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="AzallPiyasaFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px"
                            >Gönderilecek Adet</b-col
                          >
                          <b-col cols="9">
                            <vs-input v-model="AzallGonderilecekAdet" />
                          </b-col>
                        </b-row>

                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('Azall')"
                              type="gradient"
                              style="border-radius: 5px"
                              :disabled="validateAzallListeyeEkle"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              >Listeye Ekle</vs-button
                            >

                            <vs-button
                              @click="AzallGonder()"
                              type="gradient"
                              color="danger"
                              style="border-radius: 5px"
                              >Azall Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              color="success"
                              type="gradient"
                              style="border-radius: 5px"
                              >Özellik Eşleştir</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>
                    <b-col
                      cols="6"
                      v-if="AzallBilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>

                  <table>
                    <tr>
                      <td colspan="2">{{ AzallDurumMesaji }}</td>
                    </tr>
                  </table>

                  <vs-table :data="AzallAltUrunListesi">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>Özellik</vs-th>
                      <vs-th>Alt Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].Barkod }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].beden }} - {{ data[indextr].renk }} -
                          {{ data[indextr].cinsiyet }}
                        </vs-td>
                        <vs-td>
                          <span v-if="data[indextr].eslesmeDurumu == '2'">
                            Ürün Azall Gönderilmiş (
                            {{ data[indextr].eklenmeDurumu }} )
                          </span>
                          <span v-if="data[indextr].eslesmeDurumu == '1'">
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="altListedenKaldir('Azall', data[indextr].stokKodu)"
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>
                          <span v-if="urunEklenmeDurumu == 'anaUrun'">
                            <span v-if="data[indextr].eslesmeDurumu == '-1'">
                              <vs-button
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'Azall',
                                    data[indextr].stokKodu,
                                    data[indextr].StokAdi,
                                    data[indextr].Barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    data[indextr].pazaryeriId,
                                    '',
                                    0,
                                    '',
                                    data[indextr].ortakKod,
                                    data[indextr].pazaryeriCode
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                            </span>
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>

                <span v-if="dEklenmeDurumu == 'anaUrun'">
                  <span style="font-weight: bold">İlişkili Ürünler</span>
                  <span style="font-weight: bold"
                    ><vs-input
                      class="inputx"
                      placeholder="Stok Kodu & Barkod"
                      @keyup.enter="iliskiliUrunAra('Azall')"
                      :ref="iliskiliUrunB"
                      v-model="iliskiliUrunB"
                  /></span>
                  <vs-table :data="anaUrunListesiAzall">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>İlişkili Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>

                        <vs-td>
                          <span v-if="dBarkod != boslukTemizle(data[indextr].barkod)">
                            <vs-button
                              @click="
                                iliskiliUrunGonder('Azall', dBarkod, data[indextr].barkod)
                              "
                              color="red"
                              type="filled"
                              >İlişkili Ürün Gönder</vs-button
                            >
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
              </div>
            </div>
            <div v-if="tabval.name == 'Pazarama'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">{{
                      pazaramaBilgilendirme
                    }}</b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Kategorisi</b-col>
                          <b-col cols="9">{{ pazaramaKategori }}</b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Satış Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="pazaramaSatisFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Piyasa Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="pazaramaPiyasaFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px"
                            >Gönderilecek Adet</b-col
                          >
                          <b-col cols="9">
                            <vs-input v-model="pazaramaGonderilecekAdet" />
                          </b-col>
                        </b-row>

                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('Pazarama')"
                              style="border-radius: 5px"
                              type="gradient"
                              :disabled="validatePazaramaListeyeEkle"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              >Listeye Ekle</vs-button
                            >
                            <vs-button
                              @click="pazaramaGonder()"
                              type="gradient"
                              color="danger"
                              style="border-radius: 5px"
                              >Pazarama Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              color="success"
                              type="gradient"
                              style="border-radius: 5px"
                              >Özellik Eşleştir</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>
                    <b-col
                      cols="6"
                      v-if="pazaramaBilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>

                  <vs-table :data="pazaramaAltUrunListesi">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>Özellik</vs-th>
                      <vs-th>Alt Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].Barkod }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].beden }} - {{ data[indextr].renk }} -
                          {{ data[indextr].cinsiyet }}
                        </vs-td>
                        <vs-td>
                          <span v-if="data[indextr].eslesmeDurumu == '2'">
                            Ürün Pazarama Gönderilmiş (
                            {{ data[indextr].eklenmeDurumu }} )
                          </span>
                          <span v-if="data[indextr].eslesmeDurumu == '1'">
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="
                                altListedenKaldir('Pazarama', data[indextr].stokKodu)
                              "
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>
                          <span v-if="urunEklenmeDurumu == 'anaUrun'">
                            <span v-if="data[indextr].eslesmeDurumu == '-1'">
                              <vs-button
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'Pazarama',
                                    data[indextr].stokKodu,
                                    data[indextr].StokAdi,
                                    data[indextr].Barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    0,
                                    '',
                                    0,
                                    '',
                                    data[indextr].ortakKod,
                                    ''
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                            </span>
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>

                <span v-if="dEklenmeDurumu == 'anaUrun'">
                  <span style="font-weight: bold">İlişkili Ürünler</span>
                  <span style="font-weight: bold"
                    ><vs-input
                      class="inputx"
                      placeholder="Stok Kodu & Barkod"
                      @keyup.enter="iliskiliUrunAra('Pazarama')"
                      :ref="iliskiliUrunB"
                      v-model="iliskiliUrunB"
                  /></span>
                  <vs-table :data="anaUrunListesiPazarama">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>İlişkili Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>

                        <vs-td>
                          <span v-if="dBarkod != boslukTemizle(data[indextr].barkod)">
                            <vs-button
                              @click="
                                iliskiliUrunGonder(
                                  'Pazarama',
                                  dBarkod,
                                  data[indextr].barkod
                                )
                              "
                              color="red"
                              type="filled"
                              >İlişkili Ürün Gönder</vs-button
                            >
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
              </div>
            </div>
            <div v-if="tabval.name == 'PhpWebServis'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">{{
                      PhpWebServisBilgilendirme
                    }}</b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Kategorisi</b-col>
                          <b-col cols="9">{{ PhpWebServisKategori }}</b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Satış Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="PhpWebServisSatisFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Piyasa Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="PhpWebServisPiyasaFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px"
                            >Gönderilecek Adet</b-col
                          >
                          <b-col cols="9">
                            <vs-input v-model="PhpWebServisGonderilecekAdet" />
                          </b-col>
                        </b-row>

                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('PhpWebServis')"
                              style="border-radius: 5px"
                              type="gradient"
                              :disabled="validatePhpWebServisListeyeEkle"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              >Listeye Ekle</vs-button
                            >
                            <vs-button
                              @click="PhpWebServisGonder()"
                              type="gradient"
                              color="danger"
                              style="border-radius: 5px"
                              >PhpWebServis Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              color="success"
                              type="gradient"
                              style="border-radius: 5px"
                              >Özellik Eşleştir</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>
                    <b-col
                      cols="6"
                      v-if="PhpWebServisBilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>

                  <vs-table :data="PhpWebServisAltUrunListesi">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>Özellik</vs-th>
                      <vs-th>Alt Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].Barkod }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].beden }} - {{ data[indextr].renk }} -
                          {{ data[indextr].cinsiyet }}
                        </vs-td>
                        <vs-td>
                          <span v-if="data[indextr].eslesmeDurumu == '2'">
                            Ürün PhpWebServis Gönderilmiş (
                            {{ data[indextr].eklenmeDurumu }} )
                          </span>
                          <span v-if="data[indextr].eslesmeDurumu == '1'">
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="
                                altListedenKaldir('PhpWebServis', data[indextr].stokKodu)
                              "
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>
                          <span v-if="urunEklenmeDurumu == 'anaUrun'">
                            <span v-if="data[indextr].eslesmeDurumu == '-1'">
                              <vs-button
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'PhpWebServis',
                                    data[indextr].stokKodu,
                                    data[indextr].StokAdi,
                                    data[indextr].Barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    0,
                                    '',
                                    0,
                                    '',
                                    data[indextr].ortakKod,
                                    ''
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                            </span>
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>

                <span v-if="dEklenmeDurumu == 'anaUrun'">
                  <span style="font-weight: bold">İlişkili Ürünler</span>
                  <span style="font-weight: bold"
                    ><vs-input
                      class="inputx"
                      placeholder="Stok Kodu & Barkod"
                      @keyup.enter="iliskiliUrunAra('PhpWebServis')"
                      :ref="iliskiliUrunB"
                      v-model="iliskiliUrunB"
                  /></span>
                  <vs-table :data="anaUrunListesiPhpWebServis">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>İlişkili Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>

                        <vs-td>
                          <span v-if="dBarkod != boslukTemizle(data[indextr].barkod)">
                            <vs-button
                              @click="
                                iliskiliUrunGonder(
                                  'PhpWebServis',
                                  dBarkod,
                                  data[indextr].barkod
                                )
                              "
                              color="red"
                              type="filled"
                              >İlişkili Ürün Gönder</vs-button
                            >
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
              </div>
            </div>
            <div v-if="tabval.name == 'Ideasoft'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">{{
                      ideasoftBilgilendirme
                    }}</b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Kategorisi</b-col>
                          <b-col cols="9">{{ ideasoftKategori }}</b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Satış Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="ideasoftSatisFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Piyasa Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="ideasoftPiyasaFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px"
                            >Gönderilecek Adet</b-col
                          >
                          <b-col cols="9">
                            <vs-input v-model="ideasoftGonderilecekAdet" />
                          </b-col>
                        </b-row>

                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('Ideasoft')"
                              style="border-radius: 5px"
                              type="gradient"
                              :disabled="validateIdeasoftListeyeEkle"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              >Listeye Ekle</vs-button
                            >
                            <vs-button
                              @click="ideasoftGonder()"
                              type="gradient"
                              color="danger"
                              style="border-radius: 5px"
                              >Ideasoft Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              color="success"
                              type="gradient"
                              style="border-radius: 5px"
                              >Özellik Eşleştir</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>
                    <b-col
                      cols="6"
                      v-if="ideasoftBilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>

                  <vs-table :data="ideasoftAltUrunListesi">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>Özellik</vs-th>
                      <vs-th>Alt Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].Barkod }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].beden }} - {{ data[indextr].renk }} -
                          {{ data[indextr].cinsiyet }}
                        </vs-td>
                        <vs-td>
                          <span v-if="data[indextr].eslesmeDurumu == '2'">
                            Ürün Ideasoft Gönderilmiş (
                            {{ data[indextr].eklenmeDurumu }} )
                          </span>
                          <span v-if="data[indextr].eslesmeDurumu == '1'">
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="
                                altListedenKaldir('Ideasoft', data[indextr].stokKodu)
                              "
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>
                          <span v-if="urunEklenmeDurumu == 'anaUrun'">
                            <span v-if="data[indextr].eslesmeDurumu == '-1'">
                              <vs-button
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'Ideasoft',
                                    data[indextr].stokKodu,
                                    data[indextr].StokAdi,
                                    data[indextr].Barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    0,
                                    '',
                                    0,
                                    '',
                                    data[indextr].ortakKod,
                                    ''
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                            </span>
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>

                <span v-if="dEklenmeDurumu == 'anaUrun'">
                  <span style="font-weight: bold">İlişkili Ürünler</span>
                  <span style="font-weight: bold"
                    ><vs-input
                      class="inputx"
                      placeholder="Stok Kodu & Barkod"
                      @keyup.enter="iliskiliUrunAra('Ideasoft')"
                      :ref="iliskiliUrunB"
                      v-model="iliskiliUrunB"
                  /></span>
                  <vs-table :data="anaUrunListesiIdeasoft">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>İlişkili Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>

                        <vs-td>
                          <span v-if="dBarkod != boslukTemizle(data[indextr].barkod)">
                            <vs-button
                              @click="
                                iliskiliUrunGonder(
                                  'Ideasoft',
                                  dBarkod,
                                  data[indextr].barkod
                                )
                              "
                              color="red"
                              type="filled"
                              >İlişkili Ürün Gönder</vs-button
                            >
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
              </div>
            </div>
            <div v-if="tabval.name == 'Etsy'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">{{ etsyBilgilendirme }}</b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Kategorisi</b-col>
                          <b-col cols="9">{{ etsyKategori }}</b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Satış Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="etsySatisFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Piyasa Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="etsyPiyasaFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px"
                            >Gönderilecek Adet</b-col
                          >
                          <b-col cols="9">
                            <vs-input v-model="etsyGonderilecekAdet" />
                          </b-col>
                        </b-row>

                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('Etsy')"
                              style="border-radius: 5px"
                              type="gradient"
                              :disabled="validateEtsyListeyeEkle"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              >Listeye Ekle</vs-button
                            >
                            <vs-button
                              @click="etsyGonder()"
                              type="gradient"
                              color="danger"
                              style="border-radius: 5px"
                              >Etsy Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              color="success"
                              type="gradient"
                              style="border-radius: 5px"
                              >Özellik Eşleştir</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>
                    <b-col
                      cols="6"
                      v-if="etsyBilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>

                  <vs-table :data="etsyAltUrunListesi">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>Özellik</vs-th>
                      <vs-th>Alt Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].Barkod }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].beden }} - {{ data[indextr].renk }} -
                          {{ data[indextr].cinsiyet }}
                        </vs-td>
                        <vs-td>
                          <span v-if="data[indextr].eslesmeDurumu == '2'">
                            Ürün Etsy Gönderilmiş (
                            {{ data[indextr].eklenmeDurumu }} )
                          </span>
                          <span v-if="data[indextr].eslesmeDurumu == '1'">
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="altListedenKaldir('Etsy', data[indextr].stokKodu)"
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>
                          <span v-if="urunEklenmeDurumu == 'anaUrun'">
                            <span v-if="data[indextr].eslesmeDurumu == '-1'">
                              <vs-button
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'Etsy',
                                    data[indextr].stokKodu,
                                    data[indextr].StokAdi,
                                    data[indextr].Barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    0,
                                    '',
                                    0,
                                    '',
                                    data[indextr].ortakKod,
                                    ''
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                            </span>
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>

                <span v-if="dEklenmeDurumu == 'anaUrun'">
                  <span style="font-weight: bold">İlişkili Ürünler</span>
                  <span style="font-weight: bold"
                    ><vs-input
                      class="inputx"
                      placeholder="Stok Kodu & Barkod"
                      @keyup.enter="iliskiliUrunAra('Etsy')"
                      :ref="iliskiliUrunB"
                      v-model="iliskiliUrunB"
                  /></span>
                  <vs-table :data="anaUrunListesiEtsy">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>İlişkili Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>

                        <vs-td>
                          <span v-if="dBarkod != boslukTemizle(data[indextr].barkod)">
                            <vs-button
                              @click="
                                iliskiliUrunGonder('Etsy', dBarkod, data[indextr].barkod)
                              "
                              color="red"
                              type="filled"
                              >İlişkili Ürün Gönder</vs-button
                            >
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
              </div>
            </div>
            <div v-if="tabval.name == 'Ozon'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">{{ ozonBilgilendirme }}</b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Kategorisi</b-col>
                          <b-col cols="9">{{ ozonKategori }}</b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Satış Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="ozonSatisFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Piyasa Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="ozonPiyasaFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px"
                            >Gönderilecek Adet</b-col
                          >
                          <b-col cols="9">
                            <vs-input v-model="ozonGonderilecekAdet" />
                          </b-col>
                        </b-row>

                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('Ozon')"
                              style="border-radius: 5px"
                              type="gradient"
                              :disabled="validateOzonListeyeEkle"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              >Listeye Ekle</vs-button
                            >
                            <vs-button
                              @click="ozonGonder()"
                              type="gradient"
                              color="danger"
                              style="border-radius: 5px"
                              >Ozon Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              color="success"
                              type="gradient"
                              style="border-radius: 5px"
                              >Özellik Eşleştir</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>
                    <b-col
                      cols="6"
                      v-if="ozonBilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>

                  <vs-table :data="ozonAltUrunListesi">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>Özellik</vs-th>
                      <vs-th>Alt Ürün Ekle</vs-th>
                      <vs-th>Eşle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].Barkod }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].beden }} - {{ data[indextr].renk }} -
                          {{ data[indextr].cinsiyet }}
                        </vs-td>
                        <vs-td>
                          <span v-if="data[indextr].eslesmeDurumu == '2'">
                            Ürün Ozon Gönderilmiş (
                            {{ data[indextr].eklenmeDurumu }} )
                          </span>
                          <span v-if="data[indextr].eslesmeDurumu == '1'">
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="altListedenKaldir('Ozon', data[indextr].stokKodu)"
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>
                          <span v-if="urunEklenmeDurumu == 'anaUrun'">
                            <span v-if="data[indextr].eslesmeDurumu == '-1'">
                              <vs-button
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'Ozon',
                                    data[indextr].stokKodu,
                                    data[indextr].StokAdi,
                                    data[indextr].Barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    0,
                                    '',
                                    0,
                                    '',
                                    data[indextr].ortakKod,
                                    ''
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                            </span>
                          </span>
                        </vs-td>
                        <vs-td>
                          <vs-button
                            @click="
                              ozellikEsleme2(
                                'liste',
                                data[indextr].stokKodu,
                                data[indextr].Barkod
                              )
                            "
                            color="success"
                            type="gradient"
                            >Özellik Eşle</vs-button
                          >
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>

                <span v-if="dEklenmeDurumu == 'anaUrun'">
                  <span style="font-weight: bold">İlişkili Ürünler</span>
                  <span style="font-weight: bold"
                    ><vs-input
                      class="inputx"
                      placeholder="Stok Kodu & Barkod"
                      @keyup.enter="iliskiliUrunAra('Ozon')"
                      :ref="iliskiliUrunB"
                      v-model="iliskiliUrunB"
                  /></span>
                  <vs-table :data="anaUrunListesiOzon">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>İlişkili Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>

                        <vs-td>
                          <span v-if="dBarkod != boslukTemizle(data[indextr].barkod)">
                            <vs-button
                              @click="
                                iliskiliUrunGonder('Ozon', dBarkod, data[indextr].barkod)
                              "
                              color="red"
                              type="filled"
                              >İlişkili Ürün Gönder</vs-button
                            >
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
              </div>
            </div>
            <div v-if="tabval.name == 'AkinSoft'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">{{
                      akinSoftBilgilendirme
                    }}</b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Kategorisi</b-col>
                          <b-col cols="9">{{ akinSoftKategori }}</b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Satış Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="akinSoftSatisFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Piyasa Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="akinSoftPiyasaFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px"
                            >Gönderilecek Adet</b-col
                          >
                          <b-col cols="9">
                            <vs-input v-model="akinSoftGonderilecekAdet" />
                          </b-col>
                        </b-row>

                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('AkinSoft')"
                              style="border-radius: 5px"
                              type="gradient"
                              :disabled="validateAkinSoftListeyeEkle"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              >Listeye Ekle</vs-button
                            >
                            <vs-button
                              @click="akinSoftGonder()"
                              type="gradient"
                              color="danger"
                              style="border-radius: 5px"
                              >AkinSoft Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              color="success"
                              type="gradient"
                              style="border-radius: 5px"
                              >Özellik Eşleştir</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>
                    <b-col
                      cols="6"
                      v-if="akinSoftBilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>

                  <vs-table :data="akinSoftAltUrunListesi">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>Özellik</vs-th>
                      <vs-th>Alt Ürün Ekle</vs-th>
                      <vs-th>Eşle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].Barkod }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].beden }} - {{ data[indextr].renk }} -
                          {{ data[indextr].cinsiyet }}
                        </vs-td>
                        <vs-td>
                          <span v-if="data[indextr].eslesmeDurumu == '2'">
                            Ürün AkinSoft Gönderilmiş (
                            {{ data[indextr].eklenmeDurumu }} )
                          </span>
                          <span v-if="data[indextr].eslesmeDurumu == '1'">
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="
                                altListedenKaldir('AkinSoft', data[indextr].stokKodu)
                              "
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>
                          <span v-if="urunEklenmeDurumu == 'anaUrun'">
                            <span v-if="data[indextr].eslesmeDurumu == '-1'">
                              <vs-button
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'AkinSoft',
                                    data[indextr].stokKodu,
                                    data[indextr].StokAdi,
                                    data[indextr].Barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    0,
                                    '',
                                    0,
                                    '',
                                    data[indextr].ortakKod,
                                    ''
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                            </span>
                          </span>
                        </vs-td>
                        <vs-td>
                          <vs-button
                            @click="
                              ozellikEsleme2(
                                'liste',
                                data[indextr].stokKodu,
                                data[indextr].Barkod
                              )
                            "
                            color="success"
                            type="gradient"
                            >Özellik Eşle</vs-button
                          >
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>

                <span v-if="dEklenmeDurumu == 'anaUrun'">
                  <span style="font-weight: bold">İlişkili Ürünler</span>
                  <span style="font-weight: bold"
                    ><vs-input
                      class="inputx"
                      placeholder="Stok Kodu & Barkod"
                      @keyup.enter="iliskiliUrunAra('AkinSoft')"
                      :ref="iliskiliUrunB"
                      v-model="iliskiliUrunB"
                  /></span>
                  <vs-table :data="anaUrunListesiAkinSoft">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>İlişkili Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>

                        <vs-td>
                          <span v-if="dBarkod != boslukTemizle(data[indextr].barkod)">
                            <vs-button
                              @click="
                                iliskiliUrunGonder(
                                  'AkinSoft',
                                  dBarkod,
                                  data[indextr].barkod
                                )
                              "
                              color="red"
                              type="filled"
                              >İlişkili Ürün Gönder</vs-button
                            >
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
              </div>
            </div>
            <div v-if="tabval.name == 'Modanisa'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">{{
                      modanisaBilgilendirme
                    }}</b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Kategorisi</b-col>
                          <b-col cols="9">{{ modanisaKategori }}</b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Satış Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="modanisaSatisFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Piyasa Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="modanisaPiyasaFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px"
                            >Gönderilecek Adet</b-col
                          >
                          <b-col cols="9">
                            <vs-input v-model="modanisaGonderilecekAdet" />
                          </b-col>
                        </b-row>

                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('Modanisa')"
                              style="border-radius: 5px"
                              type="gradient"
                              :disabled="validateModanisaListeyeEkle"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              >Listeye Ekle</vs-button
                            >
                            <vs-button
                              @click="modanisaGonder()"
                              type="gradient"
                              color="danger"
                              style="border-radius: 5px"
                              >Modanisa Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              color="success"
                              type="gradient"
                              style="border-radius: 5px"
                              >Özellik Eşleştir</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>
                    <b-col
                      cols="6"
                      v-if="modanisaBilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>

                  <vs-table :data="modanisaAltUrunListesi">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>Özellik</vs-th>
                      <vs-th>Alt Ürün Ekle</vs-th>
                      <vs-th>Eşle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].Barkod }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].beden }} - {{ data[indextr].renk }} -
                          {{ data[indextr].cinsiyet }}
                        </vs-td>
                        <vs-td>
                          <span v-if="data[indextr].eslesmeDurumu == '2'">
                            Ürün Modanisa Gönderilmiş (
                            {{ data[indextr].eklenmeDurumu }} )
                          </span>
                          <span v-if="data[indextr].eslesmeDurumu == '1'">
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="
                                altListedenKaldir('Modanisa', data[indextr].stokKodu)
                              "
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>
                          <span v-if="urunEklenmeDurumu == 'anaUrun'">
                            <span v-if="data[indextr].eslesmeDurumu == '-1'">
                              <vs-button
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'Modanisa',
                                    data[indextr].stokKodu,
                                    data[indextr].StokAdi,
                                    data[indextr].Barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    0,
                                    '',
                                    0,
                                    '',
                                    data[indextr].ortakKod,
                                    ''
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                            </span>
                          </span>
                        </vs-td>
                        <vs-td>
                          <vs-button
                            @click="
                              ozellikEsleme2(
                                'liste',
                                data[indextr].stokKodu,
                                data[indextr].Barkod
                              )
                            "
                            color="success"
                            type="gradient"
                            >Özellik Eşle</vs-button
                          >
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>

                <span v-if="dEklenmeDurumu == 'anaUrun'">
                  <span style="font-weight: bold">İlişkili Ürünler</span>
                  <span style="font-weight: bold"
                    ><vs-input
                      class="inputx"
                      placeholder="Stok Kodu & Barkod"
                      @keyup.enter="iliskiliUrunAra('Modanisa')"
                      :ref="iliskiliUrunB"
                      v-model="iliskiliUrunB"
                  /></span>
                  <vs-table :data="anaUrunListesiModanisa">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>İlişkili Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>

                        <vs-td>
                          <span v-if="dBarkod != boslukTemizle(data[indextr].barkod)">
                            <vs-button
                              @click="
                                iliskiliUrunGonder(
                                  'Modanisa',
                                  dBarkod,
                                  data[indextr].barkod
                                )
                              "
                              color="red"
                              type="filled"
                              >İlişkili Ürün Gönder</vs-button
                            >
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
              </div>
            </div>
            <div v-if="tabval.name == 'Opencart'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">{{
                      opencartBilgilendirme
                    }}</b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Kategorisi</b-col>
                          <b-col cols="9">{{ opencartKategori }}</b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Satış Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="opencartSatisFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Piyasa Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="opencartPiyasaFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px"
                            >Gönderilecek Adet</b-col
                          >
                          <b-col cols="9">
                            <vs-input v-model="opencartGonderilecekAdet" />
                          </b-col>
                        </b-row>

                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('Opencart')"
                              style="border-radius: 5px"
                              type="gradient"
                              :disabled="validateOpencartListeyeEkle"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              >Listeye Ekle</vs-button
                            >
                            <vs-button
                              @click="opencartGonder()"
                              type="gradient"
                              color="danger"
                              style="border-radius: 5px"
                              >Opencart Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              color="success"
                              type="gradient"
                              style="border-radius: 5px"
                              >Özellik Eşleştir</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>
                    <b-col
                      cols="6"
                      v-if="opencartBilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>

                  <vs-table :data="opencartAltUrunListesi">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>Özellik</vs-th>
                      <vs-th>Alt Ürün Ekle</vs-th>
                      <vs-th>Eşle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].Barkod }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].beden }} - {{ data[indextr].renk }} -
                          {{ data[indextr].cinsiyet }}
                        </vs-td>
                        <vs-td>
                          <span v-if="data[indextr].eslesmeDurumu == '2'">
                            Ürün Opencart Gönderilmiş (
                            {{ data[indextr].eklenmeDurumu }} )
                          </span>
                          <span v-if="data[indextr].eslesmeDurumu == '1'">
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="
                                altListedenKaldir('Opencart', data[indextr].stokKodu)
                              "
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>
                          <span v-if="urunEklenmeDurumu == 'anaUrun'">
                            <span v-if="data[indextr].eslesmeDurumu == '-1'">
                              <vs-button
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'Opencart',
                                    data[indextr].stokKodu,
                                    data[indextr].StokAdi,
                                    data[indextr].Barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    0,
                                    '',
                                    0,
                                    '',
                                    data[indextr].ortakKod,
                                    ''
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                            </span>
                          </span>
                        </vs-td>
                        <vs-td>
                          <vs-button
                            @click="
                              ozellikEsleme2(
                                'liste',
                                data[indextr].stokKodu,
                                data[indextr].Barkod
                              )
                            "
                            color="success"
                            type="gradient"
                            >Özellik Eşle</vs-button
                          >
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>

                <span v-if="dEklenmeDurumu == 'anaUrun'">
                  <span style="font-weight: bold">İlişkili Ürünler</span>
                  <span style="font-weight: bold"
                    ><vs-input
                      class="inputx"
                      placeholder="Stok Kodu & Barkod"
                      @keyup.enter="iliskiliUrunAra('Opencart')"
                      :ref="iliskiliUrunB"
                      v-model="iliskiliUrunB"
                  /></span>
                  <vs-table :data="anaUrunListesiOpencart">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>İlişkili Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>

                        <vs-td>
                          <span v-if="dBarkod != boslukTemizle(data[indextr].barkod)">
                            <vs-button
                              @click="
                                iliskiliUrunGonder(
                                  'Opencart',
                                  dBarkod,
                                  data[indextr].barkod
                                )
                              "
                              color="red"
                              type="filled"
                              >İlişkili Ürün Gönder</vs-button
                            >
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
              </div>
            </div>
            <div v-if="tabval.name == 'Allesgo'">
              <div class="con-tab-ejemplo">
                <span>
                  <b-row>
                    <b-col cols="12" style="color: red">{{ allesgoBilgilendirme }}</b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Kategorisi</b-col>
                          <b-col cols="9">{{ allesgoKategori }}</b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Satış Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="allesgoSatisFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px">Piyasa Fiyatı</b-col>
                          <b-col cols="9">
                            <vs-input v-model="allesgoPiyasaFiyati" />
                          </b-col>
                        </b-row>
                        <b-row align-v="center">
                          <b-col cols="3" style="font-size: 15px"
                            >Gönderilecek Adet</b-col
                          >
                          <b-col cols="9">
                            <vs-input v-model="allesgoGonderilecekAdet" />
                          </b-col>
                        </b-row>

                        <div slot="footer" style="margin-top: 40px">
                          <vs-row vs-justify="flex-end">
                            <vs-button
                              @click="gonderimListesineEkle('Allesgo')"
                              style="border-radius: 5px"
                              type="gradient"
                              :disabled="validateAllesgoListeyeEkle"
                              id="button-with-loading-listeyeekle"
                              class="vs-con-loading__container"
                              >Listeye Ekle</vs-button
                            >
                            <vs-button
                              @click="allesgoGonder()"
                              type="gradient"
                              color="danger"
                              style="border-radius: 5px"
                              >Allesgo Gönder</vs-button
                            >
                            <vs-button
                              @click="ozellikEsleme2()"
                              color="success"
                              type="gradient"
                              style="border-radius: 5px"
                              >Özellik Eşleştir</vs-button
                            >
                          </vs-row>
                        </div>
                      </vs-card>
                    </b-col>
                    <b-col
                      cols="6"
                      v-if="allesgoBilgilendirme != 'Eşleşen Kategori Bulunamadı'"
                    >
                      <vs-card
                        v-if="
                          validatedAlan1 == false ||
                          validatedAlan2 == false ||
                          validatedAlan3 == false ||
                          validatedAlan4 == false ||
                          validatedAlan5 == false ||
                          validatedAlan6 == false ||
                          validatedAlan7 == false ||
                          validatedAlan8 == false ||
                          validatedAlan9 == false ||
                          validatedAlan10 == false
                        "
                      >
                        <div slot="header">
                          <h3>Detay</h3>
                        </div>
                        <b-row :hidden="validatedAlan1">
                          <b-col>{{ alan1Ad }}</b-col>
                          <b-col>{{ alan1Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan2">
                          <b-col>{{ alan2Ad }}</b-col>
                          <b-col> {{ alan2Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan3">
                          <b-col>{{ alan3Ad }}</b-col>
                          <b-col>{{ alan3Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan4">
                          <b-col> {{ alan4Ad }} </b-col>
                          <b-col> {{ alan4Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan5">
                          <b-col>{{ alan5Ad }}</b-col>
                          <b-col>{{ alan5Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan6">
                          <b-col>{{ alan6Ad }}</b-col>
                          <b-col> {{ alan6Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan7">
                          <b-col> {{ alan7Ad }} </b-col>
                          <b-col> {{ alan7Deger }} </b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan8">
                          <b-col>{{ alan8Ad }}</b-col>
                          <b-col>{{ alan8Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan9">
                          <b-col>{{ alan9Ad }}</b-col>
                          <b-col>{{ alan9Deger }}</b-col>
                        </b-row>
                        <b-row :hidden="validatedAlan10">
                          <b-col>{{ alan10Ad }}</b-col>
                          <b-col> {{ alan10Deger }}</b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>

                  <vs-table :data="allesgoAltUrunListesi">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>Özellik</vs-th>
                      <vs-th>Alt Ürün Ekle</vs-th>
                      <vs-th>Eşle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].Barkod }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].beden }} - {{ data[indextr].renk }} -
                          {{ data[indextr].cinsiyet }}
                        </vs-td>
                        <vs-td>
                          <span v-if="data[indextr].eslesmeDurumu == '2'">
                            Ürün Allesgo Gönderilmiş (
                            {{ data[indextr].eklenmeDurumu }} )
                          </span>
                          <span v-if="data[indextr].eslesmeDurumu == '1'">
                            <vs-button
                              v-bind:id="'cikar' + data[indextr].stokKodu"
                              @click="
                                altListedenKaldir('Allesgo', data[indextr].stokKodu)
                              "
                              color="red"
                              type="filled"
                              >Listeden Kaldır</vs-button
                            >
                          </span>
                          <span v-if="urunEklenmeDurumu == 'anaUrun'">
                            <span v-if="data[indextr].eslesmeDurumu == '-1'">
                              <vs-button
                                v-bind:id="'ekle' + data[indextr].stokKodu"
                                @click="
                                  altGonderimListesineEkle(
                                    'Allesgo',
                                    data[indextr].stokKodu,
                                    data[indextr].StokAdi,
                                    data[indextr].Barkod,
                                    data[indextr].stokAdet,
                                    data[indextr].alan1,
                                    data[indextr].alan2,
                                    data[indextr].alan3,
                                    data[indextr].alan4,
                                    data[indextr].alan5,
                                    data[indextr].alan6,
                                    data[indextr].alan7,
                                    data[indextr].alan8,
                                    data[indextr].alan9,
                                    data[indextr].alan10,
                                    data[indextr].renk,
                                    data[indextr].beden,
                                    data[indextr].SATIS_FIAT1,
                                    data[indextr].stokAdet,
                                    data[indextr].SATIS_FIAT1,
                                    0,
                                    0,
                                    '',
                                    0,
                                    '',
                                    data[indextr].ortakKod,
                                    ''
                                  )
                                "
                                color="success"
                                type="filled"
                                >Alt Ürün Ekle</vs-button
                              >
                            </span>
                          </span>
                        </vs-td>
                        <vs-td>
                          <vs-button
                            @click="
                              ozellikEsleme2(
                                'liste',
                                data[indextr].stokKodu,
                                data[indextr].Barkod
                              )
                            "
                            color="success"
                            type="gradient"
                            >Özellik Eşle</vs-button
                          >
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>

                <span v-if="dEklenmeDurumu == 'anaUrun'">
                  <span style="font-weight: bold">İlişkili Ürünler</span>
                  <span style="font-weight: bold"
                    ><vs-input
                      class="inputx"
                      placeholder="Stok Kodu & Barkod"
                      @keyup.enter="iliskiliUrunAra('Allesgo')"
                      :ref="iliskiliUrunB"
                      v-model="iliskiliUrunB"
                  /></span>
                  <vs-table :data="anaUrunListesiAllesgo">
                    <template slot="thead">
                      <vs-th>Ürün Kodu</vs-th>
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Barkod</vs-th>
                      <vs-th>İlişkili Ürün Ekle</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ data[indextr].stokKodu }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].stokAdi }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].barkod }}
                        </vs-td>

                        <vs-td>
                          <span v-if="dBarkod != boslukTemizle(data[indextr].barkod)">
                            <vs-button
                              @click="
                                iliskiliUrunGonder(
                                  'Allesgo',
                                  dBarkod,
                                  data[indextr].barkod
                                )
                              "
                              color="red"
                              type="filled"
                              >İlişkili Ürün Gönder</vs-button
                            >
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </span>
              </div>
            </div>
          </vs-tab>

          <!-- <vs-tab label="İdeasoft">
            <div class="con-tab-ejemplo">
              <span> ....</span>
            </div>
          </vs-tab>

          <vs-tab label="H-ticaret">
            <div class="con-tab-ejemplo">
              <span>Macaroon ....</span>
            </div>
          </vs-tab>-->
        </vs-tabs>

        <vs-popup title="N11 Gönderilecek Katalog Seçimi" :active.sync="popupStokAktar">
          <b-row align-h="center">
            <b-col cols="12" md="auto">
              <h5 style="color: red">Stok Kart Bilgisi</h5>
            </b-col>
            <b-col cols="12" md="auto">
              {{ StokKartDetayOzellikleri }}
            </b-col>
          </b-row>
          <StokAktarComponent ref="stokAktarPopup" :StokAktarList="StokAktarList" />
        </vs-popup>
      </template>
    </vs-popup>

    <vs-prompt
      title="Listenden Kaldırılacak Emin misiniz ?"
      acceptText="Sil"
      cancelText="Vazgeç"
      @click="ListedenKaldir('Ciceksepeti', dStokKodu)"
      :active.sync="activePrompt"
    >
    </vs-prompt>
    <b-modal
      ref="modal-resim"
      id="modal-primary"
      modal-class="modal-primary"
      size="sm"
      centered
      title="BootstrapVue"
      hide-footer
      hide-header
    >
      <img :src="imageLink" style="width: 100%" />
    </b-modal>
    <ReceteComponent ref="recetePopup" />
    <LogList
      :logOrderNumber="logOrderNumber"
      :isAktiveLogList="isAktiveLogList"
      :module="'Stock'"
      ref="getLogList"
    />
  </div>
</template>

<script>
import state from "../../store/state";
import Store from "../../store/store";
import vSelect from "vue-select";
import {
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import LogList from "../components/uzum-components/LogList.vue";
import ReceteComponent from "../components/uzum-components/stoklistesi-components/ReceteComponent.vue";
import StokAktarComponent from "../components/uzum-components/stoklistesi-components/StokAktarComponent.vue";
import TopluIslemComponent from "../components/uzum-components/stoklistesi-components/TopluIslemComponent.vue";
import ExcelYazdirButon from "../components/uzum-components/stoklistesi-components/ExcelYazdirButon.vue";
import { VueAutosuggest } from "vue-autosuggest";
export default {
  components: {
    LogList,
    StokAktarComponent,
    VueAutosuggest,
    ExcelYazdirButon,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    "v-select": vSelect,
    ReceteComponent,
    TopluIslemComponent,

    //  Component: require('components/component.vue'),
  },

  data() {
    return {
      logOrderNumber: "",
      isAktiveLogList: false,
      anaUrunListesiAkinSoft: [],
      ozellikEsleListeStokKodu: "",
      ozellikEsleListeBarkod: "",
      ozellikEsleListeFlag: false,
      imageLink: "",
      popupStokAktar: false,
      trendyolDesi: 0,
      hepsiburadaDesi: 0,
      colorAlert: "primary",
      titleAlert: "Alert",
      activeAlert: false,
      valueInput: "",
      imageBase64: "",
      suggestPazaryer: "",
      suggestKategoriId: "",
      query: "",
      filteredOptions: [],
      currentGelenPage: 0,
      pageLength: 50,
      KAYITSAYISI: 0,
      dir: false,
      rows: [],
      secilenStok: [],
      columns: [
        {
          label: "Stok Kodu",
          field: "stokKodu",
        },
        {
          label: "Barkod",
          field: "Barkod",
        },
        {
          label: "Stok Adı",
          field: "StokAdi",
        },
        {
          label: "Renk",
          field: "renk",
        },
        {
          label: "Satış Fiyat",
          field: "SATIS_FIAT1",
        },

        // {
        //   label: "Liste Fiyat",
        //   field: "LISTE_FIAT",
        // },
        {
          label: "Stok Adet",
          field: "stokAdet",
        },
        {
          label: "Pazaryeri",
          field: "pazaryeri",
        },
        {
          field: "action",
        },
        /*  {
          label: "Action",
          field: "action",
        },*/
      ],
      StokKartDetayOzellikleriListe: "",
      StokKartDetayOzellikleri: "",
      ozellikKategoriId: "",
      ozellikEslestirmeListesiData: [],
      ozellikOzellikleriData: [],
      dDurum: "",
      selectedO1: { attributeid: 0, attributeName: "Pazaryeri Başlıkları" },
      selectedO3: { valueId: 0, valueName: "Pazaryeri Özellikleri" },
      pazaryeriKategoriId: "",
      kategoriOzellikListesi: [],
      popupActiveSiparis2: false,
      GGKatalogId: "",
      HBKatalogId: "",
      imgURL: "",
      selectedN11UrunDurumu: "",
      ortakKodPn: "",
      N11KatalogId: "",
      N11yeniFiyat: 0,
      karOran: 0,
      kargoTutar: 0,
      hesaplananFiyat: "",
      karoranhesapla: 0,
      anaUrunListesiTicimax: [],
      anaUrunListesiTsoft: [],
      anaUrunListesiShopify: [],
      anaUrunListesiGittigidiyor: [],
      anaUrunListesiCiceksepeti: [],
      anaUrunListesiPlatinMarket: [],
      anaUrunListesiWoocommerce: [],
      anaUrunListesiIkas: [],
      anaUrunListesiOzon: [],
      anaUrunListesiPttAvm: [],
      anaUrunListesiPhpWebServis: [],
      anaUrunListesiPazarama: [],
      anaUrunListesiIdeasoft: [],
      anaUrunListesiEtsy: [],
      liste: [],
      gonderilenStokListesi: [],
      gonderilenStokListesiN11: [],
      gonderilenStokListesiHepsiburada: [],
      gonderilenStokListesiTicimax: [],
      stokResimListesi: [],
      ticimaxAltUrunListesi: [],
      trendyolAltUrunListesi: [],
      N11AltUrunListesi: [],
      WoocommerceAltUrunListesi: [],
      tsoftAltUrunListesi: [],
      gittigidiyorAltUrunListesi: [],
      PttAvmAltUrunListesi: [],
      AzallAltUrunListesi: [],
      platinmarketAltUrunListesi: [],
      ciceksepetiAltUrunListesi: [],
      HepsiburadaAltUrunListesi: [],
      ikasAltUrunListesi: [],
      ozonAltUrunListesi: [],
      modanisaAltUrunListesi: [],
      opencartAltUrunListesi: [],
      allesgoAltUrunListesi: [],
      akinSoftAltUrunListesi: [],
      pazaramaAltUrunListesi: [],
      ideasoftAltUrunListesi: [],
      etsyAltUrunListesi: [],

      PhpWebServisAltUrunListesi: [],

      shopifyAltUrunListesi: [],
      checkSelected: [],
      anaUrunListesiAzall: [],
      kod: "",
      Durum: false,
      AktifPazarYeriTanim: "",
      altUrunKodu: "",
      barkod: "",
      popupKartDetay: false,
      dStokAdi: "",
      dStokKodu: "",
      dBarkod: "",
      dRenk: "",
      dBeden: "",
      dDigerOzellikler: "",
      dDigerOzelliklerListe: "",
      dKategori: "",
      dSatisFiyat: 0,
      dPiyasaFiyat: 0,
      dStokAdet: 0,
      dKdv: 0,
      dTedarikci: "",
      dMarka: "",
      dParaBirim: "",
      dEklenmeDurumu: "",

      trendyolKategori: "",
      trendyolKategoriId: 0,
      trendyolSatisFiyati: 0,
      trendyolPiyasaFiyati: 0,
      trendyolGonderilecekAdet: 0,
      trendyolBilgilendirme: "",
      trendyolDurumMesaji: "",

      tsoftKategori: "",
      tsoftKategoriId: 0,
      tsoftSatisFiyati: 0,
      tsoftPiyasaFiyati: 0,
      tsoftGonderilecekAdet: 0,
      tsoftBilgilendirme: "",

      gittigidiyorKategori: "",
      gittigidiyorKategoriId: 0,
      gittigidiyorSatisFiyati: 0,
      gittigidiyorPiyasaFiyati: 0,
      gittigidiyorGonderilecekAdet: 0,
      gittigidiyorBilgilendirme: "",

      ciceksepetiKategori: "",
      ciceksepetiKategoriId: 0,
      ciceksepetiSatisFiyati: 0,
      ciceksepetiPiyasaFiyati: 0,
      ciceksepetiGonderilecekAdet: 0,
      ciceksepetiBilgilendirme: "",

      ikasKategori: "",
      ikasKategoriId: 0,
      ikasSatisFiyati: 0,
      ikasPiyasaFiyati: 0,
      ikasGonderilecekAdet: 0,
      ikasBilgilendirme: "",

      ozonKategori: "",
      ozonKategoriId: 0,
      ozonSatisFiyati: 0,
      ozonPiyasaFiyati: 0,
      ozonGonderilecekAdet: 0,
      ozonBilgilendirme: "",

      modanisaKategori: "",
      modanisaKategoriId: 0,
      modanisaSatisFiyati: 0,
      modanisaPiyasaFiyati: 0,
      modanisaGonderilecekAdet: 0,
      modanisaBilgilendirme: "",

      opencartKategori: "",
      opencartKategoriId: 0,
      opencartSatisFiyati: 0,
      opencartPiyasaFiyati: 0,
      opencartGonderilecekAdet: 0,
      opencartBilgilendirme: "",

      allesgoKategori: "",
      allesgoKategoriId: 0,
      allesgoSatisFiyati: 0,
      allesgoPiyasaFiyati: 0,
      allesgoGonderilecekAdet: 0,
      allesgoBilgilendirme: "",

      akinSoftKategori: "",
      akinSoftKategoriId: 0,
      akinSoftSatisFiyati: 0,
      akinSoftPiyasaFiyati: 0,
      akinSoftGonderilecekAdet: 0,
      akinSoftBilgilendirme: "",

      pazaramaKategori: "",
      pazaramaKategoriId: 0,
      pazaramaSatisFiyati: 0,
      pazaramaPiyasaFiyati: 0,
      pazaramaGonderilecekAdet: 0,
      pazaramaBilgilendirme: "",

      ideasoftKategori: "",
      ideasoftKategoriId: 0,
      ideasoftSatisFiyati: 0,
      ideasoftPiyasaFiyati: 0,
      ideasoftGonderilecekAdet: 0,
      ideasoftBilgilendirme: "",

      etsyKategori: "",
      etsyKategoriId: 0,
      etsySatisFiyati: 0,
      etsyPiyasaFiyati: 0,
      etsyGonderilecekAdet: 0,
      etsyBilgilendirme: "",

      PhpWebServisKategori: "",
      PhpWebServisKategoriId: 0,
      PhpWebServisSatisFiyati: 0,
      PhpWebServisPiyasaFiyati: 0,
      PhpWebServisGonderilecekAdet: 0,
      PhpWebServisBilgilendirme: "",

      platinmarketKategori: "",
      platinmarketKategoriId: 0,
      platinmarketSatisFiyati: 0,
      platinmarketPiyasaFiyati: 0,
      platinmarketGonderilecekAdet: 0,
      platinmarketBilgilendirme: "",

      WoocommerceKategori: "",
      WoocommerceKategoriId: 0,
      WoocommerceSatisFiyati: 0,
      WoocommercePiyasaFiyati: 0,
      WoocommerceGonderilecekAdet: 0,
      WoocommerceBilgilendirme: "",

      PttAvmKategori: "",
      PttAvmKategoriId: 0,
      PttAvmSatisFiyati: 0,
      PttAvmPiyasaFiyati: 0,
      PttAvmGonderilecekAdet: 0,
      PttAvmBilgilendirme: "",

      AzallBilgilendirme: "",
      AzallKategori: "",
      AzallKategoriId: 0,
      AzallSatisFiyati: 0,
      AzallPiyasaFiyati: 0,
      AzallGonderilecekAdet: 0,

      shopifyKategori: "",
      shopifyKategoriId: 0,
      shopifySatisFiyati: 0,
      shopifyPiyasaFiyati: 0,
      shopifyGonderilecekAdet: 0,
      shopifyBilgilendirme: "",

      n11Kategori: "",
      n11KategoriId: 0,
      n11SatisFiyati: 0,
      n11PiyasaFiyati: 0,
      n11GonderilecekAdet: 0,
      n11Bilgilendirme: "",
      n11DurumMesaji: "",
      WoocommerceDurumMesaji: "",
      PttAvmDurumMesaji: "",
      AzallDurumMesaji: "",
      hepsiburadaKategori: "",
      hepsiburadaKategoriId: 0,
      hepsiburadaSatisFiyati: 0,
      hepsiburadaPiyasaFiyati: 0,
      hepsiburadaGonderilecekAdet: 0,
      hepsiburadaBilgilendirme: "",
      ticimaxKategori: "",
      ticimaxKategoriId: 0,
      ticimaxSatisFiyati: 0,
      ticimaxPiyasaFiyati: 0,
      ticimaxGonderilecekAdet: 0,
      ticimaxBilgilendirme: "",
      alan1: "",
      alan2: "",
      alan3: "",
      alan4: "",
      alan5: "",
      alan6: "",
      alan7: "",
      alan8: "",
      alan9: "",
      alan10: "",
      alan1Pd: "",
      alan2Pd: "",
      alan3Pd: "",
      alan4Pd: "",
      alan5Pd: "",
      alan6Pd: "",
      alan7Pd: "",
      alan8Pd: "",
      alan9Pd: "",
      alan10Pd: "",
      ortakKod: "",
      ortakKodSayi: "",
      validatedAlan1: true,
      validatedAlan2: true,
      validatedAlan3: true,
      validatedAlan4: true,
      validatedAlan5: true,
      validatedAlan6: true,
      validatedAlan7: true,
      validatedAlan8: true,
      validatedAlan9: true,
      validatedAlan10: true,
      alan1Ad: "",
      alan2Ad: "",
      alan3Ad: "",
      alan4Ad: "",
      alan5Ad: "",
      alan6Ad: "",
      alan7Ad: "",
      alan8Ad: "",
      alan9Ad: "",
      alan10Ad: "",
      alan1Deger: "",
      alan2Deger: "",
      alan3Deger: "",
      alan4Deger: "",
      alan5Deger: "",
      alan6Deger: "",
      alan7Deger: "",
      alan8Deger: "",
      alan9Deger: "",
      alan10Deger: "",
      validatePhpWebServisListeyeEkle: true,
      validateOpencartListeyeEkle: true,
      validateModanisaListeyeEkle: true,
      validateTrendyolListeyeEkle: true,
      validateTrendyolGonder: true,
      validateTsoftListeyeEkle: true,
      validateTsoftGonder: true,
      validateGittigidiyorListeyeEkle: true,
      validateAzallListeyeEkle: true,
      validateGittigidiyorGonder: true,
      validatePttAvmGonder: true,
      validateCiceksepetiListeyeEkle: true,
      validateIkasListeyeEkle: true,
      validateOzonListeyeEkle: true,
      validateAkinSoftListeyeEkle: true,
      validateciceksepetiGonder: true,
      validatePlatinmarketListeyeEkle: true,
      validatePlatinmarketGonder: true,
      validateShopifyListeyeEkle: true,
      validateShopifyGonder: true,
      validateN11ListeyeEkle: true,
      validatePazaramaListeyeEkle: true,
      validateIdeasoftListeyeEkle: true,
      validateEtsyListeyeEkle: true,
      validateWoocommerceListeyeEkle: true,
      validatePttAvmListeyeEkle: true,
      validateN11Gonder: true,
      validateHepsiburadaListeyeEkle: true,
      validateHepsiburadaGonder: true,
      validateTicimaxListeyeEkle: true,
      validateTicimaxGonder: true,
      stokAciklama: "",
      activePrompt: false,
      resimAdi: "",
      anaStokKodu: "",
      urunEklenmeDurumu: "",
      ticimaxurunEklenmeDurumu: "",
      trendyolurunEklenmeDurumu: "",
      N11urunEklenmeDurumu: "",
      aktifPazaryeri: "",
      active_tab: 0,
      selectedN11TeslimatSablonu: "",
      selectedN11HazirlikSuresi: "",
      formatOptions: [
        { label: "Aktif ", id: "1" },
        { label: "Beklemede ", id: "2" },
        { label: "Yasaklı", id: "3" },
        { label: "Liste Dışı", id: "4" },
        { label: "Onay bekleyen", id: "5" },
        { label: "Reddedilen", id: "6" },
      ],
      optionsN11TeslimatSablonu: [],
      verilers: "",
      iliskiliUrunB: "",
      hepsiburadaGonderimHatasi: "",
      mesajHB: "",
      image: "",
      imageUrl: state.sistemAddress,
      tabList: [],
      datasuggest: [],
      suggestionattributeName: "",
      suggestionattributeid: "",
      datasuggeststok: [],
      listedenKaldirpazaryer: "",
      listedenKaldirstokkod: "",
      StokAktarList: [],
    };
  },
  created() {
    this.tabList = Store.state.uzum.menuListForTabs;
  },
  mounted() {
    //tables global olarak tanımlanıyor
    this.$root.$on("stokaktarpopup", () => {
      this.stokaktarpopup();
    });
  },
  beforeDestroy() {
    this.$root.$off("stokaktarpopup");
  },

  methods: {
    logListesiGetir(stockNo) {
      this.$refs.getLogList.getLogList(stockNo);
    },
    onInputChange(text) {
      if (text === "" || text === undefined) {
        return;
      }

      /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
      const filteredData = this.ozellikOzellikleriData.filter((item) => {
        return item.valueName.toLowerCase().indexOf(text.toLowerCase()) > -1;
      });

      this.filteredOptions = [
        {
          data: filteredData,
        },
      ];
    },
    onClick(event) {
      // alert("lalalala"+event)
      this.imageLink = this.sistemurl + event;
      this.$refs["modal-resim"].show();
    },
    stokaktarpopup() {
      this.popupStokAktar = false;
    },
    openAlert(color, pazaryeri, dStokKodu) {
      this.colorAlert = color || this.getColorRandom();
      this.listedenKaldirpazaryer = pazaryeri;
      this.listedenKaldirstokkod = dStokKodu;
      this.$vs.dialog({
        color: this.colorAlert,
        title: "Uyarı", //`Dialog - ${this.colorAlert}`,
        text: "Listenden Kaldırılacak Emin misiniz ?",
        acceptText: "Sil",
        accept: this.ListedenKaldir,
      });
    },

    getSuggestionValue(suggestion) {
      this.selectedO3 = {
        valueId: suggestion.item.valueId,
        valueName: suggestion.item.valueName,
      };
      this.ozellikOzellikListesi();

      return suggestion.item.valueName;
    },

    rowStyleClassFn(row) {
      return "VGT-row";
    },
    selectionChanged(params) {
      this.secilenStok = params.selectedRows;
    },

    recete(skod) {
      //  alert(skod)
      this.$refs.recetePopup.receteDetay(skod);
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    indexbul(array, conditionFn) {
      //console.log(array)
      const item = array.find(conditionFn);
      return array.indexOf(item);
    },
    ozellikeslestirmeSil(id, program, barkod) {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        id: id,
        pazaryeri: program.trim(),
        barkod: barkod.trim(),
        token: Store.state.tokenId,
      };

      console.log(args);
      soap.createClient(url, function (err, client) {
        client.eslesenStokOzellikleriListesiSil(args, function (err, result) {
          if (result.ozellikeslestirmeSilResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
        });
      });
      vm.ozellikEslemeListesi(program);
    },
    ozellikOzellikListesi() {
      this.ozellikOzellikleriData = this.ozellikOzellikleri.filter(
        (d) => d.attributeid === this.selectedO1.attributeid
      ); 
    },
    kategoriOzellikleri(pazaryeri, KategoriIdd) {
      this.suggestPazaryer = pazaryeri;
      this.suggestKategoriId = KategoriIdd;
      this.datasuggest = [];
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        pazaryeri: pazaryeri,
        token: Store.state.tokenId,
        categoryId: KategoriIdd,
      };
      console.log("pazaryeriKategoriOzellik");
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.pazaryeriKategoriOzellik(args, function (err, result) {
          if (result.pazaryeriKategoriOzellikResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.pazaryeriKategoriOzellikResult);

          vm.kategoriSuz = vm.veriler["json"];
          let ozellikler = vm.veriler["json"];
          //console.log(result.pazaryeriKategoriOzellikResult)
          vm.ozellikOzellikleri = ozellikler;
          console.log("vm.ozellikOzellikleri");
          console.log(vm.ozellikOzellikleri);
          //console.log("vm.ozellikOzellikleri:  " + vm.ozellikOzellikleri);
          const kategoriOzellik = [...new Set(ozellikler.map((x) => x.attributeid))];
          //console.log(kategoriOzellik)
          //vm.ozelliklerDiv=""
          vm.kategoriOzellikListesi = [];
          for (let s = 0; s < kategoriOzellik.length; s++) {
            vm.indext = vm.indexbul(
              vm.kategoriSuz,
              (item) => item.attributeid === kategoriOzellik[s]
            );
            vm.kategoriOzellikListesi.push({
              attributeName: vm.kategoriSuz[parseInt(vm.indext)]["attributeName"],
              attributeid: vm.kategoriSuz[parseInt(vm.indext)]["attributeid"],
            });
          }
          vm.datasuggest = vm.kategoriOzellikListesi;
          console.log(vm.kategoriOzellikListesi);

          vm.ozellikEslemeListesi(pazaryeri);
          //=kategoriOzellik

          // vm.ozelliklerDiv=vm.a

          // document.createElement(a)
          //vm.veriler=JSON.parse(result.pazaryeriKategoriCekResult)
          //vm.list=vm.veriler
        });
      });
    },
    ozellikleriEsle() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      var ozellikleriEsleargs = {
        program: vm.aktifPazaryeri,
        token: Store.state.tokenId,
        stokKodu: vm.dStokKodu,
        barkod: vm.dBarkod,
        muhasebeAlan: this.selectedO1.attributeName,

        ozellikId: this.selectedO1.attributeid,
        alanDegeri: this.selectedO3.valueName,
        kontrol: 1,
        manuel: 1,
        ozellikAltId: this.selectedO3.valueId,
      };
      if (this.ozellikEsleListeFlag == true) {
        ozellikleriEsleargs = {
          program: vm.aktifPazaryeri,
          token: Store.state.tokenId,
          stokKodu: this.ozellikEsleListeStokKodu,
          barkod: this.ozellikEsleListeBarkod,
          muhasebeAlan: this.selectedO1.attributeName,

          ozellikId: this.selectedO1.attributeid,
          alanDegeri: this.selectedO3.valueName,
          kontrol: 1,
          manuel: 1,
          ozellikAltId: this.selectedO3.valueId,
        };
      }
      console.log(ozellikleriEsleargs);
      soap.createClient(url, function (err, client) {
        client.ozellikleriEsleManuel(ozellikleriEsleargs, function (err, result) {
          if (result.ozellikleriEsleManuelResult == "-1") {
            Store.dispatch("logout");
          }

          vm.ozellikEslemeListesi(vm.aktifPazaryeri);
        });
      });
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      //console.log(reader)
      reader.onload = (e) => {
        vm.image = e.target.result;
        vm.imageBase64 = e.target.result;
        console.log(vm.image);

        vm.upload(e.target.result, file.name);
      };
      reader.readAsDataURL(file);
    },
    removeImage: function (e) {
      this.image = "";
    },
    upload(f, fileName) {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "upload");
      const args = {
        f: f,
        stokKodu: this.dStokKodu,
        barkod: this.dBarkod,
        fileName: fileName,
      };
      soap.createClient(url, function (err, client) {
        client.uploadFileProduct(args, function (err, result) {
          console.log(result);
          if (result.uploadFileProductResult == "Ok") {
            vm.removeImage();
            vm.resimListesi();
            vs.notify({
              title: "Başarılı",
              text: "Resim ekleme başarılı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } else {
            vm.removeImage();
            vs.notify({
              title: "Hata",
              text: "Resim eklenirken hata oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
          //vm.veriler=JSON.parse(result.iadeKabulListesineEkleResult)
          //vm.barkodOku(orderNumber.trim())
        });
      });
    },
    iliskiliUrunAra(pazaryeri) {
      this.anaUrunListesi(pazaryeri);
    },
    iliskiliUrunGonder(pazaryeri, barkod, barkod1) {
      var vs = this.$vs;
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        pazaryeri: pazaryeri,
        token: Store.state.tokenId,
        barkod: barkod.replace(" ", ""),
        barkod1: barkod1.replace(" ", ""),
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.iliskiliUrunGonder(args, function (err, result) {
          if (result.iliskiliUrunGonderResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.iliskiliUrunGonderResult);

          if (vm.veriler.response == "Ok") {
            vs.notify({
              title: "İlişkili Ürün",
              text: "İlişkişi Ürün Gönderildi",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          }

          // vm.eslesenStokListesi=vm.veriler
        });
      });
    },
    boslukTemizle(text) {
      return text.trim();
    },
    resimSil(resimId) {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = { token: Store.state.tokenId, resimId: resimId };
      soap.createClient(url, function (err, client) {
        client.stokResimSil(args, function (err, result) {
          if (result.stokResimEkleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          //vm.veriler=JSON.parse(result.StokAktarResult)
          // vm.eslesenStokListesi=vm.veriler

          vm.resimListesi();
          vm.imageBase64 = "";
        });
      });
    },
    ozellikEsleme2(kontrol, stokKodu, Barkod) {
      //this.kategoriOzellikleri();
      if (kontrol == "liste") {
        this.ozellikEsleListeStokKodu = stokKodu;
        this.ozellikEsleListeBarkod = Barkod;
        this.ozellikEsleListeFlag = true;
        this.StokKartDetayOzellikleriListe = stokKodu + "-" + Barkod;
      } else {
        this.ozellikEsleListeFlag = false;
      }
      console.log(this.ozellikEsleListeFlag);
      this.popupActiveSiparis2 = true;
      this.ozellikEslemeListesi();
    },
    ozellikEslemeListesi() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      var listEslesenArgs = {};

      listEslesenArgs = {
        program: vm.aktifPazaryeri,
        token: Store.state.tokenId,
        barkod: vm.dBarkod,
      };
      if (vm.ozellikEsleListeFlag == true) {
        listEslesenArgs = {
          program: vm.aktifPazaryeri,
          token: Store.state.tokenId,
          barkod: vm.ozellikEsleListeBarkod,
        };
      }
      console.log(listEslesenArgs);
      //alert(vm.aktifPazaryeri)
      soap.createClient(url, function (err, client) {
        client.eslesenStokOzellikleriListesi(listEslesenArgs, function (err, result) {
          if (result.eslesenStokOzellikleriListesiResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.eslesenStokOzellikleriListesiResult);
          vm.ozellikEslestirmeListesiData = vm.veriler;
        });
      });
    },
    ticimaxGonder() {
      // this.popupGonderilenStokListesi=true
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: "Ticimax",
        token: Store.state.tokenId,
        barkod: this.dBarkod,
        tedarikci: this.dTedarikci,
        marka: this.dMarka,
        teslimatSablonu: "",
      };
      soap.createClient(url, function (err, client) {
        client.StokAktar(args, function (err, result) {
          if (result.StokAktarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          //  console.log(result.StokAktarResult)
          vm.veriler = JSON.parse(result.StokAktarResult);
          if (vm.veriler.response == "Ok") {
            vs.notify({
              title: "Ticimax Gönderim",
              text: "Ticimax Gönderim Başarılı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
            //  vm.n11DurumMesaji = "N11 Gönderim Başarılı";
            //  vm.stokListesi()
          } else {
            vs.notify({
              title: "Ticimax Gönderim Hatalı",
              text: vm.veriler.mesaj,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
              fixed: true,
            });
            //   vm.n11DurumMesaji = vm.veriler.mesaj;
          }

          // vm.eslesenStokListesi=vm.veriler
          //console.log(vm.veriler.batchRequestId)

          setTimeout(function () {
            // vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
          }, 2500);
        });
      });
    },
    resimListeyeEkle() {
      //alert(this.resimAdi+this.dStokKodu+this.dBarkod)

      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        stokKodu: this.dStokKodu,
        barkod: this.dBarkod,
        resimAdi: this.resimAdi,
      };
      soap.createClient(url, function (err, client) {
        client.stokResimEkle(args, function (err, result) {
          if (result.stokResimEkleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          //vm.veriler=JSON.parse(result.StokAktarResult)
          // vm.eslesenStokListesi=vm.veriler

          vm.resimListesi();
        });
      });
    },
    resimListesi() {
      //alert(this.resimAdi+this.dStokKodu+this.dBarkod)

      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        stokKodu: this.dStokKodu,
        barkod: this.dBarkod,
      };
      soap.createClient(url, function (err, client) {
        client.stokResimListesi(args, function (err, result) {
          if (result.stokResimListesiResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          //console.log(result.stokResimListesiResult)
          vm.veriler = JSON.parse(result.stokResimListesiResult);
          vm.stokResimListesi = vm.veriler;
          // vm.eslesenStokListesi=vm.veriler
        });
      });
    },
    trendyolGonder() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      var dTedarikcitype = this.dTedarikci;
      if (typeof dTedarikcitype == "undefined") {
        dTedarikcitype = "";
      }
      var dMarkatype = this.dMarka;
      if (typeof dMarkatype == "undefined") {
        dMarkatype = "";
      }
      const args = {
        program: "Trendyol",
        token: Store.state.tokenId,
        barkod: this.dBarkod,
        tedarikci: dTedarikcitype,
        marka: dMarkatype,
        teslimatSablonu: "",
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.StokAktar(args, function (err, result) {
          if (result.StokAktarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            var sonuc = result.StokAktarResult;
            //  const userStr = JSON.stringify(sonuc);
            vm.veriler = JSON.parse(sonuc);

            if (vm.veriler[0].status == "SUCCESS") {
              vm.gonderilenStokListesi = vm.veriler;
              vm.popupGonderilenStokListesi = true;
              vs.notify({
                title: "Trendyol",
                text: "Trendyol Gönderim Başarılı",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            } else {
              vs.notify({
                title: "Trendyol Gönderim Hatası",
                text: vm.veriler,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
            vm.trendyolDurumMesaji = vm.veriler;
          } catch (error) {
            console.log(error);
            console.log(result);
          }

          setTimeout(function () {}, 2500);
        });
      });
    },
    trendyolAktarumDurum(kod) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = { program: "Trendyol", durumKodu: kod, stokKodu: "" };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.aktarimDurumSorgula(args, function (err, result) {
          try {
            console.log(result);
            vm.veriler = JSON.parse(result.aktarimDurumSorgulaResult);
            vm.gonderilenStokListesi = vm.veriler;
          } catch (error) {
            console.log(error);
            console.log(result);
          }
        });
      });
    },
    hepsiburadaGonder() {
      // this.popupGonderilenStokListesi=true
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: "Hepsiburada",
        token: Store.state.tokenId,
        barkod: this.dBarkod,
        tedarikci: this.dTedarikci,
        marka: this.dMarka,
        teslimatSablonu: "",
      };
      soap.createClient(url, function (err, client) {
        client.StokAktar(args, function (err, result) {
          if (result.StokAktarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          // console.log(result.StokAktarResult)
          var sonuc = result.StokAktarResult;

          //  const userStr = JSON.stringify(sonuc);
          vm.veriler = JSON.parse(sonuc);
          console.log(vm.veriler);
          // const d=JSON.parse(vm.veriler)
          if (vm.veriler.error == "Yes") {
            vs.notify({
              title: "Hepsiburada Gönderim Hatası",
              text: vm.veriler.mesaj,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
            });
          } else {
            console.log(vm.veriler.json[0]);
            if (vm.veriler.json[0].status == "SUCCESS") {
              vm.mesajHB = vm.veriler.json[0].importMessages.split("&");
              vm.hepsiburadaGonderimHatasi = vm.mesajHB[1] + "eksikler";
              console.log(vm.mesajHB[1]);
              vs.notify({
                title: "Hepsiburada",
                text: "Hepsiburada Gönderim Başarılı",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            } else {
              vm.mesajHB = vm.veriler.json[0].importMessages.split("&");
              vm.hepsiburadaGonderimHatasi = vm.mesajHB[1];
              vs.notify({
                title: "Hepsiburada Gönderim Hatalı",
                text: vm.mesajHB[0],
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center",
              });
            }
          }
          /*console.log(vm.veriler.batchRequestId)
    console.log(vm.veriler['batchRequestId'])
    console.log(d.batchRequestId)
    console.log(d['batchRequestId'])
    const batch=d['batchRequestId']*/
          /*if (typeof batch!='undefined') {
     batch =d.batchRequestId
    }*/

          //console.log(batch)
          /* if (typeof batch!='undefined') {
      vm.trendyolAktarumDurum(d['batchRequestId'])
    } else {

      vs.notify({
            title: 'Trendyol Gönderim Hatalı',
            text: d.errors[0].message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            position:'top-center'
          })
        vm.trendyolDurumMesaji=d.errors[0].message
    }**/

          //console.log(vm.veriler.timestamp)
          //let k=vm.veriler

          /*if (k.hasOwnProperty('batchRequestId')) {

        } else {
          console.log(k.timestamp)
        }*/
          // vm.eslesenStokListesi=vm.veriler
          // console.log(vm.veriler.batchRequestId)
          // vm.gonderilenStokListesi=vm.veriler
          setTimeout(function () {
            //vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
          }, 2500);
        });
      });
    },
    tsoftGonder() {
      var vs = this.$vs;
      this.popupGonderilenStokListesi = true;
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: "Tsoft",
        token: Store.state.tokenId,
        barkod: this.dBarkod,
        tedarikci: this.dTedarikci,
        marka: this.dMarka,
        teslimatSablonu: "",
      };
      soap.createClient(url, function (err, client) {
        client.StokAktar(args, function (err, result) {
          if (result.StokAktarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          //console.log(result.StokAktarResult)
          vm.veriler = JSON.parse(result.StokAktarResult);

          if (vm.veriler.json[0].Durum == "True") {
            vs.notify({
              title: "Tsoft",
              text: "Tsoft Gönderim Başarılı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } else {
            vs.notify({
              title: "Tsoft Gönderim Hatalı",
              text: vm.veriler.json[0].Detay,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
              fixed: true,
            });
          }
          //vm.eslesenStokListesi=vm.veriler
          // console.log(vm.veriler.batchRequestId)

          setTimeout(function () {
            //  vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
          }, 2500);
        });
      });
    },
    shopifyGonder() {
      var vs = this.$vs;
      this.popupGonderilenStokListesi = true;
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: "Shopify",
        token: Store.state.tokenId,
        barkod: this.dBarkod,
        tedarikci: this.dTedarikci,
        marka: this.dMarka,
        teslimatSablonu: "",
      };
      soap.createClient(url, function (err, client) {
        client.StokAktar(args, function (err, result) {
          if (result.StokAktarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.StokAktarResult);
          if (vm.veriler.response == "Ok") {
            vs.notify({
              title: "Shopify",
              text: "Shopify Gönderim Başarılı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } else {
            vs.notify({
              title: "Shopify Gönderim Hatalı",
              text: vm.veriler.Detay,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
              fixed: true,
            });
          }
          //vm.eslesenStokListesi=vm.veriler
          // console.log(vm.veriler.batchRequestId)

          setTimeout(function () {
            //  vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
          }, 2500);
        });
      });
    },
    gittigidiyorGonder() {
      debugger;
      var vs = this.$vs;
      this.popupGonderilenStokListesi = true;
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: "Gittigidiyor",
        token: Store.state.tokenId,
        barkod: this.dBarkod,
      };
      /*const args = {
        program: "Gittigidiyor",
        token: Store.state.tokenId,
        barkod: this.dBarkod,
        tedarikci: this.dTedarikci,
        marka: this.dMarka,
        teslimatSablonu: ""
      };*/
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.StokAktar(args, function (err, result) {
          if (result.StokAktarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          //console.log(result.StokAktarResult)
          vm.veriler = JSON.parse(result.StokAktarResult);
          console.log(vm.veriler);
          vm.gonderilenStokListesi = vm.veriler;
          console.log(vm.gonderilenStokListesi);

          //   vm.popupGonderilenStokListesi = true;

          if (vm.veriler.response == "Ok") {
            vs.notify({
              title: "Gittigidiyor",
              text: "Gittigidiyor Gönderim Başarılı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } else {
            vs.notify({
              title: vm.veriler.Mesaj,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
              fixed: true,
            });
          }
          //vm.eslesenStokListesi=vm.veriler
          vm.pazaryeriDetay("Gittigidiyor");

          setTimeout(function () {
            //  vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
          }, 2500);
        });
      });
    },
    ciceksepetiGonder() {
      var vs = this.$vs;
      this.popupGonderilenStokListesi = true;
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: "Ciceksepeti",
        token: Store.state.tokenId,
        barkod: this.dBarkod,
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.StokAktar(args, function (err, result) {
          if (result.StokAktarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          //console.log(result.StokAktarResult)
          vm.veriler = JSON.parse(result.StokAktarResult);
          if (vm.veriler.response == "Ok") {
            vs.notify({
              title: "Ciceksepeti",
              text: "Çiçeksepeti Gönderim Başarılı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
            //  this.stokListesi();
          } else {
            vs.notify({
              title: "Çiçeksepeti Gönderim Hatalı",
              text: vm.veriler.mesaj,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
              fixed: true,
            });
          }

          //vm.eslesenStokListesi=vm.veriler
          // console.log(vm.veriler.batchRequestId)

          setTimeout(function () {
            //  vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
          }, 2500);
        });
      });
    },
    PhpWebServisGonder() {
      var vs = this.$vs;
      this.popupGonderilenStokListesi = true;
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: "PhpWebServis",
        token: Store.state.tokenId,
        barkod: this.dBarkod,
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.StokAktar(args, function (err, result) {
          if (result.StokAktarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          //console.log(result.StokAktarResult)
          vm.veriler = JSON.parse(result.StokAktarResult);
          if (vm.veriler.response == "Ok") {
            vs.notify({
              title: "PhpWebServis",
              text: "PhpWebServis Gönderim Başarılı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
            //  this.stokListesi();
          } else {
            vs.notify({
              title: "PhpWebServis Gönderim Hatalı",
              text: vm.veriler.mesaj,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
              fixed: true,
            });
          }

          //vm.eslesenStokListesi=vm.veriler
          // console.log(vm.veriler.batchRequestId)

          setTimeout(function () {
            //  vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
          }, 2500);
        });
      });
    },
    etsyGonder() {
      var vs = this.$vs;
      this.popupGonderilenStokListesi = true;
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: "Etsy",
        token: Store.state.tokenId,
        barkod: this.dBarkod,
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.StokAktar(args, function (err, result) {
          if (result.StokAktarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          //console.log(result.StokAktarResult)
          vm.veriler = JSON.parse(result.StokAktarResult);
          if (vm.veriler.response == "Ok") {
            vs.notify({
              title: "Etsy",
              text: "Etsy Gönderim Başarılı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
            //  this.stokListesi();
          } else {
            vs.notify({
              title: "Etsy Gönderim Hatalı",
              text: vm.veriler.mesaj,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
              fixed: true,
            });
          }

          //vm.eslesenStokListesi=vm.veriler
          // console.log(vm.veriler.batchRequestId)

          setTimeout(function () {
            //  vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
          }, 2500);
        });
      });
    },
    ideasoftGonder() {
      var vs = this.$vs;
      this.popupGonderilenStokListesi = true;
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: "Ideasoft",
        token: Store.state.tokenId,
        barkod: this.dBarkod,
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.StokAktar(args, function (err, result) {
          if (result.StokAktarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          //console.log(result.StokAktarResult)
          vm.veriler = JSON.parse(result.StokAktarResult);
          if (vm.veriler.response == "Ok") {
            vs.notify({
              title: "Ideasoft",
              text: "Ideasoft Gönderim Başarılı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
            //  this.stokListesi();
          } else {
            vs.notify({
              title: "Ideasoft Gönderim Hatalı",
              text: vm.veriler.mesaj,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
              fixed: true,
            });
          }

          //vm.eslesenStokListesi=vm.veriler
          // console.log(vm.veriler.batchRequestId)

          setTimeout(function () {
            //  vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
          }, 2500);
        });
      });
    },
    pazaramaGonder() {
      var vs = this.$vs;
      this.popupGonderilenStokListesi = true;
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: "Pazarama",
        token: Store.state.tokenId,
        barkod: this.dBarkod,
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.StokAktar(args, function (err, result) {
          if (result.StokAktarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          //console.log(result.StokAktarResult)
          vm.veriler = JSON.parse(result.StokAktarResult);
          if (vm.veriler.response == "Ok") {
            vs.notify({
              title: "Pazarama",
              text: "Pazarama Gönderim Başarılı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
            //  this.stokListesi();
          } else {
            vs.notify({
              title: "Pazarama Gönderim Hatalı",
              text: vm.veriler.mesaj,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
              fixed: true,
            });
          }

          //vm.eslesenStokListesi=vm.veriler
          // console.log(vm.veriler.batchRequestId)

          setTimeout(function () {
            //  vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
          }, 2500);
        });
      });
    },
    akinSoftGonder() {
      var vs = this.$vs;
      this.popupGonderilenStokListesi = true;
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: "AkinSoft",
        token: Store.state.tokenId,
        barkod: this.dBarkod,
        tedarikci: this.dTedarikci,
        marka: this.dMarka,
        teslimatSablonu: "",
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.StokAktar(args, function (err, result) {
          if (result.StokAktarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          //console.log(result.StokAktarResult)
          console.log(result.StokAktarResult);
          vm.veriler = JSON.parse(result.StokAktarResult);
          if (vm.veriler.response == "Ok") {
            vs.notify({
              title: "AkinSoft",
              text: vm.veriler.mesaj,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } else {
            vs.notify({
              title: "AkinSoft Gönderim Hatalı",
              text: vm.veriler.json[0].Detay,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
              fixed: true,
            });
          }
          //vm.eslesenStokListesi=vm.veriler
          // console.log(vm.veriler.batchRequestId)

          setTimeout(function () {
            //  vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
          }, 2500);
        });
      });
    },
    allesgoGonder() {
      var vs = this.$vs;
      this.popupGonderilenStokListesi = true;
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: "Allesgo",
        token: Store.state.tokenId,
        barkod: this.dBarkod,
        tedarikci: this.dTedarikci,
        marka: this.dMarka,
        teslimatSablonu: "",
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.StokAktar(args, function (err, result) {
          if (result.StokAktarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          //console.log(result.StokAktarResult)
          console.log(result.StokAktarResult);
          vm.veriler = JSON.parse(result.StokAktarResult);
          if (vm.veriler.response == "Ok") {
            vs.notify({
              title: "Allesgo",
              text: vm.veriler.mesaj,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } else {
            vs.notify({
              title: "Allesgo Gönderim Hatalı",
              text: vm.veriler.json[0].Detay,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
              fixed: true,
            });
          }
          //vm.eslesenStokListesi=vm.veriler
          // console.log(vm.veriler.batchRequestId)

          setTimeout(function () {
            //  vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
          }, 2500);
        });
      });
    },
    opencartGonder() {
      var vs = this.$vs;
      this.popupGonderilenStokListesi = true;
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: "Opencart",
        token: Store.state.tokenId,
        barkod: this.dBarkod,
        tedarikci: this.dTedarikci,
        marka: this.dMarka,
        teslimatSablonu: "",
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.StokAktar(args, function (err, result) {
          if (result.StokAktarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          //console.log(result.StokAktarResult)
          console.log(result.StokAktarResult);
          vm.veriler = JSON.parse(result.StokAktarResult);
          if (vm.veriler.response == "Ok") {
            vs.notify({
              title: "Opencart",
              text: vm.veriler.mesaj,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } else {
            vs.notify({
              title: "Opencart Gönderim Hatalı",
              text: vm.veriler.json[0].Detay,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
              fixed: true,
            });
          }
          //vm.eslesenStokListesi=vm.veriler
          // console.log(vm.veriler.batchRequestId)

          setTimeout(function () {
            //  vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
          }, 2500);
        });
      });
    },

    modanisaGonder() {
      var vs = this.$vs;
      this.popupGonderilenStokListesi = true;
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: "Modanisa",
        token: Store.state.tokenId,
        barkod: this.dBarkod,
        tedarikci: this.dTedarikci,
        marka: this.dMarka,
        teslimatSablonu: "",
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.StokAktar(args, function (err, result) {
          if (result.StokAktarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          //console.log(result.StokAktarResult)
          console.log(result.StokAktarResult);
          vm.veriler = JSON.parse(result.StokAktarResult);
          if (vm.veriler.response == "Ok") {
            vs.notify({
              title: "Modanisa",
              text: vm.veriler.mesaj,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } else {
            vs.notify({
              title: "Modanisa Gönderim Hatalı",
              text: vm.veriler.json[0].Detay,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
              fixed: true,
            });
          }
          //vm.eslesenStokListesi=vm.veriler
          // console.log(vm.veriler.batchRequestId)

          setTimeout(function () {
            //  vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
          }, 2500);
        });
      });
    },
    ozonGonder() {
      var vs = this.$vs;
      this.popupGonderilenStokListesi = true;
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: "Ozon",
        token: Store.state.tokenId,
        barkod: this.dBarkod,
        tedarikci: this.dTedarikci,
        marka: this.dMarka,
        teslimatSablonu: "",
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.StokAktar(args, function (err, result) {
          if (result.StokAktarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          //console.log(result.StokAktarResult)
          console.log(result.StokAktarResult);
          vm.veriler = JSON.parse(result.StokAktarResult);
          if (vm.veriler.response == "Ok") {
            vs.notify({
              title: "Ozon",
              text: vm.veriler.mesaj,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } else {
            vs.notify({
              title: "Ozon Gönderim Hatalı",
              text: vm.veriler.json[0].Detay,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
              fixed: true,
            });
          }
          //vm.eslesenStokListesi=vm.veriler
          // console.log(vm.veriler.batchRequestId)

          setTimeout(function () {
            //  vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
          }, 2500);
        });
      });
    },
    ikasGonder() {
      var vs = this.$vs;
      this.popupGonderilenStokListesi = true;
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: "Ikas",
        token: Store.state.tokenId,
        barkod: this.dBarkod,
        tedarikci: this.dTedarikci,
        marka: this.dMarka,
        teslimatSablonu: "",
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.StokAktar(args, function (err, result) {
          if (result.StokAktarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          //console.log(result.StokAktarResult)
          console.log(result.StokAktarResult);
          vm.veriler = JSON.parse(result.StokAktarResult);
          if (vm.veriler.response == "Ok") {
            vs.notify({
              title: "Ikas",
              text: vm.veriler.mesaj,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } else {
            vs.notify({
              title: "Ikas Gönderim Hatalı",
              text: vm.veriler.json[0].Detay,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
              fixed: true,
            });
          }
          //vm.eslesenStokListesi=vm.veriler
          // console.log(vm.veriler.batchRequestId)

          setTimeout(function () {
            //  vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
          }, 2500);
        });
      });
    },

    WoocommerceGonder() {
      this.popupGonderilenStokListesi = true;
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: "Woocommerce",
        token: Store.state.tokenId,
      };
      soap.createClient(url, function (err, client) {
        client.StokAktarToplu(args, function (err, result) {
          if (result.StokAktarTopluResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          //console.log("result.StokAktarResult:" + result.StokAktarResult);
          vm.veriler = JSON.parse(result.StokAktarTopluResult);
          if (vm.veriler.response == "Ok") {
            vs.notify({
              title: "Woocommerce Gönderim",
              text: "Woocommerce Gönderim Başarılı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
            vm.WoocommerceDurumMesaji = "Woocommerce Gönderim Başarılı";
          } else {
            vs.notify({
              title: "Woocommerce Gönderim Hatalı",
              text: vm.veriler.mesaj,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
              fixed: true,
            });
            vm.WoocommerceDurumMesaji = vm.veriler.mesaj;
          }
        });
      });
    },
    AzallGonder() {
      this.popupGonderilenStokListesi = true;
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: "Azall",
        token: Store.state.tokenId,
        barkod: this.dBarkod,
      };
      soap.createClient(url, function (err, client) {
        client.StokAktar(args, function (err, result) {
          if (result.StokAktarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.StokAktarResult);
          if (vm.veriler.response == "Ok") {
            vs.notify({
              title: "Azall Gönderim",
              text: "Azall Gönderim Başarılı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
            vm.AzallDurumMesaji = "Azall Gönderim Başarılı";
          } else {
            vs.notify({
              title: "Azall Gönderim Hatalı",
              text: vm.veriler.mesaj,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
              fixed: true,
            });
            vm.AzallDurumMesaji = vm.veriler.mesaj;
          }
        });
      });
      this.stokListesi();
    },
    PttAvmGonder() {
      this.popupGonderilenStokListesi = true;
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: "PttAvm",
        token: Store.state.tokenId,
        barkod: this.dBarkod,
      };
      soap.createClient(url, function (err, client) {
        client.StokAktar(args, function (err, result) {
          if (result.StokAktarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.StokAktarResult);
          if (vm.veriler.response == "Ok") {
            vs.notify({
              title: "Ptt Gönderim",
              text: "Ptt Gönderim Başarılı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
            vm.PttAvmDurumMesaji = "Ptt Gönderim Başarılı";
          } else {
            vs.notify({
              title: "Ptt Gönderim Hatalı",
              text: vm.veriler.mesaj,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
              fixed: true,
            });
            vm.PttAvmDurumMesaji = vm.veriler.mesaj;
          }
        });
      });
      this.stokListesi();
    },
    n11Gonder() {
      this.popupGonderilenStokListesi = true;
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      vs.loading({
        background: "#0064fa",
        color: this.colorLoading,
        container: "#button-with-loading-n11gonder",
        scale: 0.45,
      });

      const args = {
        program: "N11",
        token: Store.state.tokenId,
        barkod: this.dBarkod,
        tedarikci: this.dTedarikci,
        marka: this.dMarka,
        teslimatSablonu: this.selectedN11TeslimatSablonu,
        hazirlikSuresi: this.selectedN11HazirlikSuresi,
      };

      if (vm.selectedN11HazirlikSuresi.id == "" || this.selectedN11HazirlikSuresi == "") {
        vs.notify({
          title: "Hazırlık Süresi",
          text: "Lütfen Hazırlık Süresi Seçiniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "dark",
          position: "top-center",
        });
      } else {
        soap.createClient(url, function (err, client) {
          client.StokAktar(args, function (err, result) {
            if (result.StokAktarResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.StokAktarResult);
              if (vm.veriler.response == "Ok") {
                vm.StokAktarList = vm.veriler.json;
                console.log(vm.StokAktarList);

                if (typeof vm.StokAktarList != "undefined") {
                  vs.loading.close("#button-with-loading-n11gonder > .con-vs-loading");

                  console.log(vm.StokAktarList);
                  vm.popupStokAktar = true;
                  vm.$store.commit("uzum/STOK_AKTAR_LIST", vm.StokAktarList);
                  vm.$refs.stokAktarPopup.listele(vm.dBarkod);
                } else {
                  vs.loading.close("#button-with-loading-n11gonder > .con-vs-loading");
                  vs.notify({
                    title: "N11 Gönderim",
                    text: "N11 Gönderim Başarılı",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                    position: "top-center",
                  });
                  vm.n11DurumMesaji = "N11 Gönderim Başarılı";
                }
              } else {
                vs.loading.close("#button-with-loading-n11gonder > .con-vs-loading");
                vs.notify({
                  title: "N11 Gönderim Hatalı",
                  text: vm.veriler.mesaj,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center",
                  fixed: true,
                });
                vm.n11DurumMesaji = vm.veriler.mesaj;
              }
            } catch (error) {
              console.log(result);
              console.log(error);

              vs.loading.close("#button-with-loading-n11gonder > .con-vs-loading");
              vs.notify({
                title: "N11 Gönderim Hatalı",
                text: "Gönderimde hata var",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }

            // vm.eslesenStokListesi=vm.veriler

            /*setTimeout(function() {
         vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
    }, 2500)  */
          });
        });
      }
    },
    gonderimListesineEkle(pazaryeri) {
      ///console.log(pazaryeri+' ** '+Store.state.tokenId+' ** '+pazaryeri+' ** '+this.dStokKodu+' ** '+1+' ** '+this.dBarkod+' ** '+this.trendyolGonderilecekAdet+' ** '+this.alan1+' ** '+ this.alan2+' ** '+ this.alan3+' ** '+ this.alan4+' ** '+ this.alan5+' ** '+ this.alan6+' ** '+ this.alan7+' ** '+ this.alan8+' ** '+this.alan9+' ** '+this.alan10+' ** '+ this.dRenk+' ** '+this.dBeden+' ** '+this.trendyolSatisFiyati+' ** '+this.trendyolGonderilecekAdet+' ** '+this.trendyolSatisFiyati+' ** '+this.trendyolPiyasaFiyati+' ** '+this.trendyolKategoriId)

      var vs = this.$vs;
      var vm = this;

      let args;
      let btnLnk = "";

      switch (pazaryeri) {
        case "Trendyol":
          btnLnk = "b_1";
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.trendyolGonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7Pd,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10Pd,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.trendyolSatisFiyati,
            adet: this.trendyolGonderilecekAdet,
            gonderilecekFiyat: this.trendyolSatisFiyati,
            gonderilecekPiyasaFiyati: this.trendyolPiyasaFiyati,
            pazaryeriId: this.trendyolKategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            anaStokKodu: this.anaStokKodu,
            ortakKod: this.ortakKod,
            pazaryeriCode: "",
            desi: this.trendyolDesi,
          };
          break;
        case "N11":
          btnLnk = "b_2";
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.n11GonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.n11SatisFiyati,
            adet: this.n11GonderilecekAdet,
            gonderilecekFiyat: this.n11SatisFiyati,
            gonderilecekPiyasaFiyati: this.n11PiyasaFiyati,
            pazaryeriId: this.n11KategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            anaStokKodu: this.anaStokKodu,
            ortakKod: this.ortakKod,
            pazaryeriCode: 0,
            N11KatalogId: this.N11KatalogId,
          };
          break;
        case "Hepsiburada":
          btnLnk = "b_3";
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.hepsiburadaGonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7Pd,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10Pd,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.hepsiburadaSatisFiyati,
            adet: this.hepsiburadaGonderilecekAdet,
            gonderilecekFiyat: this.hepsiburadaSatisFiyati,
            gonderilecekPiyasaFiyati: this.hepsiburadaPiyasaFiyati,
            pazaryeriId: this.hepsiburadaKategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            HBKatalogId: this.HBKatalogId,
            pazaryeriCode: "",
            desi: this.hepsiburadaDesi,
          };
          break;
        case "Ticimax":
          btnLnk = "b_4";
          args = {
            token: Store.state.tokenId,
            program: "Ticimax",
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.ticimaxGonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7Pd,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10Pd,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.ticimaxSatisFiyati,
            adet: this.ticimaxGonderilecekAdet,
            gonderilecekFiyat: this.ticimaxSatisFiyati,
            gonderilecekPiyasaFiyati: this.ticimaxPiyasaFiyati,
            pazaryeriId: this.ticimaxKategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            anaStokKodu: this.anaStokKodu,
            ortakKod: "",
            pazaryeriCode: "",
          };
          //          args = {token:Store.state.tokenId,program:pazaryeri,stokKodu:this.dStokKodu,stokAdi:this.dStokAdi,durum:1,barkod:this.dBarkod,gonderilecekAdet:this.ticimaxGonderilecekAdet,alan1:this.alan1, alan2:this.alan2,alan3:this.alan3,  alan4:this.alan4, alan5:this.alan5, alan6:this.alan6, alan7:this.alan7, alan8:this.alan8, alan9:this.alan9,  alan10:this.alan10, renk:this.dRenk, beden:this.dBeden, fiyat:this.ticimaxSatisFiyati, adet:this.ticimaxGonderilecekAdet, gonderilecekFiyat:this.ticimaxSatisFiyati, gonderilecekPiyasaFiyati:this.ticimaxPiyasaFiyati, pazaryeriId:this.ticimaxKategoriId,detay:this.stokAciklama,kdv:this.dKdv, anaStokKodu:this.anaStokKodu ,ortakKod:"", pazaryeriCode:""}
          break;
        case "Tsoft":
          btnLnk = "b_5";
          //console.log(this.alan10)

          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.tsoftGonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7Pd,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10Pd,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.tsoftSatisFiyati,
            adet: this.tsoftGonderilecekAdet,
            gonderilecekFiyat: this.tsoftSatisFiyati,
            gonderilecekPiyasaFiyati: this.tsoftPiyasaFiyati,
            pazaryeriId: this.tsoftKategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            anaStokKodu: this.anaStokKodu,
            ortakKod: this.ortakKod,
            pazaryeriCode: this.tsoftKategoriId,
          };
          //console.log(args)
          break;
        case "Shopify":
          btnLnk = "b_6";
          //console.log(this.alan10)

          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.shopifyGonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7Pd,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10Pd,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.shopifySatisFiyati,
            adet: this.shopifyGonderilecekAdet,
            gonderilecekFiyat: this.shopifySatisFiyati,
            gonderilecekPiyasaFiyati: this.shopifyPiyasaFiyati,
            pazaryeriId: this.shopifyKategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            anaStokKodu: this.anaStokKodu,
            ortakKod: this.ortakKod,
            pazaryeriCode: this.shopifyKategoriId,
          };
          //console.log(args)
          break;
        case "Gittigidiyor":
          btnLnk = "b_7";
          //console.log(this.alan10)

          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.gittigidiyorGonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7Pd,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10Pd,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.gittigidiyorSatisFiyati,
            adet: this.gittigidiyorGonderilecekAdet,
            gonderilecekFiyat: this.gittigidiyorSatisFiyati,
            gonderilecekPiyasaFiyati: this.gittigidiyorPiyasaFiyati,
            pazaryeriId: this.gittigidiyorKategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            anaStokKodu: this.anaStokKodu,
            ortakKod: this.ortakKod,
            pazaryeriCode: this.gittigidiyorKategoriId,
            GGKatalogId: this.GGKatalogId,
          };
          break;
        case "Ciceksepeti":
          btnLnk = "b_8";
          //console.log(this.alan10)

          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.ciceksepetiGonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7Pd,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10Pd,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.ciceksepetiSatisFiyati,
            adet: this.ciceksepetiGonderilecekAdet,
            gonderilecekFiyat: this.ciceksepetiSatisFiyati,
            gonderilecekPiyasaFiyati: this.ciceksepetiPiyasaFiyati,
            pazaryeriId: this.ciceksepetiKategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            anaStokKodu: this.anaStokKodu,
            ortakKod: this.ortakKod,
            pazaryeriCode: this.ciceksepetiKategoriId,
          };
          //console.log(args)
          break;
        case "PlatinMarket":
          btnLnk = "b_9";
          //console.log(this.alan10)

          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.platinmarketGonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7Pd,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10Pd,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.platinmarketSatisFiyati,
            adet: this.platinmarketGonderilecekAdet,
            gonderilecekFiyat: this.platinmarketSatisFiyati,
            gonderilecekPiyasaFiyati: this.platinmarketPiyasaFiyati,
            pazaryeriId: this.platinmarketKategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            anaStokKodu: this.anaStokKodu,
            ortakKod: this.ortakKod,
            pazaryeriCode: this.platinmarketKategoriId,
          };
          //console.log(args)
          break;
          console.log(args);
          break;
        case "Woocommerce":
          btnLnk = "b_10";
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.WoocommerceGonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.WoocommerceSatisFiyati,
            adet: this.WoocommerceGonderilecekAdet,
            gonderilecekFiyat: this.WoocommerceSatisFiyati,
            gonderilecekPiyasaFiyati: this.WoocommercePiyasaFiyati,
            pazaryeriId: this.WoocommerceKategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            anaStokKodu: this.anaStokKodu,
            ortakKod: vm.ortakKod,
            pazaryeriCode: this.WoocommerceKategoriId,
          };
          break;
        case "Ikas":
          btnLnk = "b_11";
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.ikasGonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7Pd,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10Pd,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.ikasSatisFiyati,
            adet: this.ikasGonderilecekAdet,
            gonderilecekFiyat: this.ikasSatisFiyati,
            gonderilecekPiyasaFiyati: this.ikasPiyasaFiyati,
            pazaryeriId: this.ikasKategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            anaStokKodu: this.anaStokKodu,
            ortakKod: this.ortakKod,
            pazaryeriCode: this.ikasKategoriId,
          };
          //console.log(args)
          break;

        case "Ozon":
          btnLnk = "b_11";
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.ozonGonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7Pd,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10Pd,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.ozonSatisFiyati,
            adet: this.ozonGonderilecekAdet,
            gonderilecekFiyat: this.ozonSatisFiyati,
            gonderilecekPiyasaFiyati: this.ozonPiyasaFiyati,
            pazaryeriId: this.ozonKategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            anaStokKodu: this.anaStokKodu,
            ortakKod: this.ortakKod,
            pazaryeriCode: this.ozonKategoriId,
          };
          //console.log(args)
          break;
        case "Modanisa":
          btnLnk = "b_11";
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.modanisaGonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7Pd,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10Pd,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.modanisaSatisFiyati,
            adet: this.modanisaGonderilecekAdet,
            gonderilecekFiyat: this.modanisaSatisFiyati,
            gonderilecekPiyasaFiyati: this.modanisaPiyasaFiyati,
            pazaryeriId: this.modanisaKategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            anaStokKodu: this.anaStokKodu,
            ortakKod: this.ortakKod,
            pazaryeriCode: this.modanisaKategoriId,
          };
          //console.log(args)
          break;
        case "AkinSoft":
          btnLnk = "b_11";
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.akinSoftGonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7Pd,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10Pd,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.akinSoftSatisFiyati,
            adet: this.akinSoftGonderilecekAdet,
            gonderilecekFiyat: this.akinSoftSatisFiyati,
            gonderilecekPiyasaFiyati: this.akinSoftPiyasaFiyati,
            pazaryeriId: this.akinSoftKategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            anaStokKodu: this.anaStokKodu,
            ortakKod: this.ortakKod,
            pazaryeriCode: this.akinSoftKategoriId,
          };
          //console.log(args)
          break;
        case "Opencart":
          btnLnk = "b_11";
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.opencartGonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7Pd,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10Pd,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.opencartSatisFiyati,
            adet: this.opencartGonderilecekAdet,
            gonderilecekFiyat: this.opencartSatisFiyati,
            gonderilecekPiyasaFiyati: this.opencartPiyasaFiyati,
            pazaryeriId: this.opencartKategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            anaStokKodu: this.anaStokKodu,
            ortakKod: this.ortakKod,
            pazaryeriCode: this.opencartKategoriId,
          };
          //console.log(args)
          break;
        case "Allesgo":
          btnLnk = "b_11";
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.allesgoGonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7Pd,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10Pd,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.allesgoSatisFiyati,
            adet: this.allesgoGonderilecekAdet,
            gonderilecekFiyat: this.allesgoSatisFiyati,
            gonderilecekPiyasaFiyati: this.allesgoPiyasaFiyati,
            pazaryeriId: this.allesgoKategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            anaStokKodu: this.anaStokKodu,
            ortakKod: this.ortakKod,
            pazaryeriCode: this.allesgoKategoriId,
          };
          //console.log(args)
          break;

        case "PttAvm":
          btnLnk = "b_10";
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.PttAvmGonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.PttAvmSatisFiyati,
            adet: this.PttAvmGonderilecekAdet,
            gonderilecekFiyat: this.PttAvmSatisFiyati,
            gonderilecekPiyasaFiyati: this.PttAvmPiyasaFiyati,
            pazaryeriId: this.PttAvmKategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            anaStokKodu: this.anaStokKodu,
            ortakKod: this.ortakKod,
            pazaryeriCode: this.PttAvmKategoriId,
          };
          break;
        case "Azall":
          btnLnk = "b_10";
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.AzallGonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.AzallSatisFiyati,
            adet: this.AzallGonderilecekAdet,
            gonderilecekFiyat: this.AzallSatisFiyati,
            gonderilecekPiyasaFiyati: this.AzallPiyasaFiyati,
            pazaryeriId: this.AzallKategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            anaStokKodu: this.anaStokKodu,
            ortakKod: this.ortakKod,
            pazaryeriCode: this.AzallKategoriId,
          };
          break;
        case "Pazarama":
          btnLnk = "b_2";
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.pazaramaGonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.pazaramaSatisFiyati,
            adet: this.pazaramaGonderilecekAdet,
            gonderilecekFiyat: this.pazaramaSatisFiyati,
            gonderilecekPiyasaFiyati: this.pazaramaPiyasaFiyati,
            pazaryeriId: this.pazaramaKategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            anaStokKodu: this.anaStokKodu,
            ortakKod: this.ortakKod,
            pazaryeriCode: 0,
            PazaramaKatalogId: this.PazaramaKatalogId,
          };
          break;
        case "PhpWebServis":
          btnLnk = "b_2";
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.PhpWebServisGonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.PhpWebServisSatisFiyati,
            adet: this.PhpWebServisGonderilecekAdet,
            gonderilecekFiyat: this.PhpWebServisSatisFiyati,
            gonderilecekPiyasaFiyati: this.PhpWebServisPiyasaFiyati,
            pazaryeriId: this.PhpWebServisKategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            anaStokKodu: this.anaStokKodu,
            ortakKod: this.ortakKod,
            pazaryeriCode: 0,
            PhpWebServisKatalogId: this.PhpWebServisKatalogId,
          };
          break;
        case "Ideasoft":
          btnLnk = "b_2";
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.ideasoftGonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.ideasoftSatisFiyati,
            adet: this.ideasoftGonderilecekAdet,
            gonderilecekFiyat: this.ideasoftSatisFiyati,
            gonderilecekPiyasaFiyati: this.ideasoftPiyasaFiyati,
            pazaryeriId: this.ideasoftKategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            anaStokKodu: this.anaStokKodu,
            ortakKod: this.ortakKod,
            pazaryeriCode: 0,
            IdeasoftKatalogId: this.IdeasoftKatalogId,
          };
          break;

        case "Etsy":
          btnLnk = "b_2";
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: this.dStokKodu,
            stokAdi: this.dStokAdi,
            durum: 1,
            barkod: this.dBarkod,
            gonderilecekAdet: this.etsyGonderilecekAdet,
            alan1: this.alan1Pd,
            alan2: this.alan2Pd,
            alan3: this.alan3Pd,
            alan4: this.alan4Pd,
            alan5: this.alan5Pd,
            alan6: this.alan6Pd,
            alan7: this.alan7,
            alan8: this.alan8Pd,
            alan9: this.alan9Pd,
            alan10: this.alan10,
            renk: this.dRenk,
            beden: this.dBeden,
            fiyat: this.etsySatisFiyati,
            adet: this.etsyGonderilecekAdet,
            gonderilecekFiyat: this.etsySatisFiyati,
            gonderilecekPiyasaFiyati: this.etsyPiyasaFiyati,
            pazaryeriId: this.etsyKategoriId,
            detay: this.stokAciklama,
            kdv: this.dKdv,
            anaStokKodu: this.anaStokKodu,
            ortakKod: this.ortakKod,
            pazaryeriCode: 0,
            EtsyKatalogId: this.EtsyKatalogId,
          };
          break;
      }
      /* vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#"+btnLnk,
        scale: 0.45
      })*/
      //alert("Gonderim Listesine Ekle ortakKod :" + vm.ortakKodPn);
      vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-listeyeekle",
        scale: 0.45,
      });
      const soap = require("soap");
      const url = state.sistemAddress;
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.gonderimListesineEkle(args, function (err, result) {
          if (result.gonderimListesineEkleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.gonderimListesineEkleResult);
            //console.log("gonderimListesineEkleResult" + vm.veriler);
            if (vm.veriler.response == "Ok") {
              vs.loading.close("#button-with-loading-listeyeekle > .con-vs-loading");
              vs.notify({
                title: "Gönderim Listesi",
                text: "Ekleme İşlemi Başarılı",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            } else {
              vs.loading.close("#button-with-loading-listeyeekle > .con-vs-loading");
              vs.notify({
                title: "Gönderim Listesi",
                text: "Eklemede Hata Oluştu",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center",
              });
            }
            // vs.loading.close("#"+btnLnk+" > .con-vs-loading")
            //vm.resimYukle(result.gonderimListesineEkleResult, 0, 1, pazaryeri);
            //console.log(pazaryeri +""+ this.dBarkod)
            vm.pazaryeriDetay(pazaryeri);

            //vm.altUrunListesi(pazaryeri, this.dBarkod); //Burayı Kontrol Et
          } catch (error) {
            vs.loading.close("#button-with-loading-listeyeekle > .con-vs-loading");
            vs.notify({
              title: "Gönderim Listesi",
              text: "Eklemede Hata Oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
    altListedenKaldir(pazaryeri, stokKodu) {
      document.getElementById("cikar" + stokKodu).disabled = true;
      var vm = this;
      let args = {
        token: Store.state.tokenId,
        pazaryeri: pazaryeri,
        stokKodu: stokKodu,
      };
      const url = state.sistemAddress;
      const soap = require("soap");
      soap.createClient(url, function (err, client) {
        client.altGonderimListesiKaldir(args, function (err, result) {
          if (result.altGonderimListesiKaldirResult == "-1") {
            Store.dispatch("logout");
          }
          //vm.veriler=JSON.parse(result.altGonderimListesiKaldirResult)
          //  vm.altUrunListesi(pazaryeri,vm.ortakKod)
        });
      });
    },
    ListedenKaldir() {
      var vm = this;
      var vs = this.$vs;
      let args = {
        token: Store.state.tokenId,
        pazaryeri: this.listedenKaldirpazaryer,
        stokKodu: this.listedenKaldirstokkod,
      };
      console.log(args);
      const url = state.sistemAddress;
      const soap = require("soap");
      soap.createClient(url, function (err, client) {
        client.altGonderimListesiKaldir(args, function (err, result) {
          if (result.altGonderimListesiKaldirResult == "-1") {
            Store.dispatch("logout");
          }
          console.log(result);
          try {
            vm.veriler = JSON.parse(result.altGonderimListesiKaldirResult);
            console.log(vm.veriler);
            if (vm.veriler == "Ok")
              vs.notify({
                color: "success",
                title: "Başarılı",
                text: "Listeden ürün başarıyla kaldırıldı",
              });
            else
              vs.notify({
                color: "danger",
                title: "Hata",
                text: "Listeden ürün kaldırılırken hata oluştu",
              });
          } catch (error) {
            vs.notify({
              color: "danger",
              title: "Hata",
              text: "Listeden ürün kaldırılırken hata oluştu",
            });
          }
          vm.pazaryeriDetay(this.listedenKaldirpazaryer);
        });
      });
    },
    altGonderimListesineEkle(
      pazaryeri,
      stokKodu,
      stokAdi,
      barkod,
      gonderilecekAdet,
      alan1,
      alan2,
      alan3,
      alan4,
      alan5,
      alan6,
      alan7,
      alan8,
      alan9,
      alan10,
      renk,
      beden,
      fiyat,
      adet,
      gonderilecekFiyat,
      gonderilecekPiyasaFiyati,
      pazaryeriId,
      detay,
      kdv,
      anaStokKodu,
      ortakKod,
      pazaryeriCode
    ) {
      // console.log("pazaryer : "+pazaryeri+'**'+"stokkodu : "+stokKodu+'**'+"stokadi : "+stokAdi+'**'+"barkod : "+barkod+'**'+"adet : "+gonderilecekAdet+'**'+alan1+'**'+ alan2+'**'+alan3+'**'+  alan4+'**'+ alan5+'**'+ alan6+'**'+ alan7+'**'+ alan8+'**'+ alan9+'**'+  alan10+'**'+ "renk : "+renk+'**'+ "beden  : "+beden+'**'+ "fiyat : "+fiyat+'**'+ "adet : "+adet+'**'+ "adet : "+gonderilecekFiyat+'**'+ "piyasafiyat : "+gonderilecekPiyasaFiyati+'**'+ "pazaryeriid : "+pazaryeriId+'**'+detay+'**'+"kdv : "+kdv+'**'+"anastokkodu : "+anaStokKodu+'**'+"ortakod : "+ortakKod+'**'+"pazaryerikod : "+pazaryeriCode)

      document.getElementById("ekle" + stokKodu).disabled = true;
      var vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      let args;
      const url = state.sistemAddress;

      switch (pazaryeri) {
        case "Tsoft":
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: stokKodu,
            stokAdi: stokAdi,
            durum: 1,
            barkod: barkod,
            gonderilecekAdet: gonderilecekAdet,
            alan1: "",
            alan2: "",
            alan3: "",
            alan4: "",
            alan5: "",
            alan6: "",
            alan7: "",
            alan8: "",
            alan9: "",
            alan10: "",
            renk: renk,
            beden: beden,
            fiyat: fiyat,
            adet: adet,
            gonderilecekFiyat: gonderilecekFiyat,
            gonderilecekPiyasaFiyati: gonderilecekPiyasaFiyati,
            pazaryeriId: pazaryeriId,
            detay: detay,
            kdv: kdv,
            anaStokKodu: this.dStokKodu,
            ortakKod: vm.ortakKod,
            pazaryeriCode: pazaryeriCode,
          };
          // console.log(args)
          break;
        case "Trendyol":
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: stokKodu,
            stokAdi: stokAdi,
            durum: 1,
            barkod: barkod,
            gonderilecekAdet: gonderilecekAdet,
            alan1: "",
            alan2: "",
            alan3: "",
            alan4: "",
            alan5: "",
            alan6: "",
            alan7: "",
            alan8: "",
            alan9: "",
            alan10: "",
            renk: renk,
            beden: beden,
            fiyat: fiyat,
            adet: adet,
            gonderilecekFiyat: gonderilecekFiyat,
            gonderilecekPiyasaFiyati: gonderilecekPiyasaFiyati,
            pazaryeriId: pazaryeriId,
            detay: detay,
            kdv: kdv,
            anaStokKodu: this.dStokKodu,
            ortakKod: vm.ortakKod,
            pazaryeriCode: pazaryeriCode,
          };
          console.log(args);
          break;
        case "Ticimax":
          if (fiyat == "") {
            fiyat = vm.dSatisFiyat;
            gonderilecekFiyat = vm.dSatisFiyat;
          }
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: stokKodu,
            stokAdi: stokAdi,
            durum: 1,
            barkod: barkod,
            gonderilecekAdet: gonderilecekAdet,
            alan1: "",
            alan2: "",
            alan3: "",
            alan4: "",
            alan5: "",
            alan6: "",
            alan7: "",
            alan8: "",
            alan9: "",
            alan10: "",
            renk: renk,
            beden: beden,
            fiyat: fiyat,
            adet: adet,
            gonderilecekFiyat: gonderilecekFiyat,
            gonderilecekPiyasaFiyati: gonderilecekPiyasaFiyati,
            pazaryeriId: pazaryeriId,
            detay: detay,
            kdv: kdv,
            anaStokKodu: this.dStokKodu,
            ortakKod: vm.ortakKod,
            pazaryeriCode: pazaryeriCode,
          };
          //console.log(args)
          break;
        case "N11":
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: stokKodu,
            stokAdi: stokAdi,
            durum: 1,
            barkod: barkod,
            gonderilecekAdet: gonderilecekAdet,
            alan1: "",
            alan2: "",
            alan3: "",
            alan4: "",
            alan5: "",
            alan6: "",
            alan7: "",
            alan8: "",
            alan9: "",
            alan10: "",
            renk: renk,
            beden: beden,
            fiyat: fiyat,
            adet: adet,
            gonderilecekFiyat: gonderilecekFiyat,
            gonderilecekPiyasaFiyati: gonderilecekPiyasaFiyati,
            pazaryeriId: pazaryeriId,
            detay: detay,
            kdv: kdv,
            anaStokKodu: vm.dStokKodu,
            ortakKod: vm.ortakKod,
            pazaryeriCode: pazaryeriCode,
            N11KatalogId: vm.N11KatalogId,
          };
          //console.log("N11 alt ürün args:"+args)
          // alert("vm.N11KatalogId:"+vm.N11KatalogId)
          break;
        case "Woocommerce":
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: stokKodu,
            stokAdi: stokAdi,
            durum: 1,
            barkod: barkod,
            gonderilecekAdet: gonderilecekAdet,
            alan1: "",
            alan2: "",
            alan3: "",
            alan4: "",
            alan5: "",
            alan6: "",
            alan7: "",
            alan8: "",
            alan9: "",
            alan10: "",
            renk: renk,
            beden: beden,
            fiyat: fiyat,
            adet: adet,
            gonderilecekFiyat: gonderilecekFiyat,
            gonderilecekPiyasaFiyati: gonderilecekPiyasaFiyati,
            pazaryeriId: pazaryeriId,
            detay: detay,
            kdv: kdv,
            anaStokKodu: vm.dStokKodu,
            ortakKod: vm.ortakKod,
            pazaryeriCode: pazaryeriCode,
          };
          break;
        case "Ikas":
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: stokKodu,
            stokAdi: stokAdi,
            durum: 1,
            barkod: barkod,
            gonderilecekAdet: gonderilecekAdet,
            alan1: "",
            alan2: "",
            alan3: "",
            alan4: "",
            alan5: "",
            alan6: "",
            alan7: "",
            alan8: "",
            alan9: "",
            alan10: "",
            renk: renk,
            beden: beden,
            fiyat: fiyat,
            adet: adet,
            gonderilecekFiyat: gonderilecekFiyat,
            gonderilecekPiyasaFiyati: gonderilecekPiyasaFiyati,
            pazaryeriId: pazaryeriId,
            detay: detay,
            kdv: kdv,
            anaStokKodu: vm.dStokKodu,
            ortakKod: vm.ortakKod,
            pazaryeriCode: pazaryeriCode,
          };
          break;
        case "Ozon":
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: stokKodu,
            stokAdi: stokAdi,
            durum: 1,
            barkod: barkod,
            gonderilecekAdet: gonderilecekAdet,
            alan1: "",
            alan2: "",
            alan3: "",
            alan4: "",
            alan5: "",
            alan6: "",
            alan7: "",
            alan8: "",
            alan9: "",
            alan10: "",
            renk: renk,
            beden: beden,
            fiyat: fiyat,
            adet: adet,
            gonderilecekFiyat: gonderilecekFiyat,
            gonderilecekPiyasaFiyati: gonderilecekPiyasaFiyati,
            pazaryeriId: pazaryeriId,
            detay: detay,
            kdv: kdv,
            anaStokKodu: vm.dStokKodu,
            ortakKod: vm.ortakKod,
            pazaryeriCode: pazaryeriCode,
          };
          break;
        case "Modanisa":
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: stokKodu,
            stokAdi: stokAdi,
            durum: 1,
            barkod: barkod,
            gonderilecekAdet: gonderilecekAdet,
            alan1: "",
            alan2: "",
            alan3: "",
            alan4: "",
            alan5: "",
            alan6: "",
            alan7: "",
            alan8: "",
            alan9: "",
            alan10: "",
            renk: renk,
            beden: beden,
            fiyat: fiyat,
            adet: adet,
            gonderilecekFiyat: gonderilecekFiyat,
            gonderilecekPiyasaFiyati: gonderilecekPiyasaFiyati,
            pazaryeriId: pazaryeriId,
            detay: detay,
            kdv: kdv,
            anaStokKodu: vm.dStokKodu,
            ortakKod: vm.ortakKod,
            pazaryeriCode: pazaryeriCode,
          };
          break;
        case "Shopify":
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: stokKodu,
            stokAdi: stokAdi,
            durum: 1,
            barkod: barkod,
            gonderilecekAdet: gonderilecekAdet,
            alan1: "",
            alan2: "",
            alan3: "",
            alan4: "",
            alan5: "",
            alan6: "",
            alan7: "",
            alan8: "",
            alan9: "",
            alan10: "",
            renk: renk,
            beden: beden,
            fiyat: fiyat,
            adet: adet,
            gonderilecekFiyat: gonderilecekFiyat,
            gonderilecekPiyasaFiyati: gonderilecekPiyasaFiyati,
            pazaryeriId: pazaryeriId,
            detay: detay,
            kdv: kdv,
            anaStokKodu: vm.dStokKodu,
            ortakKod: vm.ortakKod,
            pazaryeriCode: pazaryeriCode,
          };
          break;
        case "Azall":
          args = {
            token: Store.state.tokenId,
            program: pazaryeri,
            stokKodu: stokKodu,
            stokAdi: stokAdi,
            durum: 1,
            barkod: barkod,
            gonderilecekAdet: gonderilecekAdet,
            alan1: "",
            alan2: "",
            alan3: "",
            alan4: "",
            alan5: "",
            alan6: "",
            alan7: "",
            alan8: "",
            alan9: "",
            alan10: "",
            renk: renk,
            beden: beden,
            fiyat: fiyat,
            adet: adet,
            gonderilecekFiyat: gonderilecekFiyat,
            gonderilecekPiyasaFiyati: gonderilecekPiyasaFiyati,
            pazaryeriId: pazaryeriId,
            detay: detay,
            kdv: kdv,
            anaStokKodu: vm.dStokKodu,
            ortakKod: vm.ortakKod,
            pazaryeriCode: pazaryeriCode,
            AzallKatalogId: vm.AzallKatalogId,
          };
          //console.log("Azall alt ürün args:"+args)
          // alert("vm.AzallKatalogId:"+vm.AzallKatalogId)
          break;
      }
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.gonderimListesineEkle(args, function (err, result) {
          if (result.gonderimListesineEkleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.gonderimListesineEkleResult);
          //console.log("gonderimListesineEkleResult" + vm.veriler);
          if (vm.veriler.response == "Ok") {
            vs.notify({
              title: "Gönderim Listesi",
              text: "Ekleme İşlemi Başarılı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } else {
            vs.notify({
              title: "Gönderim Listesi",
              text: "Eklemede Hata Oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "error",
              position: "top-center",
            });
          }
          // vm.veriler=JSON.parse(result.gonderimListesineEkleResult)

          //console.log("Alt gonderimListesineEkle: "+vm.veriler)
          // vm.resimYukle(result.gonderimListesineEkleResult,0,1,pazaryeri)
          //vm.altUrunListesi(pazaryeri, vm.ortakKod);
        });
      });

      //  vm.altUrunListesi(pazaryeri,vm.ortakKodSayi)
    },
    resimYukle(resimler, sayi, id, pazaryeri) {
      var vs = this.$vs;
      const tumResimler = JSON.parse(resimler);
      const resimSayisi = tumResimler.length;
      var vm = this;
      // console.log(tumResimler[sayi]['resim'])
      if (resimSayisi > 0) {
        const f = tumResimler[sayi]["resim"].split("\\");
        const t = f.length;
        const t1 = t - 1;
        /// console.log(f[t1])
        const soap = require("soap");
        const url = state.sistemAddress;
        const args1 = {
          resimYolu: tumResimler[sayi]["resim"],
          resimAdi: f[t1],
        };
        soap.createClient(url, function (err, client) {
          client.ftpResimYukle(args1, function (erri, result) {
            /// console.log(result.ftpResimYukleResult)
            if (result.ftpResimYukleResult == "Ok") {
              // alert("burda")
              sayi = sayi + 1;
              if (sayi < resimSayisi) {
                vm.resimYukle(resimler, sayi, id);
              } else {
                //alert("bitti")
                vs.loading.close("#b_1 > .con-vs-loading");
                document.getElementById("b_1").disabled = true;
                switch (pazaryeri) {
                  case "Trendyol":
                    vm.validateTrendyolGonder = false;
                    break;
                  case "N11":
                    vm.validateN11Gonder = false;
                    break;
                  case "Hepsiburada":
                    vm.validateHepsiburadaGonder = false;
                    break;
                  case "Ticimax":
                    vm.validateTicimaxGonder = false;
                    break;
                  case "Shopify":
                    vm.validateShopifyGonder = false;
                    break;
                }
              }
            }
          });
        });
      } else {
        switch (pazaryeri) {
          case "Trendyol":
            //   vs.loading.close("#b_1 > .con-vs-loading");
            // document.getElementById("b_1").disabled=true;
            vm.validateTrendyolGonder = false;
            break;
          case "N11":
            vs.loading.close("#b_2 > .con-vs-loading");
            document.getElementById("b_2").disabled = true;
            vm.validateN11Gonder = false;
            break;
          case "Hepsiburada":
            vs.loading.close("#b_3 > .con-vs-loading");
            document.getElementById("b_3").disabled = true;
            vm.validateHepsiburadaGonder = false;
            break;
          case "Ticimax":
            vs.loading.close("#b_4 > .con-vs-loading");
            document.getElementById("b_4").disabled = true;
            vm.validateTicimaxListeyeEkle = false;
            break;

          case "Shopify":
            vs.loading.close("#b_6 > .con-vs-loading");
            document.getElementById("b_6").disabled = true;
            vm.validateShopifyListeyeEkle = false;
            break;
        }
      }
    },
    teslimatSablonuCek() {
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {};
      soap.createClient(url, function (err, client) {
        client.teslimatSablonuCek(args, function (err, result) {
          return result.teslimatSablonuCekResult;
        });
      });
    },
    anaUrunListesi(pazaryeri) {
      const vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        pazaryeri: pazaryeri,
        kod: this.iliskiliUrunB,
      };
      soap.createClient(url, function (err, client) {
        client.anaUrunListesi(args, function (err, result) {
          vm.verilers = JSON.parse(result.anaUrunListesiResult);
          console.log(vm.verilers);
          vm.anaUrunListesiTicimax = vm.verilers;
          vm.anaUrunListesiWoocommerce = vm.verilers;
        });
      });
    },
    FiyatHesapla(KarOran, Kargo, Fiyat) {
      this.N11yeniFiyat =
        parseFloat(Fiyat) +
        (parseFloat(Fiyat) * parseFloat(KarOran)) / 100 +
        parseFloat(Kargo);
      return this.N11yeniFiyat;
    },

    pazaryeriDetay(pazaryeri) {
      this.aktifPazaryeri = pazaryeri;
      this.gonderilenStokListesi = [];
      this.gonderilenStokListesiN11 = [];
      this.gonderilenStokListesiHepsiburada = [];
      this.gonderilenStokListesiTicimax = [];
      this.validateTrendyolListeyeEkle = true;
      this.validateTrendyolGonder = true;
      this.validateN11ListeyeEkle = true;
      this.validatePazaramaListeyeEkle = true;
      this.validateIdeasoftListeyeEkle = true;
      this.validateEtsyListeyeEkle = true;
      this.validateN11Gonder = true;
      this.validateHepsiburadaListeyeEkle = true;
      this.validateHepsiburadaGonder = true;
      this.validateTicimaxListeyeEkle = true;
      this.validateTicimaxGonder = true;
      this.validateWoocommerceListeyeEkle = true;
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        pazaryeri: pazaryeri,
        barkod: vm.dBarkod,
        kod: vm.dStokKodu,
      };

      //debugger
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.stokPazaryeriDetay(args, function (err, result) {
          if (result.stokPazaryeriDetayResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          console.log("stokPazaryeriDetay");

          vm.veriler = "";

          vm.veriler = JSON.parse(result.stokPazaryeriDetayResult);
          console.log(vm.veriler);

          let stokAltKod = "";
          try {
            switch (pazaryeri) {
              case "Ticimax":
                const ortakAlanTicimax = vm.alan10.split("*");
                if (ortakAlanTicimax[0] == "ortakKod") {
                  stokAltKod = ortakAlanTicimax[1];
                } else {
                  stokAltKod = vm.dStokKodu;
                }

                vm.altUrunListesi(pazaryeri, stokAltKod);

                if (vm.dEklenmeDurumu == "anaUrun") {
                  vm.verilers = vm.anaUrunListesi("Ticimax");
                }

                break;

              case "Trendyol":
                var ortakAlanTrendyol = "";
                if (
                  vm.alan10 == null ||
                  typeof vm.alan10 == "undefined" ||
                  vm.alan10 == ""
                )
                  console.log("alan10 yok");
                else ortakAlanTrendyol = vm.alan10.split("*");
                // console.log("s1"+ortakAlanTrendyol)

                if (ortakAlanTrendyol[0] == "ortakKod") {
                  stokAltKod = ortakAlanTrendyol[1];
                } else {
                  stokAltKod = vm.dStokKodu;
                }

                vm.altUrunListesi(pazaryeri, stokAltKod);

                break;
              case "Ikas":
                vm.altUrunListesi(pazaryeri, vm.dStokKodu);

                break;
              case "Ozon":
                vm.altUrunListesi(pazaryeri, vm.dStokKodu);

                break;
              case "Tsoft":
                // alert(vm.ortakKodSayi)
                vm.altUrunListesi(pazaryeri, vm.ortakKod);
                break;
              case "Shopify":
              // alert(vm.ortakKodSayi)
              //    vm.altUrunListesi(pazaryeri,vm.ortakKod); break;
              case "N11":
                const ortakAlanN11 = vm.alan10;
                //console.log("s2"+ortakAlanTicimax)
                //console.log(ortakAlan)

                if (ortakAlanN11[0] == "ortakKod") {
                  stokAltKod = ortakAlanN11[1];
                } else {
                  stokAltKod = vm.dStokKodu;
                }

                const argsSablon = {};

                soap.createClient(url, function (err, clientSablon) {
                  clientSablon.teslimatSablonuCek(
                    argsSablon,
                    function (err, resultSablon) {
                      vm.verilers = JSON.parse(resultSablon.teslimatSablonuCekResult);

                      vm.optionsN11TeslimatSablonu = vm.verilers.json;
                      //console.log(resultSablon.teslimatSablonuCekResult)
                    }
                  );
                });
                //console.log("Teslimat Şablonu"+vm.verilers.json)
                vm.altUrunListesi(pazaryeri, stokAltKod);
                //alert(pazaryeri)
                break;

              case "Woocommerce":
                console.log(vm.alan10.includes("*"));

                if (
                  vm.alan10.includes("*") == true ||
                  vm.alan10.includes("*") == "true"
                ) {
                  const ortakAlanTicimax1 = vm.alan10.split("*");

                  if (ortakAlanTicimax1[0] == "ortakKod") {
                    stokAltKod = ortakAlanTicimax1[1];
                  } else {
                    stokAltKod = vm.ortakKod;
                  }
                } else {
                  stokAltKod = vm.ortakKod;
                }

                vm.altUrunListesi(pazaryeri, vm.dBarkod);
                break;

              case "Hepsiburada":
                vm.altUrunListesi(pazaryeri, vm.dStokKodu);
                break;

              case "Modanisa":
                vm.altUrunListesi(pazaryeri, vm.dBarkod);
                break;
            }
            console.log(pazaryeri);

            if (vm.veriler[0].error == "No") {
              switch (pazaryeri) {
                case "Trendyol":
                  vm.trendyolKategori = vm.veriler[0].pazaryeriKategori;
                  vm.trendyolKategoriId = vm.veriler[0].pazaryeriId;
                  //  console.log(vm.veriler[0].guncelStokFiyat);
                  vm.trendyolSatisFiyati = vm.veriler[0].guncelStokFiyat.replace(
                    ",",
                    "."
                  );
                  vm.trendyolPiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat.replace(
                    ",",
                    "."
                  );
                  vm.trendyolGonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;
                  // vm.ortakKod=vm.veriler[0].ortakKod
                  vm.trendyolurunEklenmeDurumu = vm.veriler[0].durumAltUrun;
                  vm.trendyolBilgilendirme = "";
                  console.log("in");
                  vm.kategoriOzellikleri(pazaryeri, vm.trendyolKategoriId);
                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validateTrendyolListeyeEkle = false;
                      vm.validateTrendyolGonder = true;
                      break;
                    case "1":
                      vm.validateTrendyolListeyeEkle = true;
                      vm.validateTrendyolGonder = false;
                      break;
                    case "2":
                      vm.validateTrendyolListeyeEkle = true;
                      vm.validateTrendyolGonder = true;
                      break;
                  }

                  if (vm.trendyolSatisFiyati == "0") {
                    vm.trendyolSatisFiyati = vm.dSatisFiyat;
                    vm.trendyolBilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.trendyolKategoriId == "") {
                    vm.trendyolBilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validateTrendyolListeyeEkle = true;
                    vm.validateTrendyolGonder = true;
                  }
                  if (vm.trendyolPiyasaFiyati == "0") {
                    vm.trendyolPiyasaFiyati = vm.dPiyasaFiyat;
                  }
                  if (vm.trendyolGonderilecekAdet == "0") {
                    vm.trendyolGonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }
                  break;

                case "N11":
                  vm.dParaBirim = vm.veriler[0].dParaBirim;
                  vm.n11Kategori = vm.veriler[0].pazaryeriKategori;
                  vm.n11KategoriId = vm.veriler[0].pazaryeriId;
                  vm.n11SatisFiyati = vm.veriler[0].guncelStokFiyat.replace(",", ".");
                  vm.n11PiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat;
                  vm.n11GonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.karOran = vm.veriler[0].karOran.replace(",", ".");
                  vm.kargoTutar = vm.veriler[0].kargoTutar.replace(",", ".");
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;
                  //alert("vm.veriler[0].durumAltUrun:" +vm.veriler[0].durumAltUrun)
                  vm.N11urunEklenmeDurumu = vm.veriler[0].durumAltUrun;
                  vm.n11Bilgilendirme = "";
                  //alert("alan10:"+vm.alan10)
                  vm.kategoriOzellikleri(pazaryeri, vm.n11KategoriId);
                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validateN11ListeyeEkle = false;
                      vm.validateN11Gonder = true;
                      break;
                    case "1":
                      vm.validateN11ListeyeEkle = true;
                      vm.validateN11Gonder = false;
                      break;
                    case "2":
                      vm.validateN11ListeyeEkle = true;
                      vm.validateN11Gonder = true;
                      break;
                  }

                  if (vm.n11SatisFiyati == "0") {
                    vm.n11SatisFiyati = vm.dSatisFiyat;
                    vm.n11Bilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.n11KategoriId == "") {
                    vm.n11Bilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validateN11ListeyeEkle = true;
                    vm.validateN11Gonder = true;
                  }
                  if (vm.n11PiyasaFiyati == "0") {
                    vm.n11PiyasaFiyati = vm.dPiyasaFiyat;
                  }
                  if (vm.n11GonderilecekAdet == "0") {
                    vm.n11GonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }

                  break;

                case "Hepsiburada":
                  vm.hepsiburadaKategori = vm.veriler[0].pazaryeriKategori;
                  vm.hepsiburadaKategoriId = vm.veriler[0].pazaryeriId;
                  vm.hepsiburadaSatisFiyati = vm.veriler[0].guncelStokFiyat.replace(
                    ",",
                    "."
                  );
                  vm.hepsiburadaPiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat.replace(
                    ",",
                    "."
                  );
                  vm.hepsiburadaGonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;

                  vm.hepsiburadaBilgilendirme = "";
                  console.log(vm.veriler[0].alan8);
                  console.log(vm.alan8Pd);
                  vm.kategoriOzellikleri(pazaryeri, vm.hepsiburadaKategoriId);
                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validateHepsiburadaListeyeEkle = false;
                      vm.validateHepsiburadaGonder = true;
                      break;
                    case "1":
                      vm.validateHepsiburadaListeyeEkle = true;
                      vm.validateHepsiburadaGonder = false;
                      break;
                    case "2":
                      vm.validateHepsiburadaListeyeEkle = true;
                      vm.validateHepsiburadaGonder = true;
                      break;
                  }

                  if (vm.hepsiburadaSatisFiyati == "0") {
                    vm.hepsiburadaSatisFiyati = vm.dSatisFiyat;
                    vm.hepsiburadaBilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.hepsiburadaKategoriId == "") {
                    vm.hepsiburadaBilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validateHepsiburadaListeyeEkle = true;
                    vm.validateHepsiburadaGonder = true;
                  }
                  if (vm.hepsiburadaPiyasaFiyati == "0") {
                    vm.hepsiburadaPiyasaFiyati = vm.dPiyasaFiyat;
                  }
                  if (vm.hepsiburadaGonderilecekAdet == "0") {
                    vm.hepsiburadaGonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }
                  break;

                case "Ticimax":
                  vm.ticimaxKategori = vm.veriler[0].pazaryeriKategori;
                  vm.ticimaxKategoriId = vm.veriler[0].pazaryeriId;
                  vm.ticimaxSatisFiyati = vm.veriler[0].guncelStokFiyat.replace(",", ".");
                  vm.ticimaxPiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat.replace(
                    ",",
                    "."
                  );
                  vm.ticimaxGonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;

                  vm.ticimaxurunEklenmeDurumu = vm.veriler[0].durumAltUrun;
                  // console.log(vm.ticimaxurunEklenmeDurumu)
                  vm.kategoriOzellikleri(pazaryeri, vm.ticimaxKategoriId);
                  vm.ticimaxBilgilendirme = "";
                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validateTicimaxListeyeEkle = false;
                      vm.validateTicimaxGonder = true;
                      break;
                    case "1":
                      vm.validateTicimaxListeyeEkle = true;
                      vm.validateTicimaxGonder = false;
                      break;
                    case "2":
                      vm.validateTicimaxListeyeEkle = true;
                      vm.validateTicimaxGonder = true;
                      break;
                  }

                  if (vm.ticimaxSatisFiyati == "0") {
                    vm.ticimaxSatisFiyati = vm.dSatisFiyat;
                    vm.ticimaxBilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.ticimaxKategoriId == "") {
                    vm.ticimaxBilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validateTicimaxListeyeEkle = true;
                    vm.validateTicimaxGonder = true;
                  }
                  if (vm.ticimaxPiyasaFiyati == "0") {
                    vm.ticimaxPiyasaFiyati = vm.dPiyasaFiyat;
                  }
                  if (vm.ticimaxGonderilecekAdet == "0") {
                    vm.ticimaxGonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }
                  break;

                case "Tsoft":
                  vm.tsoftKategori = vm.veriler[0].pazaryeriKategori;
                  vm.tsoftKategoriId = vm.veriler[0].pazaryeriId;
                  vm.tsoftSatisFiyati = vm.veriler[0].guncelStokFiyat.replace(",", ".");
                  console.log(vm.tsoftSatisFiyati);
                  vm.tsoftPiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat.replace(
                    ",",
                    "."
                  );
                  vm.tsoftGonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;
                  vm.alan10 = vm.veriler[0].alan10;
                  vm.urunEklenmeDurumu = vm.veriler[0].durumAltUrun;
                  //  alert(vm.urunEklenmeDurumu)
                  //  vm.ortakKod=vm.veriler[0].ortakKod
                  // vm.ortakKodSayi=vm.veriler[0].alan5
                  //console.log(vm.alan10)

                  vm.tsoftBilgilendirme = "";
                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validateTsoftListeyeEkle = false;
                      vm.validateTsoftGonder = true;
                      break;
                    case "1":
                      vm.validateTsoftListeyeEkle = true;
                      vm.validateTsoftGonder = false;
                      break;
                    case "2":
                      vm.validateTsoftListeyeEkle = true;
                      vm.validateTsoftGonder = true;
                      break;
                  }

                  if (vm.tsoftSatisFiyati == "0") {
                    vm.tsoftSatisFiyati = vm.dSatisFiyat;
                    vm.tsoftBilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.tsoftKategoriId == "") {
                    vm.tsoftBilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validateTsoftListeyeEkle = true;
                    vm.validateTsoftGonder = true;
                  }
                  if (vm.tsoftPiyasaFiyati == "0") {
                    vm.tsoftPiyasaFiyati = vm.dPiyasaFiyat;
                  }
                  if (vm.tsoftGonderilecekAdet == "0") {
                    vm.tsoftGonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }
                  vm.kategoriOzellikleri(pazaryeri, vm.tsoftKategoriId);
                  break;

                case "Gittigidiyor":
                  vm.ozellikEslemeListesi("Gittigidiyor");
                  vm.gittigidiyorKategori = vm.veriler[0].pazaryeriKategori;
                  vm.gittigidiyorKategoriId = vm.veriler[0].pazaryeriId;
                  vm.gittigidiyorSatisFiyati = vm.veriler[0].guncelStokFiyat.replace(
                    ",",
                    "."
                  );
                  vm.gittigidiyorPiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat.replace(
                    ",",
                    "."
                  );
                  vm.gittigidiyorGonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;
                  vm.dDurum = vm.veriler[0].durum;
                  vm.alan10 = vm.veriler[0].alan10;
                  vm.urunEklenmeDurumu = vm.veriler[0].durumAltUrun;

                  //  vm.ortakKod=vm.veriler[0].ortakKod
                  // vm.ortakKodSayi=vm.veriler[0].alan5
                  //console.log(vm.alan10)
                  vm.gittigidiyorBilgilendirme = "";
                  vm.kategoriOzellikleri(pazaryeri, vm.gittigidiyorKategoriId);
                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validateGittigidiyorListeyeEkle = false;
                      vm.validateGittigidiyorGonder = true;
                      break;
                    case "1":
                      vm.validateGittigidiyorListeyeEkle = true;
                      vm.validateGittigidiyorGonder = false;
                      break;
                    case "2":
                      vm.validateGittigidiyorListeyeEkle = true;
                      vm.validateGittigidiyorGonder = true;
                      break;
                    default:
                      vm.validateGittigidiyorListeyeEkle = true;
                      break;
                  }

                  if (vm.gittigidiyorSatisFiyati == "0") {
                    vm.gittigidiyorSatisFiyati = vm.dSatisFiyat;
                    vm.gittigidiyorBilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.gittigidiyorKategoriId == "") {
                    vm.gittigidiyorBilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validateGittigidiyorListeyeEkle = true;
                    vm.validateGittigidiyorGonder = true;
                  }
                  if (vm.gittigidiyorPiyasaFiyati == "0") {
                    vm.gittigidiyorPiyasaFiyati = vm.dPiyasaFiyat;
                  }
                  if (vm.gittigidiyorGonderilecekAdet == "0") {
                    vm.gittigidiyorGonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }

                  break;

                case "Ciceksepeti":
                  vm.ciceksepetiKategori = vm.veriler[0].pazaryeriKategori;
                  vm.ciceksepetiKategoriId = vm.veriler[0].pazaryeriId;
                  vm.ciceksepetiSatisFiyati = vm.veriler[0].guncelStokFiyat.replace(
                    ",",
                    "."
                  );
                  vm.ciceksepetiPiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat.replace(
                    ",",
                    "."
                  );
                  vm.ciceksepetiGonderilecekAdet = vm.veriler[0].gonderilecekAdet; //ciceksepetinde Hata çıkarsa  vm.ciceksepetitGonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;

                  vm.alan10 = vm.veriler[0].alan10;
                  vm.urunEklenmeDurumu = vm.veriler[0].durumAltUrun;
                  //  alert(vm.urunEklenmeDurumu)
                  //  vm.ortakKod=vm.veriler[0].ortakKod
                  // vm.ortakKodSayi=vm.veriler[0].alan5
                  //console.log(vm.alan10)
                  vm.ciceksepetiBilgilendirme = "";
                  vm.kategoriOzellikleri(pazaryeri, vm.ciceksepetiKategoriId);
                  //alert(vm.ciceksepetiKategoriId)
                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validateCiceksepetiListeyeEkle = false;
                      vm.validateCiceksepetiGonder = true;
                      break;
                    case "1":
                      vm.validateCiceksepetiListeyeEkle = true;
                      vm.validateCiceksepetiGonder = false;
                      break;
                    case "2":
                      vm.validateCiceksepetiListeyeEkle = true;
                      vm.validateCiceksepetiGonder = true;
                      break;
                  }

                  if (vm.ciceksepetiSatisFiyati == "0") {
                    vm.ciceksepetiSatisFiyati = vm.dSatisFiyat;
                    vm.ciceksepetiBilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.ciceksepetiKategoriId == "") {
                    vm.ciceksepetiBilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validateCiceksepetiListeyeEkle = true;
                    vm.validateCiceksepetiGonder = true;
                  }
                  if (vm.ciceksepetiPiyasaFiyati == "0") {
                    vm.ciceksepetiPiyasaFiyati = vm.dPiyasaFiyat;
                  }
                  if (vm.ciceksepetiGonderilecekAdet == "0") {
                    vm.ciceksepetiGonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }
                  break;

                case "Ikas":
                  vm.ikasKategori = vm.veriler[0].pazaryeriKategori;
                  vm.ikasKategoriId = vm.veriler[0].pazaryeriId;
                  vm.ikasSatisFiyati = vm.veriler[0].guncelStokFiyat.replace(",", ".");
                  vm.ikasPiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat.replace(",", ".");
                  vm.ikasGonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;

                  vm.alan10 = vm.veriler[0].alan10;
                  vm.urunEklenmeDurumu = vm.veriler[0].durumAltUrun;
                  //  alert(vm.urunEklenmeDurumu)
                  //  vm.ortakKod=vm.veriler[0].ortakKod
                  // vm.ortakKodSayi=vm.veriler[0].alan5
                  //console.log(vm.alan10)
                  vm.kategoriOzellikleri(pazaryeri, vm.ikasKategoriId);

                  vm.ikasBilgilendirme = "";
                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validateIkasListeyeEkle = false;
                      vm.validateIkasGonder = true;
                      break;
                    case "1":
                      vm.validateIkasListeyeEkle = true;
                      vm.validateIkasGonder = false;
                      break;
                    case "2":
                      vm.validateIkasListeyeEkle = true;
                      vm.validateIkasGonder = true;
                      break;
                  }

                  if (vm.ikasSatisFiyati == "0") {
                    vm.ikasSatisFiyati = vm.dSatisFiyat;
                    vm.ikasBilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.ikasKategoriId == "") {
                    vm.ikasBilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validateIkasListeyeEkle = true;
                    vm.validateIkasGonder = true;
                  }
                  if (vm.ikasPiyasaFiyati == "0") {
                    vm.ikasPiyasaFiyati = vm.dPiyasaFiyat;
                  }
                  if (vm.ikasGonderilecekAdet == "0") {
                    vm.ikasGonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }
                  break;

                case "Ozon":
                  vm.ozonKategori = vm.veriler[0].pazaryeriKategori;
                  vm.ozonKategoriId = vm.veriler[0].pazaryeriId;
                  vm.ozonSatisFiyati = vm.veriler[0].guncelStokFiyat.replace(",", ".");
                  vm.ozonPiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat.replace(",", ".");
                  vm.ozonGonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;

                  vm.alan10 = vm.veriler[0].alan10;
                  vm.urunEklenmeDurumu = vm.veriler[0].durumAltUrun;
                  //  alert(vm.urunEklenmeDurumu)
                  //  vm.ortakKod=vm.veriler[0].ortakKod
                  // vm.ortakKodSayi=vm.veriler[0].alan5
                  //console.log(vm.alan10)
                  vm.kategoriOzellikleri(pazaryeri, vm.ozonKategoriId);

                  vm.ozonBilgilendirme = "";
                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validateOzonListeyeEkle = false;
                      vm.validateOzonGonder = true;
                      break;
                    case "1":
                      vm.validateOzonListeyeEkle = true;
                      vm.validateOzonGonder = false;
                      break;
                    case "2":
                      vm.validateOzonListeyeEkle = true;
                      vm.validateOzonGonder = true;
                      break;
                  }

                  if (vm.ozonSatisFiyati == "0") {
                    vm.ozonSatisFiyati = vm.dSatisFiyat;
                    vm.ozonBilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.ozonKategoriId == "") {
                    vm.ozonBilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validateOzonListeyeEkle = true;
                    vm.validateOzonGonder = true;
                  }
                  if (vm.ozonPiyasaFiyati == "0") {
                    vm.ozonPiyasaFiyati = vm.dPiyasaFiyat;
                  }
                  if (vm.ozonGonderilecekAdet == "0") {
                    vm.ozonGonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }
                  break;
                case "Modanisa":
                  vm.modanisaKategori = vm.veriler[0].pazaryeriKategori;
                  vm.modanisaKategoriId = vm.veriler[0].pazaryeriId;
                  vm.modanisaSatisFiyati = vm.veriler[0].guncelStokFiyat.replace(
                    ",",
                    "."
                  );
                  vm.modanisaPiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat.replace(
                    ",",
                    "."
                  );
                  vm.modanisaGonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;

                  vm.alan10 = vm.veriler[0].alan10;
                  vm.urunEklenmeDurumu = vm.veriler[0].durumAltUrun;
                  //  alert(vm.urunEklenmeDurumu)
                  //  vm.ortakKod=vm.veriler[0].ortakKod
                  // vm.ortakKodSayi=vm.veriler[0].alan5
                  //console.log(vm.alan10)
                  vm.kategoriOzellikleri(pazaryeri, vm.modanisaKategoriId);

                  vm.modanisaBilgilendirme = "";
                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validateModanisaListeyeEkle = false;
                      vm.validateModanisaGonder = true;
                      break;
                    case "1":
                      vm.validateModanisaListeyeEkle = true;
                      vm.validateModanisaGonder = false;
                      break;
                    case "2":
                      vm.validateModanisaListeyeEkle = true;
                      vm.validateModanisaGonder = true;
                      break;
                  }

                  if (vm.modanisaSatisFiyati == "0") {
                    vm.modanisaSatisFiyati = vm.dSatisFiyat;
                    vm.modanisaBilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.modanisaKategoriId == "") {
                    vm.modanisaBilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validateModanisaListeyeEkle = true;
                    vm.validateModanisaGonder = true;
                  }
                  if (vm.modanisaPiyasaFiyati == "0") {
                    vm.modanisaPiyasaFiyati = vm.dPiyasaFiyat;
                  }
                  if (vm.modanisaGonderilecekAdet == "0") {
                    vm.modanisaGonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }
                  break;

                case "Opencart":
                  vm.opencartKategori = vm.veriler[0].pazaryeriKategori;
                  vm.opencartKategoriId = vm.veriler[0].pazaryeriId;
                  vm.opencartSatisFiyati = vm.veriler[0].guncelStokFiyat.replace(
                    ",",
                    "."
                  );
                  vm.opencartPiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat.replace(
                    ",",
                    "."
                  );
                  vm.opencartGonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;

                  vm.alan10 = vm.veriler[0].alan10;
                  vm.urunEklenmeDurumu = vm.veriler[0].durumAltUrun;
                  //  alert(vm.urunEklenmeDurumu)
                  //  vm.ortakKod=vm.veriler[0].ortakKod
                  // vm.ortakKodSayi=vm.veriler[0].alan5
                  //console.log(vm.alan10)
                  vm.kategoriOzellikleri(pazaryeri, vm.opencartKategoriId);

                  vm.opencartBilgilendirme = "";
                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validateOpencartListeyeEkle = false;
                      vm.validateOpencartGonder = true;
                      break;
                    case "1":
                      vm.validateOpencartListeyeEkle = true;
                      vm.validateOpencartGonder = false;
                      break;
                    case "2":
                      vm.validateOpencartListeyeEkle = true;
                      vm.validateOpencartGonder = true;
                      break;
                  }

                  if (vm.opencartSatisFiyati == "0") {
                    vm.opencartSatisFiyati = vm.dSatisFiyat;
                    vm.opencartBilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.opencartKategoriId == "") {
                    vm.opencartBilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validateOpencartListeyeEkle = true;
                    vm.validateOpencartGonder = true;
                  }
                  if (vm.opencartPiyasaFiyati == "0") {
                    vm.opencartPiyasaFiyati = vm.dPiyasaFiyat;
                  }
                  if (vm.opencartGonderilecekAdet == "0") {
                    vm.opencartGonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }
                  break;
                case "Allesgo":
                  vm.allesgoKategori = vm.veriler[0].pazaryeriKategori;
                  vm.allesgoKategoriId = vm.veriler[0].pazaryeriId;
                  vm.allesgoSatisFiyati = vm.veriler[0].guncelStokFiyat.replace(",", ".");
                  vm.allesgoPiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat.replace(
                    ",",
                    "."
                  );
                  vm.allesgoGonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;

                  vm.alan10 = vm.veriler[0].alan10;
                  vm.urunEklenmeDurumu = vm.veriler[0].durumAltUrun;
                  //  alert(vm.urunEklenmeDurumu)
                  //  vm.ortakKod=vm.veriler[0].ortakKod
                  // vm.ortakKodSayi=vm.veriler[0].alan5
                  //console.log(vm.alan10)
                  vm.kategoriOzellikleri(pazaryeri, vm.allesgoKategoriId);

                  vm.allesgoBilgilendirme = "";
                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validateAllesgoListeyeEkle = false;
                      vm.validateAllesgoGonder = true;
                      break;
                    case "1":
                      vm.validateAllesgoListeyeEkle = true;
                      vm.validateAllesgoGonder = false;
                      break;
                    case "2":
                      vm.validateAllesgoListeyeEkle = true;
                      vm.validateAllesgoGonder = true;
                      break;
                  }

                  if (vm.allesgoSatisFiyati == "0") {
                    vm.allesgoSatisFiyati = vm.dSatisFiyat;
                    vm.allesgoBilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.allesgoKategoriId == "") {
                    vm.allesgoBilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validateAllesgoListeyeEkle = true;
                    vm.validateAllesgoGonder = true;
                  }
                  if (vm.allesgoPiyasaFiyati == "0") {
                    vm.allesgoPiyasaFiyati = vm.dPiyasaFiyat;
                  }
                  if (vm.allesgoGonderilecekAdet == "0") {
                    vm.allesgoGonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }
                  break;

                case "AkinSoft":
                  vm.akinSoftKategori = vm.veriler[0].pazaryeriKategori;
                  vm.akinSoftKategoriId = vm.veriler[0].pazaryeriId;
                  vm.akinSoftSatisFiyati = vm.veriler[0].guncelStokFiyat.replace(
                    ",",
                    "."
                  );
                  vm.akinSoftPiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat.replace(
                    ",",
                    "."
                  );
                  vm.akinSoftGonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;

                  vm.alan10 = vm.veriler[0].alan10;
                  vm.urunEklenmeDurumu = vm.veriler[0].durumAltUrun;
                  //  alert(vm.urunEklenmeDurumu)
                  //  vm.ortakKod=vm.veriler[0].ortakKod
                  // vm.ortakKodSayi=vm.veriler[0].alan5
                  //console.log(vm.alan10)
                  vm.kategoriOzellikleri(pazaryeri, vm.akinSoftKategoriId);

                  vm.akinSoftBilgilendirme = "";
                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validateAkinSoftListeyeEkle = false;
                      vm.validateAkinSoftGonder = true;
                      break;
                    case "1":
                      vm.validateAkinSoftListeyeEkle = true;
                      vm.validateAkinSoftGonder = false;
                      break;
                    case "2":
                      vm.validateAkinSoftListeyeEkle = true;
                      vm.validateAkinSoftGonder = true;
                      break;
                  }

                  if (vm.akinSoftSatisFiyati == "0") {
                    vm.akinSoftSatisFiyati = vm.dSatisFiyat;
                    vm.akinSoftBilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.akinSoftKategoriId == "") {
                    vm.akinSoftBilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validateAkinSoftListeyeEkle = true;
                    vm.validateAkinSoftGonder = true;
                  }
                  if (vm.akinSoftPiyasaFiyati == "0") {
                    vm.akinSoftPiyasaFiyati = vm.dPiyasaFiyat;
                  }
                  if (vm.akinSoftGonderilecekAdet == "0") {
                    vm.akinSoftGonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }
                  break;

                case "PlatinMarket":
                  vm.platinmarketKategori = vm.veriler[0].pazaryeriKategori;
                  vm.platinmarketKategoriId = vm.veriler[0].pazaryeriId;
                  vm.platinmarketSatisFiyati = vm.veriler[0].guncelStokFiyat.replace(
                    ",",
                    "."
                  );
                  vm.platinmarketPiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat.replace(
                    ",",
                    "."
                  );
                  vm.platinmarkettGonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;

                  vm.alan10 = vm.veriler[0].alan10;
                  vm.urunEklenmeDurumu = vm.veriler[0].durumAltUrun;
                  //  alert(vm.urunEklenmeDurumu)
                  //  vm.ortakKod=vm.veriler[0].ortakKod
                  // vm.ortakKodSayi=vm.veriler[0].alan5
                  //console.log(vm.alan10)
                  vm.kategoriOzellikleri(pazaryeri, vm.platinmarketKategoriId);

                  vm.platinmarketBilgilendirme = "";
                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validatePlatinmarketListeyeEkle = false;
                      vm.validatePlatinmarketGonder = true;
                      break;
                    case "1":
                      vm.validatePlatinmarketListeyeEkle = true;
                      vm.validatePlatinmarketGonder = false;
                      break;
                    case "2":
                      vm.validatePlatinmarketListeyeEkle = true;
                      vm.validatePlatinmarketGonder = true;
                      break;
                  }

                  if (vm.platinmarketSatisFiyati == "0") {
                    vm.platinmarketSatisFiyati = vm.dSatisFiyat;
                    vm.platinmarketBilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.platinmarketKategoriId == "") {
                    vm.platinmarketBilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validatePlatinmarketListeyeEkle = true;
                    vm.validatePlatinmarketGonder = true;
                  }
                  if (vm.platinmarketPiyasaFiyati == "0") {
                    vm.platinmarketPiyasaFiyati = vm.dPiyasaFiyat;
                  }
                  if (vm.platinmarketGonderilecekAdet == "0") {
                    vm.platinmarketGonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }
                  break;

                case "Woocommerce":
                  vm.WoocommerceKategori = vm.veriler[0].pazaryeriKategori;
                  vm.WoocommerceKategoriId = vm.veriler[0].pazaryeriId;
                  vm.WoocommerceSatisFiyati = vm.veriler[0].guncelStokFiyat.replace(
                    ",",
                    "."
                  );
                  vm.WoocommercePiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat.replace(
                    ",",
                    "."
                  );
                  vm.WoocommerceGonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;
                  vm.alan10 = vm.veriler[0].alan10;
                  vm.urunEklenmeDurumu = vm.veriler[0].durumAltUrun;
                  //  alert(vm.urunEklenmeDurumu)
                  vm.ortakKod = vm.veriler[0].ortakKod;

                  // vm.ortakKodSayi=vm.veriler[0].alan5
                  //console.log(vm.alan10)
                  vm.kategoriOzellikleri(pazaryeri, vm.WoocommerceKategoriId);

                  vm.WoocommerceBilgilendirme = "";
                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validateWoocommerceListeyeEkle = false;
                      vm.validateWoocommerceGonder = true;
                      break;
                    case "1":
                      vm.validateWoocommerceListeyeEkle = true;
                      vm.validateWoocommerceGonder = false;
                      break;
                    case "2":
                      vm.validateWoocommerceListeyeEkle = true;
                      vm.validateWoocommerceGonder = true;
                      break;
                  }

                  if (vm.WoocommerceSatisFiyati == "0") {
                    vm.WoocommerceSatisFiyati = vm.dSatisFiyat;
                    vm.WoocommerceBilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.WoocommerceKategoriId == "") {
                    vm.WoocommerceBilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validateWoocommerceListeyeEkle = true;
                    vm.validateWoocommerceGonder = true;
                  }
                  if (vm.WoocommercePiyasaFiyati == "0") {
                    vm.WoocommercePiyasaFiyati = vm.dPiyasaFiyat;
                  }
                  if (vm.WoocommerceGonderilecekAdet == "0") {
                    vm.WoocommerceGonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }
                  break;

                case "PttAvm":
                  vm.PttAvmKategori = vm.veriler[0].pazaryeriKategori;
                  vm.PttAvmKategoriId = vm.veriler[0].pazaryeriId;
                  vm.PttAvmSatisFiyati = vm.veriler[0].guncelStokFiyat.replace(",", ".");
                  vm.PttAvmPiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat.replace(
                    ",",
                    "."
                  );
                  vm.PttAvmGonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;
                  vm.alan10 = vm.veriler[0].alan10;
                  vm.urunEklenmeDurumu = vm.veriler[0].durumAltUrun;
                  vm.ortakKod = vm.veriler[0].ortakKod;

                  vm.PttAvmBilgilendirme = "";
                  vm.kategoriOzellikleri(pazaryeri, vm.PttAvmKategoriId);

                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validatePttAvmListeyeEkle = false;
                      vm.validatePttAvmGonder = true;
                      break;
                    case "1":
                      vm.validatePttAvmListeyeEkle = true;
                      vm.validatePttAvmGonder = false;
                      break;
                    case "2":
                      vm.validatePttAvmListeyeEkle = true;
                      vm.validatePttAvmGonder = true;
                      break;
                  }

                  if (vm.PttAvmSatisFiyati == "0") {
                    vm.PttAvmSatisFiyati = vm.dSatisFiyat;
                    vm.PttAvmBilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.PttAvmKategoriId == "") {
                    vm.PttAvmBilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validatePttAvmListeyeEkle = true;
                    vm.validatePttAvmGonder = true;
                  }

                  if (vm.PttAvmSatisFiyati == "0") {
                    vm.PttAvmPiyasaFiyati = vm.dPiyasaFiyat;
                  }

                  if (vm.PttAvmGonderilecekAdet == "0") {
                    vm.PttAvmGonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }
                  break;

                case "Azall":
                  vm.AzallKategori = vm.veriler[0].pazaryeriKategori;
                  vm.AzallKategoriId = vm.veriler[0].pazaryeriId;
                  vm.AzallSatisFiyati = vm.veriler[0].guncelStokFiyat.replace(",", ".");
                  vm.AzallPiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat.replace(
                    ",",
                    "."
                  );
                  vm.AzallGonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;
                  vm.alan10 = vm.veriler[0].alan10;
                  vm.urunEklenmeDurumu = vm.veriler[0].durumAltUrun;
                  vm.ortakKod = vm.veriler[0].ortakKod;

                  vm.AzallBilgilendirme = "";
                  vm.kategoriOzellikleri(pazaryeri, vm.AzallKategoriId);

                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validateAzallListeyeEkle = false;
                      vm.validateAzallGonder = true;
                      break;
                    case "1":
                      vm.validateAzallListeyeEkle = true;
                      vm.validateAzallGonder = false;
                      break;
                    case "2":
                      vm.validateAzallListeyeEkle = true;
                      vm.validateAzallGonder = true;
                      break;
                  }

                  if (vm.AzallSatisFiyati == "0") {
                    vm.AzallSatisFiyati = vm.dSatisFiyat;
                    vm.AzallBilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.AzallKategoriId == "") {
                    vm.AzallBilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validateAzallListeyeEkle = true;
                    vm.validateAzallGonder = true;
                  }

                  if (vm.AzallSatisFiyati == "0") {
                    vm.AzallPiyasaFiyati = vm.dPiyasaFiyat;
                  }
                  if (vm.AzallGonderilecekAdet == "0") {
                    vm.AzallGonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }
                  break;

                case "Shopify":
                  vm.shopifyKategori = vm.veriler[0].pazaryeriKategori;
                  vm.shopifyKategoriId = vm.veriler[0].pazaryeriId;
                  vm.shopifySatisFiyati = vm.veriler[0].guncelStokFiyat.replace(",", ".");
                  vm.shopifyPiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat.replace(
                    ",",
                    "."
                  );
                  vm.shopifyGonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;

                  vm.alan10 = vm.veriler[0].alan10;
                  vm.urunEklenmeDurumu = vm.veriler[0].durumAltUrun;
                  //  alert(vm.urunEklenmeDurumu)
                  //  vm.ortakKod=vm.veriler[0].ortakKod
                  // vm.ortakKodSayi=vm.veriler[0].alan5
                  vm.kategoriOzellikleri(pazaryeri, vm.shopifyKategoriId);

                  vm.shopifyBilgilendirme = "";
                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validateShopifyListeyeEkle = false;
                      vm.validateShopifyGonder = true;
                      break;
                    case "1":
                      vm.validateShopifyListeyeEkle = true;
                      vm.validateShopifyGonder = false;
                      break;
                    case "2":
                      vm.validateShopifyListeyeEkle = true;
                      vm.validateShopifyGonder = true;
                      break;
                  }

                  if (vm.shopifySatisFiyati == "0") {
                    vm.shopifySatisFiyati = vm.dSatisFiyat;
                    vm.shopifyBilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.shopifyKategoriId == "") {
                    vm.shopifyBilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validateShopifyListeyeEkle = true;
                    vm.validateShopifyGonder = true;
                  }
                  if (vm.shopifyPiyasaFiyati == "0") {
                    vm.shopifyPiyasaFiyati = vm.dPiyasaFiyat;
                  }
                  if (vm.shopifyGonderilecekAdet == "0") {
                    vm.shopifyGonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }
                  break;

                case "Pazarama":
                  vm.dParaBirim = vm.veriler[0].dParaBirim;
                  vm.pazaramaKategori = vm.veriler[0].pazaryeriKategori;
                  vm.pazaramaKategoriId = vm.veriler[0].pazaryeriId;
                  vm.pazaramaSatisFiyati = vm.veriler[0].guncelStokFiyat.replace(
                    ",",
                    "."
                  );
                  vm.pazaramaPiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat;
                  vm.pazaramaGonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.karOran = vm.veriler[0].karOran.replace(",", ".");
                  vm.kargoTutar = vm.veriler[0].kargoTutar.replace(",", ".");
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;
                  //alert("vm.veriler[0].durumAltUrun:" +vm.veriler[0].durumAltUrun)
                  vm.PazaramaurunEklenmeDurumu = vm.veriler[0].durumAltUrun;
                  vm.pazaramaBilgilendirme = "";
                  //alert("alan10:"+vm.alan10)
                  console.log("in");
                  vm.kategoriOzellikleri(pazaryeri, vm.pazaramaKategoriId);
                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validatePazaramaListeyeEkle = false;
                      vm.validatePazaramaGonder = true;
                      break;
                    case "1":
                      vm.validatePazaramaListeyeEkle = true;
                      vm.validatePazaramaGonder = false;
                      break;
                    case "2":
                      vm.validatePazaramaListeyeEkle = true;
                      vm.validatePazaramaGonder = true;
                      break;
                  }

                  if (vm.pazaramaSatisFiyati == "0") {
                    vm.pazaramaSatisFiyati = vm.dSatisFiyat;
                    vm.pazaramaBilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.pazaramaKategoriId == "") {
                    vm.pazaramaBilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validatePazaramaListeyeEkle = true;
                    vm.validatePazaramaGonder = true;
                  }
                  if (vm.pazaramaPiyasaFiyati == "0") {
                    vm.pazaramaPiyasaFiyati = vm.dPiyasaFiyat;
                  }
                  if (vm.pazaramaGonderilecekAdet == "0") {
                    vm.pazaramaGonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }

                  break;

                case "Ideasoft":
                  vm.dParaBirim = vm.veriler[0].dParaBirim;
                  vm.ideasoftKategori = vm.veriler[0].pazaryeriKategori;
                  vm.ideasoftKategoriId = vm.veriler[0].pazaryeriId;
                  vm.ideasoftSatisFiyati = vm.veriler[0].guncelStokFiyat.replace(
                    ",",
                    "."
                  );
                  vm.ideasoftPiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat;
                  vm.ideasoftGonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.karOran = vm.veriler[0].karOran.replace(",", ".");
                  vm.kargoTutar = vm.veriler[0].kargoTutar.replace(",", ".");
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;
                  //alert("vm.veriler[0].durumAltUrun:" +vm.veriler[0].durumAltUrun)
                  vm.IdeasofturunEklenmeDurumu = vm.veriler[0].durumAltUrun;
                  vm.ideasoftBilgilendirme = "";
                  //alert("alan10:"+vm.alan10)
                  console.log("in");
                  vm.kategoriOzellikleri(pazaryeri, vm.ideasoftKategoriId);
                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validateIdeasoftListeyeEkle = false;
                      vm.validateIdeasoftGonder = true;
                      break;
                    case "1":
                      vm.validateIdeasoftListeyeEkle = true;
                      vm.validateIdeasoftGonder = false;
                      break;
                    case "2":
                      vm.validateIdeasoftListeyeEkle = true;
                      vm.validateIdeasoftGonder = true;
                      break;
                  }

                  if (vm.ideasoftSatisFiyati == "0") {
                    vm.ideasoftSatisFiyati = vm.dSatisFiyat;
                    vm.ideasoftBilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.ideasoftKategoriId == "") {
                    vm.ideasoftBilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validateIdeasoftListeyeEkle = true;
                    vm.validateIdeasoftGonder = true;
                  }
                  if (vm.ideasoftPiyasaFiyati == "0") {
                    vm.ideasoftPiyasaFiyati = vm.dPiyasaFiyat;
                  }
                  if (vm.ideasoftGonderilecekAdet == "0") {
                    vm.ideasoftGonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }

                  break;

                case "Etsy":
                  vm.dParaBirim = vm.veriler[0].dParaBirim;
                  vm.etsyKategori = vm.veriler[0].pazaryeriKategori;
                  vm.etsyKategoriId = vm.veriler[0].pazaryeriId;
                  vm.etsySatisFiyati = vm.veriler[0].guncelStokFiyat.replace(",", ".");
                  vm.etsyPiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat;
                  vm.etsyGonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.karOran = vm.veriler[0].karOran.replace(",", ".");
                  vm.kargoTutar = vm.veriler[0].kargoTutar.replace(",", ".");
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;
                  //alert("vm.veriler[0].durumAltUrun:" +vm.veriler[0].durumAltUrun)
                  vm.EtsyurunEklenmeDurumu = vm.veriler[0].durumAltUrun;
                  vm.etsyBilgilendirme = "";
                  //alert("alan10:"+vm.alan10)
                  console.log("in");
                  vm.kategoriOzellikleri(pazaryeri, vm.etsyKategoriId);
                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validateEtsyListeyeEkle = false;
                      vm.validateEtsyGonder = true;
                      break;
                    case "1":
                      vm.validateEtsyListeyeEkle = true;
                      vm.validateEtsyGonder = false;
                      break;
                    case "2":
                      vm.validateEtsyListeyeEkle = true;
                      vm.validateEtsyGonder = true;
                      break;
                  }

                  if (vm.etsySatisFiyati == "0") {
                    vm.etsySatisFiyati = vm.dSatisFiyat;
                    vm.etsyBilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.etsyKategoriId == "") {
                    vm.etsyBilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validateEtsyListeyeEkle = true;
                    vm.validateEtsyGonder = true;
                  }
                  if (vm.etsyPiyasaFiyati == "0") {
                    vm.etsyPiyasaFiyati = vm.dPiyasaFiyat;
                  }
                  if (vm.etsyGonderilecekAdet == "0") {
                    vm.etsyGonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }

                  break;

                case "PhpWebServis":
                  vm.dParaBirim = vm.veriler[0].dParaBirim;
                  vm.PhpWebServisKategori = vm.veriler[0].pazaryeriKategori;
                  vm.PhpWebServisKategoriId = vm.veriler[0].pazaryeriId;
                  vm.PhpWebServisSatisFiyati = vm.veriler[0].guncelStokFiyat.replace(
                    ",",
                    "."
                  );
                  vm.PhpWebServisPiyasaFiyati = vm.veriler[0].guncelPiyasaFiyat;
                  vm.PhpWebServisGonderilecekAdet = vm.veriler[0].gonderilecekAdet;
                  vm.karOran = vm.veriler[0].karOran.replace(",", ".");
                  vm.kargoTutar = vm.veriler[0].kargoTutar.replace(",", ".");
                  vm.alan1Pd = vm.veriler[0].alan1;
                  vm.alan2Pd = vm.veriler[0].alan2;
                  vm.alan3Pd = vm.veriler[0].alan3;
                  vm.alan4Pd = vm.veriler[0].alan4;
                  vm.alan5Pd = vm.veriler[0].alan5;
                  vm.alan6Pd = vm.veriler[0].alan6;
                  vm.alan7Pd = vm.veriler[0].alan7;
                  vm.alan8Pd = vm.veriler[0].alan8;
                  vm.alan9Pd = vm.veriler[0].alan9;
                  vm.alan10Pd = vm.veriler[0].alan10;
                  //alert("vm.veriler[0].durumAltUrun:" +vm.veriler[0].durumAltUrun)
                  vm.kategoriOzellikleri(pazaryeri, vm.PhpWebServisKategoriId);

                  vm.PhpWebServisurunEklenmeDurumu = vm.veriler[0].durumAltUrun;
                  vm.PhpWebServisBilgilendirme = "";
                  //alert("alan10:"+vm.alan10)
                  switch (vm.veriler[0].durum) {
                    case "0":
                      vm.validatePhpWebServisListeyeEkle = false;
                      vm.validatePhpWebServisGonder = true;
                      break;
                    case "1":
                      vm.validatePhpWebServisListeyeEkle = true;
                      vm.validatePhpWebServisGonder = false;
                      break;
                    case "2":
                      vm.validatePhpWebServisListeyeEkle = true;
                      vm.validatePhpWebServisGonder = true;
                      break;
                  }

                  if (vm.PhpWebServisSatisFiyati == "0") {
                    vm.PhpWebServisSatisFiyati = vm.dSatisFiyat;
                    vm.PhpWebServisBilgilendirme =
                      "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
                  }
                  if (vm.PhpWebServisKategoriId == "") {
                    vm.PhpWebServisBilgilendirme = "Dikkat! Eşleşen Kategori Yok";
                    vm.validatePhpWebServisListeyeEkle = true;
                    vm.validatePhpWebServisGonder = true;
                  }
                  if (vm.PhpWebServisPiyasaFiyati == "0") {
                    vm.PhpWebServisPiyasaFiyati = vm.dPiyasaFiyat;
                  }
                  if (vm.PhpWebServisGonderilecekAdet == "0") {
                    vm.PhpWebServisGonderilecekAdet = vm.dStokAdet;
                  }

                  if (vm.veriler[0].alan1 != "") {
                    vm.validatedAlan1 = false;
                    const ayir = vm.veriler[0].alan1.split("*");
                    vm.alan1Ad = ayir[0];
                    vm.alan1Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan2 != "") {
                    vm.validatedAlan2 = false;
                    const ayir = vm.veriler[0].alan2.split("*");
                    vm.alan2Ad = ayir[0];
                    vm.alan2Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan3 != "") {
                    vm.validatedAlan3 = false;
                    const ayir = vm.veriler[0].alan3.split("*");
                    vm.alan3Ad = ayir[0];
                    vm.alan3Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan4 != "") {
                    vm.validatedAlan4 = false;
                    const ayir = vm.veriler[0].alan4.split("*");
                    vm.alan4Ad = ayir[0];
                    vm.alan4Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan5 != "") {
                    vm.validatedAlan5 = false;
                    const ayir = vm.veriler[0].alan5.split("*");
                    vm.alan5Ad = ayir[0];
                    vm.alan5Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan6 != "") {
                    vm.validatedAlan6 = false;
                    const ayir = vm.veriler[0].alan6.split("*");
                    vm.alan6Ad = ayir[0];
                    vm.alan6Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan7 != "") {
                    vm.validatedAlan7 = false;
                    const ayir = vm.veriler[0].alan7.split("*");
                    vm.alan7Ad = ayir[0];
                    vm.alan7Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan8 != "") {
                    vm.validatedAlan8 = false;
                    const ayir = vm.veriler[0].alan8.split("*");
                    vm.alan8Ad = ayir[0];
                    vm.alan8Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan9 != "") {
                    vm.validatedAlan9 = false;
                    const ayir = vm.veriler[0].alan9.split("*");
                    vm.alan9Ad = ayir[0];
                    vm.alan9Deger = ayir[1];
                  }

                  if (vm.veriler[0].alan10 != "") {
                    vm.validatedAlan10 = false;
                    const ayir = vm.veriler[0].alan10.split("*");
                    vm.alan10Ad = ayir[0];
                    vm.alan10Deger = ayir[1];
                  }

                  break;
              }
            } else {
              vm.trendyolBilgilendirme = "";
              vm.trendyolBilgilendirme = "Eşleşen Kategori Bulunamadı";
              vm.n11Bilgilendirme = "";
              vm.n11Bilgilendirme = "Eşleşen Kategori Bulunamadı";
              vm.pazaramaBilgilendirme = "";
              vm.pazaramaBilgilendirme = "Eşleşen Kategori Bulunamadı";
              vm.ideasoftBilgilendirme = "";
              vm.ideasoftBilgilendirme = "Eşleşen Kategori Bulunamadı";
              vm.etsyBilgilendirme = "";
              vm.etsyBilgilendirme = "Eşleşen Kategori Bulunamadı";
              vm.PhpWebServisBilgilendirme = "";
              vm.PhpWebServisBilgilendirme = "Eşleşen Kategori Bulunamadı";
              vm.hepsiburadaBilgilendirme = "";
              vm.hepsiburadaBilgilendirme = "Eşleşen Kategori Bulunamadı";
              vm.ticimaxBilgilendirme = "";
              vm.ticimaxBilgilendirme = "Eşleşen Kategori Bulunamadı";
              vm.shopifyBilgilendirme = "";
              vm.shopifyBilgilendirme = "Eşleşen Kategori Bulunamadı";
              vm.gittigidiyorBilgilendirme = "";
              vm.gittigidiyorBilgilendirme = "Eşleşen Kategori Bulunamadı";
              vm.ciceksepetiBilgilendirme = "";
              vm.ciceksepetiBilgilendirme = "Eşleşen Kategori Bulunamadı";
              vm.platinmarketBilgilendirme = "";
              vm.platinmarketBilgilendirme = "Eşleşen Kategori Bulunamadı";
              vm.WoocommerceBilgilendirme = "";
              vm.WoocommerceBilgilendirme = "Eşleşen Kategori Bulunamadı";
              vm.ikasBilgilendirme = "";
              vm.ikasBilgilendirme = "Eşleşen Kategori Bulunamadı";
              vm.ozonBilgilendirme = "";
              vm.ozonBilgilendirme = "Eşleşen Kategori Bulunamadı";
              vm.modanisaBilgilendirme = "";
              vm.modanisaBilgilendirme = "Eşleşen Kategori Bulunamadı";
              vm.akinSoftBilgilendirme = "";
              vm.akinSoftBilgilendirme = "Eşleşen Kategori Bulunamadı";
            }
          } catch (error) {
            console.log(error);
          }
        });
      });
    },
    altUrunListesi(program, stokKodu) {
      // alert(stokKodu)
      var vs = this.$vs;

      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        stokKodu: stokKodu,
        token: Store.state.tokenId,
        ekAlan: vm.alan9,
        pazaryeri: program,
      };
      console.log(args);

      soap.createClient(url, function (err, client) {
        client.altUrunListesiProgram(args, function (err, result) {
          if (result.altUrunListesiProgramResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          console.log(result);

          vm.veriler = JSON.parse(result.altUrunListesiProgramResult);

          console.log("vm.veriler : " + vm.veriler);
          switch (vm.aktifPazaryeri) {
            case "Ticimax":
              vm.ticimaxAltUrunListesi = vm.veriler;
              break;
            case "Tsoft":
              vm.tsoftAltUrunListesi = vm.veriler;
              break;
            case "Shopify":
              vm.shopifyAltUrunListesi = vm.veriler;
              break;
            case "Trendyol":
              vm.trendyolAltUrunListesi = vm.veriler;
              break;
            case "Gittigidiyor":
              vm.gittigidiyorAltUrunListesi = vm.veriler;
              break;
            case "Ciceksepeti":
              vm.ciceksepetiAltUrunListesi = vm.veriler;
              break;
            case "Ikas":
              vm.ikasAltUrunListesi = vm.veriler;
              break;
            case "Ozon":
              vm.ozonAltUrunListesi = vm.veriler;
              break;
            case "Modanisa":
              vm.modanisaAltUrunListesi = vm.veriler;
              break;

            case "Opencart":
              vm.opencartAltUrunListesi = vm.veriler;
              break;
            case "Allesgo":
              vm.allesgoAltUrunListesi = vm.veriler;
              break;
            case "AkinSoft":
              vm.akinSoftAltUrunListesi = vm.veriler;
              break;
            case "PlatinMarket":
              vm.platinmarketAltUrunListesi = vm.veriler;
              break;
            case "N11":
              //alert("aktifPazaryeri:"+vm.aktifPazaryeri)
              vm.N11AltUrunListesi = vm.veriler;
              //console.log("vm.N11AltUrunListesi :"+ vm.N11AltUrunListesi)
              break;
            case "Pazarama":
              //alert("aktifPazaryeri:"+vm.aktifPazaryeri)
              vm.pazaramaAltUrunListesi = vm.veriler;
              //console.log("vm.N11AltUrunListesi :"+ vm.N11AltUrunListesi)
              break;
            case "Ideasoft":
              //alert("aktifPazaryeri:"+vm.aktifPazaryeri)
              vm.ideasoftAltUrunListesi = vm.veriler;
              //console.log("vm.N11AltUrunListesi :"+ vm.N11AltUrunListesi)
              break;
            case "Etsy":
              //alert("aktifPazaryeri:"+vm.aktifPazaryeri)
              vm.etsyAltUrunListesi = vm.veriler;
              //console.log("vm.N11AltUrunListesi :"+ vm.N11AltUrunListesi)
              break;
            case "PhpWebServis":
              //alert("aktifPazaryeri:"+vm.aktifPazaryeri)
              vm.PhpWebServisAltUrunListesi = vm.veriler;
              //console.log("vm.N11AltUrunListesi :"+ vm.N11AltUrunListesi)
              break;
            case "Woocommerce":
              //alert("aktifPazaryeri:"+vm.aktifPazaryeri)
              vm.WoocommerceAltUrunListesi = vm.veriler;

              break;
            case "Azall":
              //alert("aktifPazaryeri:"+vm.aktifPazaryeri)
              vm.AzallAltUrunListesi = vm.veriler;
              //console.log("vm.AzallAltUrunListesi :"+ vm.AzallAltUrunListesi)
              break;
            case "Hepsiburada":
              //alert("aktifPazaryeri:"+vm.aktifPazaryeri)
              console.log(vm.veriler);
              vm.HepsiburadaAltUrunListesi = vm.veriler;

              break;
          }
        });
        //Vue.prototype.$vs = this.$vs;
      });
    },

    StringToXML(oString) {
      //code for IE
      if (window.ActiveXObject) {
        var oXML = new ActiveXObject("Microsoft.XMLDOM");
        oXML.loadXML(oString);
        return oXML;
      }
      // code for Chrome, Safari, Firefox, Opera, etc.
      else {
        return new DOMParser().parseFromString(oString, "text/xml");
      }
    },
    xml2json(xml) {
      try {
        var obj = {};

        if (xml.children.length > 0) {
          for (var i = 0; i < xml.children.length; i++) {
            var item = xml.children.item(i);
            var nodeName = item.nodeName;

            if (typeof obj[nodeName] == "undefined") {
              obj[nodeName] = this.xml2json(item);
            } else {
              if (typeof obj[nodeName].push == "undefined") {
                var old = obj[nodeName];

                obj[nodeName] = [];
                obj[nodeName].push(old);
              }
              obj[nodeName].push(this.xml2json(item));
            }
          }
        } else {
          obj = xml.textContent;
        }
        return obj;
      } catch (e) {
        console.log(e.message);
      }
    },

    pazaryeriLogo(gelen) {
      let s = [];
      try {
        s = JSON.parse(gelen);
      } catch (error) {
        var parseString = this.StringToXML(gelen);
        let deger = [];
        let olusturulan = {};
        deger = this.xml2json(parseString);
        s = deger.programlar.program;

        if (typeof s.length == "undefined") {
          s = [{ program: s.program, satisDurum: s.satisDurum }];
        }
      }

      let k = "";
      let logo = "";
      let array = [];
      if (typeof s != "undefined")
        s.forEach((element) => {
          array.push({
            program: element.program,
            satisDurum: element.satisDurum,
          });
        });

      // k = element.program + " / " +  element.gonderilecekFiyat + " / " +  element.gonderilecekAdet + " - " +   k;
      return array;
    },
    findPazaryeri(gelen) {
      try {
        if (gelen.program.trim() == "Gittigidiyor") {
          return require("../../assets/images/logo/gittigidiyor50px.png");
        } else if (gelen.program.trim() == "N11") {
          return require("../../assets/images/logo/n11png50px.png");
        } else if (gelen.program.trim() == "Ciceksepeti") {
          return require("../../assets/images/logo/ciceksepeti50px.png");
        } else if (gelen.program.trim() == "Trendyol") {
          return require("../../assets/images/logo/trendyol-logo50px.png");
        } else if (gelen.program.trim() == "PttAvm") {
          return require("../../assets/images/logo/pttavm50px.png");
        } else if (gelen.program.trim() == "Hepsiburada") {
          return require("../../assets/images/logo/hepsiburada-logo-1024jpg50px.png");
        } else if (gelen.program.trim() == "Ideasoft") {
          return require("../../assets/images/logo/ideasoft50px.png");
        } else if (gelen.program.trim() == "Ticimax") {
          //    console.log("in")
          return require("../../assets/images/logo/tticimax50px.png");
        } else if (gelen.program.trim() == "Woocommerce") {
          return require("../../assets/images/logo/WooCommerce_logo50px.png");
        } else if (gelen.program.trim() == "Tsoft") {
          return require("../../assets/images/logo/tsoft_logo50px.png");
        } else if (gelen.program.trim() == "Shopify") {
          return require("../../assets/images/logo/Logo-della-Shopify50px.png");
        } else if (gelen.program.trim() == "Modanisa") {
          return require("../../assets/images/logo/mosanisa50px.png");
        } else if (gelen.program.trim() == "Ikas") {
          return require("../../assets/images/logo/ikas50px.jpg");
        } else if (gelen.program.trim() == "Ozon") {
          return require("../../assets/images/logo/ozon50px.png");
        } else if (gelen.program.trim() == "Pazarama") {
          return require("../../assets/images/logo/tr-pazarama.png");
        } else if (gelen.program.trim() == "PhpWebServis") {
          return require("../../assets/images/logo/PHP-tr.png");
        } else if (gelen.program.trim() == "Etsy") {
          return require("../../assets/images/logo/etsy50px.png");
        }
        /*    if (gelen.satisDurum == "Pasif") {
          return "red";
        } else if (gelen.program == "Gönderilmemiş") {
          return "black";
        } else {
          return "green";
        }*/
      } catch (error) {
        console.log(gelen);
      }
    },

    PazarYeriConvert(gelen) {
      //  console.log(gelen)
      let s = JSON.parse(gelen);
      let k = "";
      s.forEach((element) => {
        k = element.program + " - " + k;
      });

      // k = element.program + " / " +  element.gonderilecekFiyat + " / " +  element.gonderilecekAdet + " - " +   k;
      return k;
    },
    stokListesi() {
      var sonkayitcurrentGelenPage = this.currentGelenPage - 1;
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.Durum === true) {
        vm.AktifPazarYeriTanim = ' and Pazaryeri != \'[{"program":"Gönderilmemis"}]\' ';
      } else {
        vm.AktifPazarYeriTanim = "";
      }

      const args = {
        token: Store.state.tokenId,
        kod: vm.barkod,
        AktifPazarYeriTanim: vm.AktifPazarYeriTanim,
        pageSize: vm.pageLength,
        page: vm.searching != "" ? 1 : vm.currentPage,
      };
      //  console.log(args)

      soap.createClient(url, function (err, client) {
        client.stokListesi(args, function (err, result) {
          if (result.stokListesiResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          console.log(result);

          vm.veriler = JSON.parse(result.stokListesiResult);
          console.log(vm.veriler);
          // vm.liste = vm.veriler;
          vm.liste = vm.veriler;
          //  console.log(vm.liste.length)
          vm.KAYITSAYISI = vm.liste.length;
          //   console.log(vm.liste);
        });
      });
    },
    resimUpdate() {
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
      };
      soap.createClient(url, function (err, client) {
        client.resimUpdate(args, function (err, result) {
          return result.resimUpdateResult;
        });
      });
    },
    /*
    stokListesi() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = { token: Store.state.tokenId, kod: vm.barkod };
      soap.createClient(url, function(err, client) {
        client.stokListesi(args, function(err, result) {
          if (result.stokListesiResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.stokListesiResult);
          vm.liste = vm.veriler;
        });
      });
    }*/
    kartDetay(kod) {
      this.imageBase64 = "";
      this.active_tab = 0;
      this.dStokAdi = "";
      this.dStokKodu = "";
      this.dBarkod = "";
      this.dRenk = "";
      this.dBeden = "";
      this.dDigerOzellikler = "";
      this.dDigerOzelliklerListe = "";
      this.dKategori = "";
      this.dSatisFiyat = 0;
      this.dPiyasaFiyat = 0;
      this.dStokAdet = 0;
      this.dKdv = 0;
      this.dTedarikci = "";
      this.dMarka = "";
      this.dParaBirim = "";
      this.dEklenmeDurumu = "";
      this.trendyolKategori = "";
      this.trendyolKategoriId = 0;
      this.trendyolSatisFiyati = 0;
      this.trendyolPiyasaFiyati = 0;
      this.trendyolGonderilecekAdet = 0;
      this.trendyolBilgilendirme = "";
      this.n11Kategori = "";
      this.n11KategoriId = 0;
      this.n11SatisFiyati = 0;
      this.n11PiyasaFiyati = 0;
      this.n11GonderilecekAdet = 0;
      this.n11Bilgilendirme = "";
      this.pazaramaBilgilendirme = "";
      this.pazaramaKategori = "";
      this.pazaramaKategoriId = 0;
      this.pazaramaSatisFiyati = 0;
      this.pazaramaPiyasaFiyati = 0;
      this.pazaramaGonderilecekAdet = 0;

      this.ideasoftBilgilendirme = "";
      this.ideasoftKategori = "";
      this.ideasoftKategoriId = 0;
      this.ideasoftSatisFiyati = 0;
      this.ideasoftPiyasaFiyati = 0;
      this.ideasoftGonderilecekAdet = 0;

      this.etsyBilgilendirme = "";
      this.etsyKategori = "";
      this.etsyKategoriId = 0;
      this.etsySatisFiyati = 0;
      this.etsyPiyasaFiyati = 0;
      this.etsyGonderilecekAdet = 0;

      this.PhpWebServisBilgilendirme = "";
      this.PhpWebServisKategori = "";
      this.PhpWebServisKategoriId = 0;
      this.PhpWebServisSatisFiyati = 0;
      this.PhpWebServisPiyasaFiyati = 0;
      this.PhpWebServisGonderilecekAdet = 0;
      this.hepsiburadaKategori = "";
      this.hepsiburadaKategoriId = 0;
      this.hepsiburadaSatisFiyati = 0;
      this.hepsiburadaPiyasaFiyati = 0;
      this.hepsiburadaGonderilecekAdet = 0;
      this.hepsiburadaBilgilendirme = "";
      this.ticimaxKategori = "";
      this.ticimaxKategoriId = 0;
      this.ticimaxSatisFiyati = 0;
      this.ticimaxPiyasaFiyati = 0;
      this.ticimaxGonderilecekAdet = 0;
      this.ticimaxBilgilendirme = "";
      this.alan1 = "";
      this.alan2 = "";
      this.alan3 = "";
      this.alan4 = "";
      this.alan5 = "";
      this.alan6 = "";
      this.alan7 = "";
      this.alan8 = "";
      this.alan9 = "";
      this.alan10 = "";
      this.alan1Pd = "";
      this.alan2Pd = "";
      this.alan3Pd = "";
      this.alan4Pd = "";
      this.alan5Pd = "";
      this.alan6Pd = "";
      this.alan7Pd = "";
      this.alan8Pd = "";
      this.alan9Pd = "";
      this.alan10Pd = "";
      this.validatedAlan1 = true;
      this.validatedAlan2 = true;
      this.validatedAlan3 = true;
      this.validatedAlan4 = true;
      this.validatedAlan5 = true;
      this.validatedAlan6 = true;
      this.validatedAlan7 = true;
      this.validatedAlan8 = true;
      this.validatedAlan9 = true;
      this.validatedAlan10 = true;
      this.alan1Ad = "";
      this.alan2Ad = "";
      this.alan3Ad = "";
      this.alan4Ad = "";
      this.alan5Ad = "";
      this.alan6Ad = "";
      this.alan7Ad = "";
      this.alan8Ad = "";
      this.alan9Ad = "";
      this.alan10Ad = "";
      this.alan1Deger = "";
      this.alan2Deger = "";
      this.alan3Deger = "";
      this.alan4Deger = "";
      this.alan5Deger = "";
      this.alan6Deger = "";
      this.alan7Deger = "";
      this.alan8Deger = "";
      this.alan9Deger = "";
      this.alan10Deger = "";
      this.stokAciklama = "";
      this.stokAciklamaYeni = "";
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      // alert(kod)
      //   console.log(kod)

      const args = {
        token: Store.state.tokenId,
        kod: kod,
        barkod: kod,
        AktifPazarYeriTanim: "",
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.stokListesi(args, function (err, result) {
          if (result.stokListesiResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.verilerDetay = JSON.parse(result.stokListesiResult);
            console.log(vm.verilerDetay);
            vm.dStokAdi = vm.verilerDetay[0].StokAdi;
            vm.dStokKodu = vm.verilerDetay[0].stokKodu;
            //alert("vm.dStokKodu : " + vm.dStokKodu)
            vm.dBarkod = vm.verilerDetay[0].Barkod;
            //vm.dDetay=vm.veriler[0].detay
            vm.dRenk = vm.verilerDetay[0].renk;
            vm.dBeden = vm.verilerDetay[0].beden;
            vm.StokKartDetayOzellikleri = vm.dStokAdi + "-" + vm.dRenk + "-" + vm.dBeden;
            vm.dKategori =
              vm.verilerDetay[0].kategori1 +
              " -> " +
              vm.verilerDetay[0].kategori2 +
              " ->" +
              vm.verilerDetay[0].kategori3;
            vm.pazaryeriKategoriId = vm.verilerDetay[0].KategoriId;
            vm.dSatisFiyat = vm.verilerDetay[0].SATIS_FIAT1;
            vm.dPiyasaFiyat = vm.verilerDetay[0].LISTE_FIAT;
            vm.dStokAdet = vm.verilerDetay[0].stokAdet;
            vm.dKdv = vm.verilerDetay[0].kdv;
            vm.ortakKod = vm.verilerDetay[0].ortakKod;
            vm.ortakKodPn = vm.verilerDetay[0].ortakKod;
            vm.ortakKodSayi = vm.verilerDetay[0].alan5;
            vm.alan1 = vm.verilerDetay[0].alan1;
            vm.alan2 = vm.verilerDetay[0].alan2;
            vm.alan3 = vm.verilerDetay[0].alan3;
            vm.alan4 = vm.verilerDetay[0].alan4;
            vm.alan5 = vm.verilerDetay[0].alan5;
            vm.alan6 = vm.verilerDetay[0].alan6;
            vm.alan7 = vm.verilerDetay[0].alan7;
            vm.alan8 = vm.verilerDetay[0].alan8;
            vm.alan9 = vm.verilerDetay[0].alan9;
            vm.alan10 = vm.verilerDetay[0].alan10;
            vm.N11KatalogId = vm.verilerDetay[0].N11KatalogId;
            vm.GGKatalogId = vm.verilerDetay[0].GGKatalogId;
            vm.HBKatalogId = vm.verilerDetay[0].HBKatalogId;
            vm.dTedarikci = vm.verilerDetay[0].tedarikci;
            vm.dMarka = vm.verilerDetay[0].marka;
            vm.dParaBirim = vm.verilerDetay[0].dParaBirim;
            vm.dEklenmeDurumu = vm.verilerDetay[0].eklenmeDurumu;

            if (vm.verilerDetay[0].gonderilenDetay != "") {
              vm.stokAciklama = vm.verilerDetay[0].gonderilenDetay;
            } else {
              vm.stokAciklama = vm.verilerDetay[0].detay;
            }
            vm.stokAciklama = vm.verilerDetay[0].detay;

            vm.dDigerOzellikler = "";
            vm.dDigerOzelliklerListe = "";
            if (
              vm.verilerDetay[0].alan1 != null &&
              vm.verilerDetay[0].alan1 != "" &&
              vm.verilerDetay[0].alan1 != "null"
            ) {
              if (vm.verilerDetay[0].alan1.toString().includes("*")) {
                vm.dDigerOzellikler =
                  vm.dDigerOzellikler + vm.verilerDetay[0].alan1 + ",";
                vm.dDigerOzelliklerListe =
                  vm.dDigerOzelliklerListe +
                  vm.verilerDetay[0].alan1.replace("*", "=") +
                  "<br/>";
              }
            }
            if (vm.verilerDetay[0].alan2 != "" && vm.verilerDetay[0].alan2 != "null") {
              if (vm.verilerDetay[0].alan2.toString().includes("*")) {
                vm.dDigerOzellikler =
                  vm.dDigerOzellikler + vm.verilerDetay[0].alan2 + ",";
                vm.dDigerOzelliklerListe =
                  vm.dDigerOzelliklerListe +
                  vm.verilerDetay[0].alan2.replace("*", "=") +
                  "<br/>";
              }
            }
            if (vm.verilerDetay[0].alan3 != "" && vm.verilerDetay[0].alan3 != "null") {
              if (vm.verilerDetay[0].alan3.toString().includes("*")) {
                vm.dDigerOzellikler =
                  vm.dDigerOzellikler + vm.verilerDetay[0].alan3 + ",";
                vm.dDigerOzelliklerListe =
                  vm.dDigerOzelliklerListe +
                  vm.verilerDetay[0].alan3.replace("*", "=") +
                  "<br/>";
              }
            }
            if (vm.verilerDetay[0].alan4 != "" && vm.verilerDetay[0].alan4 != "null") {
              if (vm.verilerDetay[0].alan4.toString().includes("*")) {
                vm.dDigerOzellikler =
                  vm.dDigerOzellikler + vm.verilerDetay[0].alan4 + ",";
                vm.dDigerOzelliklerListe =
                  vm.dDigerOzelliklerListe +
                  vm.verilerDetay[0].alan4.replace("*", "=") +
                  "<br/>";
              }
            }
            if (vm.verilerDetay[0].alan5 != "" && vm.verilerDetay[0].alan5 != "null") {
              if (vm.verilerDetay[0].alan5.toString().includes("*")) {
                vm.dDigerOzellikler =
                  vm.dDigerOzellikler + vm.verilerDetay[0].alan5 + ",";

                vm.dDigerOzelliklerListe =
                  vm.dDigerOzelliklerListe +
                  vm.verilerDetay[0].alan5.replace("*", "=") +
                  "<br/>";
              }
            }
            if (vm.verilerDetay[0].alan6 != "" && vm.verilerDetay[0].alan6 != "null") {
              if (vm.verilerDetay[0].alan6.toString().includes("*")) {
                vm.dDigerOzellikler =
                  vm.dDigerOzellikler + vm.verilerDetay[0].alan6 + ",";
                vm.dDigerOzelliklerListe =
                  vm.dDigerOzelliklerListe +
                  vm.verilerDetay[0].alan6.replace("*", "=") +
                  "<br/>";
              }
            }
            if (vm.verilerDetay[0].alan7 != "" && vm.verilerDetay[0].alan7 != "null") {
              if (vm.verilerDetay[0].alan7.toString().includes("*")) {
                vm.dDigerOzellikler =
                  vm.dDigerOzellikler + vm.verilerDetay[0].alan7 + ",";
                vm.dDigerOzelliklerListe =
                  vm.dDigerOzelliklerListe +
                  vm.verilerDetay[0].alan7.replace("*", "=") +
                  "<br/>";
              }
            }
            if (vm.verilerDetay[0].alan8 != "" && vm.verilerDetay[0].alan8 != "null") {
              if (vm.verilerDetay[0].alan8.toString().includes("*")) {
                vm.dDigerOzellikler =
                  vm.dDigerOzellikler + vm.verilerDetay[0].alan8 + ",";
                vm.dDigerOzelliklerListe =
                  vm.dDigerOzelliklerListe +
                  vm.verilerDetay[0].alan8.replace("*", "=") +
                  "<br/>";
              }
            }
            if (vm.verilerDetay[0].alan9 != "" && vm.verilerDetay[0].alan9 != "null") {
              if (vm.verilerDetay[0].alan9.toString().includes("*")) {
                vm.dDigerOzellikler =
                  vm.dDigerOzellikler + vm.verilerDetay[0].alan9 + ",";
                vm.dDigerOzelliklerListe =
                  vm.dDigerOzelliklerListe +
                  vm.verilerDetay[0].alan9.replace("*", "=") +
                  "<br/>";
              }
            }
            if (vm.verilerDetay[0].alan10 != "" && vm.verilerDetay[0].alan10 != "null") {
              if (vm.verilerDetay[0].alan10.toString().includes("*")) {
                vm.dDigerOzellikler =
                  vm.dDigerOzellikler + vm.verilerDetay[0].alan10 + ",";
                vm.dDigerOzelliklerListe =
                  vm.dDigerOzelliklerListe +
                  vm.verilerDetay[0].alan10.replace("*", "=") +
                  "<br/>";
                vm.alan10 = vm.verilerDetay[0].alan10;
              }
            }

            vm.popupKartDetay = true;
          } catch (error) {
            console.log(error);
            console.log(result);
          }
        });
      });
    },
  },
  watch: {
    list: {
      handler: function () {
        //this.toplamParca=this.list.reduce((acc, item) => Number(acc) + (Number(item.siparisAdetleri)), 0)
      },
      deep: true,
    },
  },
  beforeMount() {
    this.stokListesi();
  },
};
</script>
<style lang="scss">
.vs-card--content {
  font-size: 13px;
}

#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

[dir] .autosuggest__results .autosuggest__results-item {
  padding: 7px !important;
}

[dir] .card-text:last-child {
  color: black;
  font-weight: 500;
}

.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
  max-height: 200px;
  overflow-y: scroll;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results-item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1) > .autosuggest__results-before {
  border-top: none;
}

.autosuggest__results .autosuggest__results-before {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results .autosuggest__results-item.autosuggest__results-item--highlighted {
  background-color: #f6f6f6;
}

.con-vs-dialog {
  z-index: 520055;
}

.VGT-row:hover {
  background-color: rgb(219, 219, 250);
}

table.vgt-table {
  font-size: 13px;
}

[dir] .vgt-table.bordered td,
[dir] .vgt-table.bordered th {
  text-align: center;
}

.btn-group button {
  padding: 0rem !important;
}

.blue {
  color: blue;
}

.green {
  color: green;
}

.red {
  color: red;
}

.black {
  color: black;
}

td {
  font-size: 11px !important;
}

.mb-base {
  margin-bottom: 0.75rem !important;
}

.list-view-item {
  .item-name,
  .item-description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .item-name {
    -webkit-line-clamp: 2;
  }

  .item-description {
    -webkit-line-clamp: 5;
  }

  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: 0.35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

    .grid-view-img {
      opacity: 0.9;
    }
  }
}
</style>
"
